/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Ответ на запрос PDF документа
 */
export interface PdfResponse {
  /** PDF файл */
  pdf: string;
}

/**
 * Ответ на запрос добавления сертификата УКЭП
 */
export interface CertQualifiedResponse {
  /** Валидность сертификата */
  result?: boolean;

  /** Дополнительная информация, описание возможных ошибок */
  message?: string;

  /** Субъект сертификата */
  subjectName?: string;

  /** Издатель сертификата */
  issuerName?: string;

  /**
   * Время начала действия сертификата
   * @format date-time
   */
  notBefore?: string;

  /**
   * Срок действия сертификата
   * @format date-time
   */
  notAfter?: string;

  /** Серийный номер сертификата */
  serialNumber?: string;
}

/**
 * Запрос на добавление сертификата УКЭП
 */
export interface CertQualifiedRequest {
  /** Данные сертификата */
  data: string;

  /**
   * Идентификатор клиента
   * @format int64
   */
  clientId: number;
}

/**
 * Ответ на запрос активных валютных операций
 */
export interface VedOperCodesResponse {
  /**
   * Идентификатор операции
   * @format int64
   */
  id: number;

  /** Код операции */
  code?: string;

  /** Описание операции */
  description?: string;
}

/**
 * Ответ на запрос получения распоряжений по транзитному счету
 */
export interface TransitAccountResponse {
  /**
   * Признак того, что мы получили не все данные.
   *
   */
  hasMore: boolean;

  /**
   * Список распоряжений по транзитному счету
   *
   */
  data: TransitAccountResponseData[];
}

/**
 * Распоряжение по транзитному счету.
 */
export interface TransitAccountResponseData {
  /**
   * ID документа.
   *
   * @format int64
   */
  id: number;

  /**
   * Счет в другом банке.
   *
   */
  accCurClient?: string;

  /**
   * Счет в другом банке.
   *
   */
  accCurSaleClient?: string;

  /**
   * Рублевый счет.
   *
   */
  accRubSaleClient?: string;

  /**
   * Общая сумма поступлений.
   *
   */
  allSum?: number;

  /**
   * БИК банка.
   *
   */
  bankBIC?: string;

  /**
   * Наименование банка.
   *
   */
  bankName?: string;

  /**
   * Счет зачисления.
   *
   */
  clientAccExt?: string;

  /**
   * Валюта суммы поступления.
   *
   */
  currCode?: string;

  /**
   * Код валюты общей суммы поступлений клиента.
   *
   */
  currCodeISO?: string;

  /**
   * Дата документа.
   *
   * @format date
   */
  documentDate?: string;

  /**
   * Номер документа.
   *
   */
  documentNumber?: string;

  /**
   * Дата уведомления.
   *
   * @format date
   */
  noticDate?: string;

  /**
   * Номер уведомления.
   *
   */
  noticNum?: string;

  /**
   * Состояние документа.
   *
   */
  state?: string;

  /**
   * Сумма продажи.
   *
   */
  sumSale?: number;

  /**
   * Сумма перевода.
   *
   */
  sumSale2?: number;

  /**
   * Идентификатор документа отзыва
   *
   */
  revokeId?: string;
  permissions?: EntityPermission[];
}

/**
 * Ответ на запрос списка зачислений.
 */
export interface VedEnrollmentResponse {
  /**
   * дописать
   *
   */
  hasMore: boolean;

  /** @format int64 */
  total?: number;

  /** @format int64 */
  pages?: number;

  /**
   * Данные на запрос списка зачислений
   *
   */
  data: VedEnrollmentResponseData[];
}

/**
 * Ответ на запрос списка зачислений
 */
export interface VedEnrollmentResponseData {
  /**
   * ID документа.
   *
   */
  id: string;

  /**
   * Номер транзитного банковского счета резидента, на который зачислены средства в иностранной валюте.
   *
   */
  trAcc?: string;

  /**
   * Id транзитного банковского счета резидента, на который зачислены средства в иностранной валюте.
   *
   * @format int64
   */
  trAccId?: number;

  /**
   * Сумма средств в иностранной валюте.
   *
   */
  sum?: number;

  /**
   * Буквенный код поступившей валюты.
   *
   */
  curCode?: string;

  /**
   * Тип валютных уведомлений.
   *
   */
  curNotifyType?: string;

  /**
   * Дата документа.
   *
   * @format date
   */
  documentDate?: string;

  /**
   * Номер документа
   *
   */
  documentNumber?: string;

  /**
   * Дата поступления валюты на транзитный счет.
   *
   * @format date
   */
  recDate?: string;

  /**
   * Состояние документа.
   *
   */
  state?: string;

  /**
   * Статус валютного контроля
   *
   */
  currControlState?: string;

  /**
   * Признак просрочености документа
   *
   */
  isExpired?: boolean;
}

/**
 * Ответ на запрос списка Бенефициаров.
 */
export interface VedBeneficiaryResponse {
  /**
   * Признак того, имеются ли еще записи
   *
   */
  hasMore: boolean;

  /**
   * Строк всего
   *
   * @format int64
   */
  total?: number;

  /**
   * Страниц всего
   *
   * @format int64
   */
  pages?: number;

  /**
   * Данные на запрос списка бенефициаров
   *
   */
  data: VedBeneficiaryResponseData[];
}

/**
 * Ответ на запрос выбора бенефициара из списка.
 */
export interface VedBeneficiaryResponseData {
  /**
   * id бенефициара
   * @format int64
   */
  id: number;

  /** Международное наименование бенефициара */
  nameInt?: string;

  /** инн */
  inn?: string;

  /** Счет бенефициара */
  account?: string;

  /** Страна бенефициара */
  country?: string;

  /** Город бенефициара */
  city?: string;

  /** SWIFT-код банка бенефициара */
  swiftCode?: string;

  /** Наименование банка бенефициара */
  beneficiaryBankName?: string;

  /** Страна банка бенефициара */
  beneficiaryBankCountry?: string;

  /** Город банка бенефициара */
  beneficiaryBankCity?: string;
}

/**
 * Ответ на запрос выбора бенефициара из списка.
 */
export interface VedBeneficiaryResponseFull {
  /**
   * id бенефициара
   * @format int64
   */
  id: number;

  /** Счет или IBAN */
  account?: string;

  /** Адрес */
  address?: string;

  /** Адрес */
  addressInt?: string;

  /** Банк */
  bank?: IdPlusNameWrapper;

  /** Счет банка */
  bankAccount?: string;

  /** Счета банка бенефициара в банке-посреднике */
  bankAgentAccount?: string;

  /** Адрес банка бенефициара */
  bankAddress?: string;

  /** Банк посредник */
  bankAgent?: IdPlusNameWrapper;

  /** Адрес банка посредника */
  bankAgentAddress?: string;

  /** Город банка посредника */
  bankAgentCity?: string;

  /** Страна банка посредника */
  bankAgentCountry?: IdPlusNameWrapper;

  /** Код страны банка посредника */
  bankAgentCountryCode?: string;

  /** Клиринговый код банка посредника */
  bankAgentClearingCode?: string;

  /** Наименование банка посредника */
  bankAgentName?: string;

  /** БИК/SWIFT банка  посредника */
  bankAgentSwift?: string;

  /** БИК банка */
  bankBic?: string;

  /** Город Банка бенефициара */
  bankCity?: string;

  /** Страна банка */
  bankCountry?: IdPlusNameWrapper;

  /** Код страны банка бенефициара */
  bankCountryCode?: string;

  /** Наименование банка бенефициара */
  bankName?: string;

  /** SWIFT банка бенефициара */
  bankSWIFT?: string;

  /** Тип бенефициара */
  beneficiarType?: string;

  /** Город */
  city?: string;

  /** Клиринговый код банка бенефициара */
  clearingCode?: string;

  /** Клиент */
  client?: IdPlusNameWrapper;

  /** Код страны бенефициара */
  country?: IdPlusNameWrapper;

  /** Валюта счета */
  currency?: IdPlusNameWrapper;

  /** Идентификатор из внешней системы */
  dbold?: string;

  /** Описание */
  desc?: string;

  /** ИНН (КИО) */
  inn?: string;

  /** КПП */
  kpp?: string;

  /** Наименование */
  name?: string;

  /** Международное наименование бенефициара */
  nameInt?: string;

  /** Номер телефона */
  phoneNumber?: string;
}

/**
 * Запрос на сохранение распоряжения на транзитный счет
 */
export interface DocObSaleCurrReq {
  /**
   * ИД отвественного лица
   * @format int64
   */
  clientContId?: number;

  /** Номер телефона ответсвенного лица */
  clientContPhone?: string;

  /** имя отвественного лица */
  clientContName?: string;

  /** Номер транзитного счета уведомления */
  clientAccNum?: string;

  /**
   * ИД транзитного счета уведомления
   * @format int64
   */
  clientAccId?: number;

  /**
   * ИД уведомления зачисления
   * @format int64
   */
  noticId?: number;

  /** ИД уведомления зачисления из МС */
  msNoticId?: string;

  /**
   * Дата уведомления
   * @format date-time
   */
  noticDate?: string;

  /** Номер уведомления */
  noticNum?: string;

  /** Валюта */
  currCodeISO?: string;

  /** Сумма уведомления */
  allSum?: number;

  /** номер счета в нашем банке */
  accRubSaleClient?: string;

  /**
   * ИД счета в нашем банке
   * @format int64
   */
  accRubSaleClientId?: number;

  /** сумма продажи в нашем банке */
  sumSale?: number;

  /** БИК банка */
  bankBIC?: string;

  /** счет зачисления в другом банке */
  clientAccExt?: string;

  /** счет зачисления в иностранной валюте */
  accCurSaleClient?: string;

  /**
   * ИД счета зачисления в иностранной валюте
   * @format int64
   */
  accCurSaleClientId?: number;

  /** сумма зачисления */
  sumSale2?: number;

  /**
   * Дата поступления
   * @format date-time
   */
  dateAllSum?: string;

  /** Информация об операции для валютного контроля */
  operVKInfo?: OperVKInfo[];

  /** Список вложений */
  attachments?: AttachmentRequest[];

  /** Идентификаторы удаленных вложений */
  "removed-files"?: number[];
}

export interface OperVKInfo {
  /**
   * Идентификатор
   * @format int64
   */
  id?: number;

  /** сумма */
  sum?: number;

  /** Код операции */
  curOperKindCodeStr?: string;

  /** номер контракта */
  uniqContractNumber?: string;

  /** Номер договора */
  contractNumber?: string;

  /**
   * Дата договора
   * @format date
   */
  contractDate?: string;

  /** Код валюты */
  currencyISO?: string;

  /** Номер контракта */
  contractid?: string;

  /** Код валюты контракта */
  contractCurrencyISO?: string;

  /** Сумма контракта */
  contractCurrencySum?: number;
}

/**
 * Ответ для распоряжения по транзитному счету
 */
export interface DocObSaleCurrResponse {
  /**
   * ИД документа
   * @format int64
   */
  id?: number;

  /** Номер документа */
  documentNumber?: string;

  /**
   * Дата документа
   * @format date
   */
  documentDate?: string;

  /**
   * Статус документа
   *
   */
  documentState?: string;

  /**
   * Описание статуса документа
   *
   */
  documentStateDesc?: string;

  /** ИНН клиента */
  clientINN?: string;

  /** ОКПО клиента */
  clientOKPO?: string;

  /** ОГРН клиента */
  clientOGRN?: string;

  /** Имя клиента */
  clientName?: string;

  /**
   * ИД ответсвенного лица
   * @format int64
   */
  clientContId?: number;

  /** Имя ответственного по сделке */
  clientContName?: string;

  /** Номер телефона ответсвенного по сделке */
  clientContPhone?: string;

  /**
   * ИД транзитного счета уведомления
   * @format int64
   */
  clientAccId?: number;

  /** ИД уведомления зачисления из МС */
  msNoticId?: string;

  /**
   * ИД уведомления зачисления
   * @format int64
   */
  noticId?: number;

  /** номер уведомления */
  noticNumber?: string;

  /**
   * Дата уведомления
   * @format date
   */
  noticDate?: string;

  /** Сумма поступления */
  allSum?: number;

  /** Транзитный счет */
  clientAccNum?: string;

  /** Валюта суммы поступления */
  currCodeISO?: string;

  /**
   * Дата суммы поступления
   * @format date
   */
  dateAllSum?: string;

  /** Cумма продажи */
  sumSale?: number;

  /** Валюта суммы продажи */
  sumSaleCurr?: string;

  /** Счет зачисления в нашем банке */
  accRubSaleClient?: string;

  /**
   * ИД счета в нашем банке
   * @format int64
   */
  accRubSaleClientId?: number;

  /** Код валютной операции */
  operkindcode?: string;

  /** Счет зачисления */
  clientAccExt?: string;

  /** Имя банка */
  bankName?: string;

  /** Корр. счет банка */
  bankCorrAcc?: string;

  /** БИК банка */
  bankBIC?: string;

  /** Сумма перевода на наш счет в иностранной валюте */
  sumSale2?: number;

  /** Счет зачисления в иностранной валюте */
  accCurSaleClient?: string;

  /**
   * ИД счета зачисления в иностранной валюте
   * @format int64
   */
  accCurSaleClientId?: number;

  /** Валюта суммы перевода */
  sumSale2CurrISO?: string;

  /**
   * Идентификатор документа отзыва
   *
   */
  revokeId?: string;

  /** Информация об операции для валютного контроля */
  operVKInfo?: OperVKInfo[];
  attachments?: AttachmentInfo[];
  permissions?: EntityPermission[];

  /**
   * Данные о доступных операциях с документе
   *
   */
  validationErrors?: ValidationResponse;
}

/**
 * Параметры запроса авторизации
 */
export interface LoginRequest {
  /**
   * UUID ИКЮЛ приложения '200709111834312030012-f01e3b1adaa54d9c'
   *
   */
  applicationUuid: string;

  /**
   * Код языка интерфейса приложения
   *
   */
  languageCode?: string;

  /**
   * Рандомная строка
   *
   */
  uniqueness?: string;

  /**
   * Идентификатор клиентской сессии, сформированной по алгоритму ГОСТ 34.11-94
   *
   */
  clientSessionId: string;

  /**
   * strId алгоритма авториации
   *
   */
  authMethod: string;

  /**
   * Логин
   *
   */
  login: string;

  /**
   * Пароль
   *
   */
  password: string;

  /**
   * IP-адрес клиента
   *
   */
  ipAddress?: string;

  /**
   * MAC-адрес клиента
   *
   */
  macAddress?: string;

  /**
   * Тайм-зона клиента
   *
   */
  timeZone?: string;

  /**
   * Набор случайных данных, сгенеренных и подписанных на фронте (для аутентификации по ЭП)
   *
   * @format base64
   */
  randomData?: string;

  /**
   * Канал:
   * IC - Интернет клиент
   * MB - Мобильный банк
   *
   */
  channel: string;

  /**
   * Отпечаток устройства клиента. Передается в base64
   *
   */
  deviceFingerPrint?: string;

  /**
   * Признак использования кнопки "По смс" на странице авторизации
   *
   */
  isSMSMode?: boolean;

  /**
   * Данные об iOS устройстве
   *
   */
  iOSDevice?: IOSDeviceInfo;

  /**
   * Данные об Android устройстве
   *
   */
  androidDevice?: AndroidDeviceInfo;

  /**
   * Данные о ПК пользователя
   *
   */
  userDevice?: UserDeviceInfo;

  /**
   * SMS пароль
   *
   */
  smsPassword?: string;
}

/**
 * Запрос процесса начала авторизации с помощью PayControl 5.3.
 */
export interface PC53LoginStartRequest {
  /**
   * Идентификатор пользователя в PayControl
   *
   */
  payControlUserId: string;

  /**
   * Отпечаток устройства PayControl
   *
   */
  fingerPrint: string;
}

/**
 * Запрос процесса окончания авторизации с помощью PayControl 5.3.
 */
export interface PC53LoginFinishRequest {
  /**
   * UUID ИКЮЛ приложения '200709111834312030012-f01e3b1adaa54d9c'
   *
   */
  applicationUuid: string;

  /**
   * Идентификатор пользователя в PayControl
   *
   */
  payControlUserId: string;

  /**
   * Отпечаток устройства PayControl
   *
   */
  fingerPrint: string;

  /**
   * Идентификатор транзакции
   *
   */
  transactionId: string;

  /**
   * Канал:
   * IC - Интернет клиент
   * MB - Мобильный банк
   *
   */
  channel?: string;

  /**
   * Код языка интерфейса приложения
   *
   */
  languageCode?: string;

  /**
   * IP-адрес клиента
   *
   */
  ipAddress?: string;

  /**
   * MAC-адрес клиента
   *
   */
  macAddress?: string;

  /**
   * Тайм-зона клиента
   *
   */
  timeZone?: string;

  /**
   * Данные об iOS устройстве
   *
   */
  iOSDevice?: IOSDeviceInfo;

  /**
   * Данные об Android устройстве
   *
   */
  androidDevice?: AndroidDeviceInfo;

  /**
   * Данные о ПК пользователя
   *
   */
  userDevice?: UserDeviceInfo;
}

/**
 * Данные об iOS устройстве
 */
export interface IOSDeviceInfo {
  /**
   * Идентификатор устройства
   *
   */
  identifierForVendor?: string;

  /**
   * Название и версия ОС ("iOS 10.1.0")
   *
   */
  osNameVersion?: string;

  /**
   * Модель устройства ("iPhone 4G")
   *
   */
  model?: string;
}

/**
 * Данные об Android устройстве
 */
export interface AndroidDeviceInfo {
  /**
   * Идентификатор International Mobile Subscriber Identity ("250-07-9990000000")
   *
   */
  imsi?: string;

  /**
   * Идентификатор International Mobile Equipment Identity ("35-209900-176148-1")
   *
   */
  imei?: string;

  /**
   * Идентификатор IMEI Software Version ("35-209900-176148-23")
   *
   */
  imeisv?: string;

  /**
   * Mobile Subscriber Integrated Services Digital Number ("7-903-1234567")
   *
   */
  msisdn?: string;

  /**
   * Наименование оператора сотовой связи ("Мегафон")
   *
   */
  spn?: string;

  /**
   * Версия операционной системы ("8.0")
   *
   */
  osVersion?: string;

  /**
   * Модель устройства ("Nexus 5", "GT-I9192I")
   *
   */
  model?: string;
}

/**
 * Данные о ПК пользователя
 */
export interface UserDeviceInfo {
  /**
   * Операционная система пользователя
   *
   */
  OS?: string;

  /**
   * Браузер с которого осуществляется вход
   *
   */
  browser?: string;

  /**
   * Версия плагина JaCarta
   *
   */
  JaCarta?: string;

  /**
   * Версия плагина CryptoPro
   *
   */
  CryptoPro?: string;
}

/**
 * Ответ на запрос авторизации
 */
export interface LoginResponse {
  /**
   * jwt токен
   *
   */
  jwt?: string;

  /**
   * Время жизни сессии в миллисекундах
   *
   * @format int32
   */
  sessionTimeout: number;

  /**
   * Требуется изменить логин
   *
   */
  changeLogin?: boolean;

  /**
   * Требуется изменить пароль
   *
   */
  changePassword?: boolean;

  /**
   * Подсказка для формы смены пароля
   *
   */
  changePasswordHint?: string;

  /**
   * Пользователь с единственной ролью UserLK
   *
   */
  isUserLK?: boolean;

  /**
   * Наличие у пользователя ограниченной роли для клиента
   *
   */
  hasRestrictedRole?: boolean;

  /**
   * Авторизация с использованием одноразового пароля
   *
   */
  isUseOTP?: boolean;

  /**
   * Признак гостевой учетной записи
   *
   */
  isGuest?: boolean;
}

/**
 * Ответ на запрос процесса начала авторизации с помощью PayControl 5.3.
 */
export interface PC53LoginStartResponse {
  /**
   * Идентификатор транзакции
   *
   */
  transactionId: string;
}

/**
 * Ответ на запрос авторизации
 */
export interface PC53LoginFinishResponse {
  /**
   * jwt токен
   *
   */
  jwt?: string;

  /**
   * Время жизни сессии в миллисекундах
   *
   * @format int32
   */
  sessionTimeout: number;

  /**
   * Требуется изменить логин
   *
   */
  changeLogin?: boolean;

  /**
   * Требуется изменить пароль
   *
   */
  changePassword?: boolean;

  /**
   * Подсказка для формы смены пароля
   *
   */
  changePasswordHint?: string;

  /**
   * Пользователь с единственной ролью UserLK
   *
   */
  isUserLK?: boolean;

  /**
   * Наличие у пользователя ограниченной роли для клиента
   *
   */
  hasRestrictedRole?: boolean;

  /**
   * Авторизация с использованием одноразового пароля
   *
   */
  isUseOTP?: boolean;

  /**
   * Признак гостевой учетной записи
   *
   */
  isGuest?: boolean;
}

/**
 * Формат ответа при ошибке сервера
 */
export interface ErrorResponse {
  errors: string[];

  /**
   * Список кодов ошибок:
   *     LOCKED_PAYCONTROL - Признак блокировки PayControl на сервере
   *
   */
  codes?: string[];
}

/**
 * Формат ответа ошибки валидации
 */
export interface ValidationResponse {
  /**
   * Список ошибок после валидации
   *
   */
  errors: ValidationItem[];

  /**
   * Список предупреждений после валидации
   *
   */
  warnings?: ValidationItem[];
}

/**
 * Описание ошибки валидируемого поля
 */
export interface ValidationItem {
  /**
   * Список полей
   *
   */
  fields?: string[];

  /**
   * Описание ошибки
   *
   */
  message: string;
}

/**
 * Пустой Ok-ответ
 */
export type EmptyResponse = object;

/**
 * Параметры запроса регистрации мобильного устройства
 */
export interface RegisterMobileDeviceRequest {
  /**
   * Наименование устройства
   *
   */
  deviceName: string;

  /**
   * Отпечаток устройства PayControl
   *
   */
  fingerPrint: string;
}

/**
 * Параметры запроса регистрации мобильного устройства для PayControl 5.3
 */
export interface PC53RegisterMobileDeviceRequest {
  /**
   * Наименование устройства
   *
   */
  deviceName: string;

  /**
   * Отпечаток устройства PayControl
   *
   */
  fingerPrint: string;
}

/**
 * Параметры запроса регистрации мобильного устройства
 */
export interface RegisterMobileDeviceResponse {
  /**
   * Зашифрованная секретная информация в формате XML
   *
   */
  keyData: string;

  /**
   * Идентификатор пользователя в PayControl
   *
   */
  payControlUserId: string;
}

/**
 * Ответ на запрос регистрации мобильного устройства в PayControl 5.3
 */
export interface PC53RegisterMobileDeviceResponse {
  /**
   * Ключевая информация для мобильного устройства
   *
   */
  keyJson: string;

  /**
   * Идентификатор пользователя в PayControl
   *
   */
  payControlUserId: string;
}

/**
 * Ответ запроса идентификатора пользователя в PayControl
 */
export interface PayControlUserIdResponse {
  /**
   * Идентификатор пользователя в PayControl
   *
   */
  payControlUserId: string;
}

/**
 * Параметры запроса блокировки PayControl пользователя
 */
export interface LockPayControlUserRequest {
  /**
   * Идентификатор пользователя в PayControl
   *
   */
  payControlUserId: string;
}

/**
 * Параметры запроса блокировки пользователя в PayControl 5.3.
 */
export interface PC53LockPayControlUserRequest {
  /**
   * Идентификатор пользователя в PayControl
   *
   */
  payControlUserId: string;
}

/**
 * Формат ответа при ошибке блокировки PayControl
 */
export interface ErrorPayControl {
  errors: string[];

  /**
   * Признак не найденного или заблокированного устройства
   *
   */
  unusableDeviceError?: boolean;

  /**
   * Признак устройства, не принадлежащего авторизованному пользователю
   *
   */
  userMismatchError?: boolean;
}

/**
 * Ответ запроса числа неуспешных попыток ввода кода активации до перенаправления пользователя на экран ввода логина и пароля
 */
export interface ActivationCodeAttemptsResponse {
  /**
   * Число неуспешных попыток ввода кода активации до перенаправления пользователя на экран ввода логина и пароля
   *
   * @format int32
   */
  activateCodeAttempts: number;
}

/**
 * Ответ запроса числа попыток ввода неправильного PIN-кода
 */
export interface PINAttemptsResponse {
  /**
   * Число попыток ввода неправильного PIN-кода до временной блокировки
   *
   * @format int32
   */
  tempLockPINAttempts: number;

  /**
   * Число попыток ввода неправильного PIN-кода до постоянной блокировки
   *
   * @format int32
   */
  permLockPINAttempts: number;
}

/**
 * Параметры запроса на смену пароля
 */
export interface ChangePasswordRequest {
  /**
   * Текущий пароль
   *
   */
  oldPassword: string;

  /**
   * Новый пароль
   *
   */
  newPassword: string;
}

/**
 * Параметры запроса на отправку СМС с временным паролем
 */
export interface SendTempPassSMSRequest {
  /**
   * Логин
   *
   */
  login: string;
}

/**
 * Параметры ответа на запрос отправки СМС с временным паролем
 */
export interface SendTempPassSMSResponse {
  /**
   * Длительность блокировки повторной отправки СМС с паролем в секундах
   *
   * @format int64
   */
  timeBetweenResending: number;

  /**
   * Номер телефона, на который отправлено СМС с паролем
   *
   */
  phoneNumber: string;
}

/**
 * Параметры запроса на отправку СМС с временным паролем
 */
export interface ResetPassSendSMSRequest {
  /**
   * Логин
   *
   */
  login: string;

  /**
   * ИНН
   *
   */
  inn?: string;

  /**
   * КПП
   *
   */
  kpp?: string;

  /**
   * Фамилия
   *
   */
  surname?: string;

  /**
   * Идентификатор сертификата
   *
   */
  certId?: string;
}

/**
 * Параметры ответа на запрос отправки СМС с временным паролем
 */
export interface ResetPassSendSMSResponse {
  /**
   * Длительность блокировки повторной отправки СМС с паролем в секундах
   *
   * @format int64
   */
  timeBetweenResending: number;

  /**
   * Номер телефона, на который отправлено СМС с паролем
   *
   */
  phoneNumber: string;
}

/**
 * Параметры запроса на отправку СМС с одноразовым паролем
 */
export interface SendOTPSMSRequest {
  /**
   * Идентификатор источника OTP
   *
   */
  sourceId: string;

  /**
   * Название действия
   *
   */
  action: string;
}

/**
 * Параметры запроса источников одноразового пароля
 */
export interface OTPSourceRequest {
  /**
   * Название действия
   *
   */
  action: string;
}

/**
 * Параметры запроса проверки одноразового пароля
 */
export interface OTPCheckRequest {
  /**
   * Идентификатор генератора одноразовых паролей
   *
   */
  otpId: string;

  /**
   * Одноразовый пароль
   *
   */
  password: string;

  /**
   * Название действия
   *
   */
  action: string;

  /**
   * Идентификатор источника OTP
   *
   */
  sourceId: string;
}

/**
 * Параметры запроса проверки одноразового пароля при подписании
 */
export interface OTPCheckSignRequest {
  /**
   * Идентификатор записи о создании одноразового пароля
   *
   */
  OTPSignLogUUID: string;

  /**
   * Одноразовый пароль
   *
   */
  password: string;

  /**
   * Название действия
   *
   */
  action: string;
}

/**
 * Параметры сохранения бенефициара
 */
export interface BeneficiarySaveRequest {
  /** Счет или IBAN */
  account?: string;

  /**
   * Номер счета банка-бенефециара в банке-посреднике
   *
   */
  bankAgentAccountNumber?: string;

  /** Адрес */
  address?: string;

  /** Международный адрес */
  addressInt?: string;

  /**
   * ID банка
   * @format int64
   */
  bankId?: number;

  /**
   * Данные банка
   *
   */
  bank?: BeneficiaryBankSaveRequest;

  /**
   * ID Банка посредника
   * @format int64
   */
  bankAgentId?: number;

  /**
   * Данные банка-посредника
   *
   */
  bankAgent?: BeneficiaryBankSaveRequest;

  /** Тип бенефициара */
  beneficiarType?: string;

  /** Город */
  city?: string;

  /**
   * Клиент
   * @format int64
   */
  clientId?: number;

  /**
   * ID Кода страны бенефициара
   * @format int64
   */
  countryId?: number;

  /** ИНН (КИО) */
  inn?: string;

  /** КПП */
  kpp?: string;

  /** Наименование */
  name?: string;

  /** Международное наименование бенефициара */
  nameInt?: string;

  /** Номер телефона */
  phoneNumber?: string;

  /** Валюта счета */
  currency?: string;
}

/**
 * Данные банка на сохранение бенефециара
 */
export interface BeneficiaryBankSaveRequest {
  /** Наименование банка */
  name?: string;

  /** Адрес банка */
  address?: string;

  /** Город Банка */
  city?: string;

  /**
   * ID Страны банка
   * @format int64
   */
  countryId?: number;

  /** Клиринговый код банка */
  clearingCode?: string;
}

/**
 * Обертка для ИД + наименование
 */
export interface IdPlusNameWrapper {
  /**
   * id
   * @format int64
   */
  id?: number;

  /** Наименование */
  name?: string;
}

/**
 * Источник одноразового пароля
 */
export interface OTPSource {
  /**
   * Идентификатор источника одноразового пароля
   *
   */
  sourceId?: string;

  /**
   * Название источника одноразового пароля
   *
   */
  sourceName?: string;

  /**
   * Является ли источник выбранным
   *
   */
  isSelected?: boolean;
}

/**
 * Параметры ответа на запрос отправки СМС с одноразовым паролем
 */
export interface SendOTPResponse {
  /**
   * Длительность блокировки повторной отправки СМС с паролем в секундах
   *
   * @format int64
   */
  timeBetweenResending?: number;

  /**
   * Идентификатор генератора одноразовых паролей
   *
   */
  otpId?: string;
}

/**
* Метод аутентификации:
auth-meth-name-and-pswd - Логин/Пароль
auth-meth-sign - ЭП (электронная подпись)
auth-meth-sign-and-pswd - ЭП с паролем
*/
export interface AuthenticationMethod {
  /**
   * Строковый идентификатор метода
   *
   */
  methodStrId: string;

  /**
   * Наименование метода
   *
   */
  methodName: string;
}

/**
 * Атрибуты сертификата
 */
export interface Certificate {
  /**
   * Идентификатор сертификата в ДБО
   *
   * @format int64
   */
  id?: number;

  /**
   * Идентификатор сертификата
   *
   */
  certId?: string;

  /**
   * Удостоверяющий центр
   *
   */
  issuer?: string;

  /**
   * Криптопровайдер
   *
   */
  provider?: string;

  /**
   * Криптоустройство подтверждения
   *
   */
  approver?: string;

  /**
   * Криптосистема (поле description сущности CryptoSystem)
   *
   */
  system?: string;

  /**
   * Владелец сертификата
   *
   */
  owner?: string;

  /**
   * Название организации
   *
   */
  client?: string;

  /**
   * Срок окончания действия сертификата
   *
   * @format date-time
   */
  dateDisable?: string;

  /**
   * Статус сертификата
   *
   */
  state?: string;

  /**
   * Идентификатор клиента
   *
   * @format int64
   */
  clientId?: number;

  /**
   * Идентификатор пользователя сертификата (CryptoUserCert.user.id)
   *
   * @format int64
   */
  userId?: number;
}

/**
 * Структура ответа с атрибутами виртуального сертификата для СМС-подписания
 */
export interface VirtualCertResponse {
  /**
   * Виртуальный сертификат
   *
   */
  virtualCert?: Certificate;

  /**
   * UUID записи журнала наложения подписей одноразовыми паролями
   *
   */
  logUUID?: string;

  /**
   * Длительность блокировки повторной отправки СМС с паролем в секундах
   *
   * @format int64
   */
  timeBetweenResending?: number;
}

/**
 * Краткая информация об клиенте
 */
export interface ClientShort {
  /**
   * Ид. клиента
   *
   * @format int64
   */
  id: number;

  /**
   * Краткое наименование клиента
   *
   */
  shortName: string;

  /**
   * Статус клиента:
   * registration -	Регистрация
   * registered -	Зарегистрирован
   * new -	Новый
   * disconnection -	Отключение
   * closed -	Закрыт
   * blocked -	Заблокирован
   * active -	Активный
   *
   */
  status: string;

  /**
   * Признак клиента, с которым пользователь работал в последнюю сессию
   *
   */
  isActive: boolean;

  /**
   * Признак блокировки СФМ (true - если клиент заблокирован)
   *
   */
  isClientBlockedSFM: boolean;

  /**
   * Дата блокировки СФМ (null, если isClientBlockedSFM - false)
   *
   * @format date
   */
  SFMBlockDate?: string;

  /**
   * Типы договоров
   *
   */
  contractTypes?: string[];

  /**
   * Полномочия пользователя относительно данного клиента
   * Если у пользователя полномочия действительны, возвращается тип подписи
   * Если у пользователя полномочия истекли, возвращается NoCompetency
   *
   */
  userCompetency?: string;

  /**
   * Идентификатор клиента в ЦФТ
   *
   */
  absId?: string;

  /**
   * ИНН клиента
   *
   */
  inn?: string;

  /**
   * ОКПО клиента
   *
   */
  okpo?: string;

  /**
   * Пользователь с единственной ролью UserLK
   *
   */
  isUserLK?: boolean;

  /**
   * Наличие у пользователя ограниченной роли для клиента
   *
   */
  hasRestrictedRole?: boolean;

  /**
   * Авторизация с использованием одноразового пароля
   *
   */
  isUseOTP?: boolean;
}

/**
 * Краткая информация об клиенте
 */
export interface ClientInfoResponse {
  /**
   * Ид. клиента
   *
   * @format int64
   */
  id: number;

  /**
   * Признак клиента, с которым пользователь работал в последнюю сессию
   *
   */
  isActive: boolean;

  /**
   * Полное наименование клиента
   *
   */
  name: string;

  /**
   * Краткое наименование клиента
   *
   */
  shortName: string;

  /**
   * Статус клиента:
   * registration -	Регистрация
   * registered -	Зарегистрирован
   * new -	Новый
   * disconnection -	Отключение
   * closed -	Закрыт
   * blocked -	Заблокирован
   * active -	Активный
   *
   */
  status: string;

  /**
   * Тип клиента:
   *     LE   - Юридическое лицо
   *     SP   - Индивидуальный предприниматель
   *     JUD  - ИП Адвокат
   *     NOT  - ИП Нотариус
   *     FARM - ИП Глава крестьянских (фермерских) хозяйств
   *     ARB  - ИП Арбитражный управляющий
   *
   */
  type: string;

  /**
   * ИНН/КИО
   *
   */
  inn: string;

  /**
   * Международное название
   *
   */
  internationalName?: string;

  /**
   * Международный адрес
   *
   */
  internationalAddress?: string;

  /**
   * КПП
   *
   */
  kpp: string;

  /**
   * Все КПП, основной и дополнительные
   *
   */
  allKpp?: string[];

  /**
   * ОГРН/ОГРНИП
   *
   */
  ogrn: string;

  /**
   * Признак нерезидента
   *
   */
  nonResident: boolean;

  /**
   * Юридический адрес
   *
   */
  legalAddress: string;

  /**
   * Почтовый адрес
   *
   */
  postAddress: string;

  /**
   * Номер телефона
   *
   */
  phoneNumber: string;

  /**
   * Показать клиенту баннера обновления профиля
   *
   */
  showUpdateProfileBanner?: boolean;

  /**
   * Дата получения признака "Показать анкету"
   *
   * @format date
   */
  updateProfileDate?: string;

  /**
   * Подразделение Банка (доп. офис)
   *
   */
  branch: Branch;

  /**
   * Основной оквэд клиента
   *
   */
  okvedMain?: Okved;

  /**
   * Список оквэдов клиента
   *
   */
  okvedList?: Okved[];
}

/**
 * Подробная информация о распоряжении на выпуск карт
 */
export interface WageIssuingCardInfoResponse {
  /**
   * Адрес подразделения
   *
   */
  address: string;

  /**
   * Идентификатор документа
   *
   */
  id: string;

  /**
   * Статус документа
   *
   */
  state: string;

  /**
   * Номер документа
   *
   */
  number: string;

  /**
   * Дата документа
   *
   * @format date
   */
  date: string;

  /**
   * ФИО ответственного по сделке
   *
   */
  agentFullName: string;

  /**
   * Телефон ответственного по сделке
   *
   */
  agentTel: string;

  /**
   * Количество карт
   *
   * @format int64
   */
  cardCount: number;

  /**
   * Тип карты
   *
   */
  cardType: string;

  /**
   * Идентификатор карты в ЦФТ
   *
   */
  absIdOfCard: string;

  /**
   * Список сотрудников
   *
   */
  wageIssuingCardEmployee: WageIssuingCardEmployee[];

  /**
   * Действия доступные для документа
   *
   */
  permissions: EntityPermission[];

  /**
   * Резидент
   *
   */
  resident: boolean;

  /**
   * Список платежей
   *
   */
  paymentRef?: PaymentShort[];

  /**
   * Информация о внешних платежах
   *
   */
  externalRef?: WageExternal[];

  /**
   * Сформировать ПП на комиссию за перечисление
   *
   */
  commission?: boolean;

  /**
   * Очередность платежа комиссии
   *
   * @format int32
   */
  commissionPriority?: number;

  /**
   * Счет списания комиссии
   *
   */
  commissionDebit?: string;

  /**
   * Назначение платежа по комиссии
   *
   */
  commissionGround?: string;

  /**
   * Идентификатор контракта
   *
   */
  contractId?: string;
}

/**
 * Данные по сотруднику
 */
export interface WageIssuingCardEmployee {
  /**
   * Идентификатор сотрудника
   *
   */
  id: string;

  /**
   * Фамилия
   *
   */
  lastName: string;

  /**
   * Имя
   *
   */
  firstName: string;

  /**
   * Отчество
   *
   */
  patronym: string;

  /**
   * Дата операции
   *
   * @format date
   */
  datebirth: string;

  /**
   * Серия паспорта
   *
   */
  series: string;

  /**
   * Номер паспорта
   *
   */
  number: string;

  /**
   * Контактный телефон
   *
   */
  phone: string;

  /**
   * Адрес
   *
   */
  address: string;
}

/**
 * Структура ответа со списком Распоряжений на выпуск карт
 */
export interface WageIssuingCardsResponse {
  /**
   * Признак того, возможна ли дальнейшая постраничная подгрузка
   *
   */
  hasMore?: boolean;

  /**
   * Список документов Распоряжения на выпуск карт
   *
   */
  data: WageIssuingCardShort[];
}

/**
 * Структура ответа со списком документов Распоряжения на выпуск карт
 */
export interface WageIssuingCardShort {
  /**
   * Идентификатор счета
   *
   * @format int64
   */
  id: number;

  /**
   * Статус документа
   *
   */
  state: string;

  /**
   * Номер документа
   *
   */
  documentNumber: string;

  /**
   * Тип карты
   *
   */
  cardType: string;

  /**
   * Идентификатор карты в ЦФТ
   *
   */
  absIdOfCard: string;

  /**
   * Дата документа
   *
   * @format date
   */
  documentDate: string;

  /**
   * Количество карт
   *
   * @format int64
   */
  cardCount: number;
  permissions: EntityPermission[];
}

/**
 * Результат импорта Распоряжения на выпуск карт
 */
export interface WageIssuingCardImportResponse {
  /**
   * Дата документа
   *
   * @format date
   */
  date?: string;

  /**
   * Номер документа
   *
   */
  number?: string;

  /**
   * Список сотрудников
   *
   */
  wageIssuingCardEmployee?: WageEmployee[];

  /**
   * Массив ошибок
   *
   */
  errors?: string[];
}

/**
 * Структура ответа подробной информации о сотрудниках в реестре на выпуск карт
 */
export interface WageIssuingCardEmployeeDetailInformationResponse {
  /**
   * Идентификатор реестра на выпуск карт
   *
   */
  id?: string;

  /**
   * Идентификтаор клиента
   *
   */
  clientId: string;

  /**
   * Идентификатор договора
   *
   */
  contractId: string;

  /**
   * Подробная информация о сотрудниках
   *
   */
  clientEmployee: WageEmployee[];
}

/**
 * Структура ответа с инфорацией об наличии у клиента первой или второй подписи а также права подписи реестра на зачисление
 */
export interface WageTransferCheckMakeSignResponse {
  /**
   * Признак того, что клиент имеет первую или вторую подпись
   *
   */
  hasFirstOrSecondSign: boolean;

  /**
   * Признак того, что клиент имеет первую подпись
   *
   */
  hasFirstSign: boolean;

  /**
   * Признак того, что клиент имеет вторую подпись
   *
   */
  hasSecondSign: boolean;

  /**
   * Признак того, что клиент может подписывать реестры на зачисление
   *
   */
  canMakeSign: boolean;
}

/**
 * Структура ответа со списком Распоряжений на зачисление средств
 */
export interface WageTransfersResponse {
  /**
   * Признак того, возможна ли дальнейшая постраничная подгрузка
   *
   */
  hasMore?: boolean;

  /**
   * Список документов Распоряжения на зачисление средств
   *
   */
  data: WageTransferShort[];
}

/**
 * Структура ответа со списком документов Распоряжения на зачисление средств
 */
export interface WageTransferShort {
  /**
   * Тип объекта (account)
   *
   */
  entityKind: string;

  /**
   * Идентификатор счета
   *
   * @format int64
   */
  id: number;

  /**
   * Статус документа
   *
   */
  state: string;

  /**
   * Номер документа
   *
   */
  documentNumber: string;

  /**
   * Дата документа
   *
   * @format date
   */
  documentDate: string;

  /**
   * Дата реестра
   *
   * @format date
   */
  registryDate: string;

  /**
   * Номер реестра
   *
   */
  registryNumber: string;

  /**
   * Номер счета плательщика
   *
   */
  payerAccNumber: string;

  /**
   * Общая сумма перечисления
   *
   * @format double
   */
  amount: number;

  /**
   * Количество сотрудников
   *
   * @format int32
   */
  employeeCount: number;
  permissions: EntityPermission[];
}

/**
 * Структура ответа со списком контрактов ЗП
 */
export interface WageContractInfoResponse {
  /**
   * Признак наличия/отсутствия у клиента активного договора ЗП
   *
   */
  isWageContractExist: boolean;

  /**
   * Список контрактов ЗП
   *
   */
  data?: WageContractShort[];
}

/**
 * Структура запроса с изменением настроек договора
 */
export interface WageContractSettings {
  /**
   * Идентификатор договора
   *
   * @format int64
   */
  id: number;

  /**
   * Номер договора
   *
   */
  contractNumber: string;

  /**
   * Идентификатор договора в ЦФТ
   *
   */
  absId?: string;

  /**
   * Название договора, данное ему пользователем
   *
   */
  name?: string;

  /**
   * Флаг "Избранное"
   *
   */
  isFavorite?: boolean;
}

/**
 * Структура ответа со списком карточных продуктов по контракту
 */
export interface CardProductInfoResponse {
  /**
   * Список карточных продуктов по договору
   *
   */
  data: WageCardProduct[];
}

/**
 * Структура ответа со списком контрактов ЗП
 */
export interface WageContractShort {
  /**
   * Идентификатор договора
   *
   * @format int64
   */
  id: number;

  /**
   * Номер договора
   *
   */
  contractNumber: string;

  /**
   * Дата открытия договора
   *
   * @format date
   */
  openDate: string;

  /**
   * Тарифный план для сотрудников
   *
   */
  tariffPlan: string;

  /**
   * Список карточных продуктов
   *
   */
  cardProduct: WageCardProduct[];

  /**
   * Процент комиссии за зачисление на счета сотрудников
   *
   */
  comission: number;

  /**
   * Счет для зачисления денежных средств на счета работников
   *
   */
  account: string;

  /**
   * ИНН подразделения банка
   *
   */
  branchINN: string;

  /**
   * КПП подразделения банка
   *
   */
  branchKPP: string;

  /**
   * БИК банка для зачисления денежных средств на счета работников
   *
   */
  bankBIC: string;

  /**
   * Наименование банка для зачисления денежных средств на счета работников
   *
   */
  bankName: string;

  /**
   * Корсчет банка для зачисления денежных средств на счета работников
   *
   */
  corrAcc: string;

  /**
   * Счет банка для перечисления комиссии за зачисление на счета сотрудников & Счет банка для перечисления комиссии за годовое обслуживание карт сотрудников Клиента
   *
   */
  accComission: string;

  /**
   * Идентификатор договора в ЦФТ
   *
   */
  absId: string;

  /**
   * Название договора, данное ему пользователем
   *
   */
  name?: string;

  /**
   * Флаг "Избранное"
   *
   */
  isFavorite?: boolean;
}

/**
 * Структура ответа со списком карточных продуктов
 */
export interface WageCardProduct {
  /**
   * Валюта
   *
   */
  currency: string;

  /**
   * Наименование
   *
   */
  name: string;

  /**
   * Комиссия за выпуск карт
   *
   */
  tariff: number;

  /**
   * Идентиикатор карты в ЦФТ
   *
   */
  absId: string;
}

/**
 * Структура ответа со списком ответственных лиц для реестра на зачисления средств
 */
export interface AgentListResponse {
  /**
   * Список ответственных лиц
   *
   */
  lstAgent: AgentData[];
}

/**
 * Dto для сущности "Ответственное лицо"
 */
export interface AgentData {
  /**
   * Идентификатор ответственного лица
   *
   * @format int64
   */
  id?: number;

  /**
   * ФИО
   *
   */
  fullName?: string;

  /**
   * Телефон
   *
   */
  phone?: string;

  /**
   * Должность
   *
   */
  position?: string;
}

/**
 * Структура запроса списка счетов
 */
export interface AccountsRequest {
  /**
   * Фильтр по валюте запрашиваемых счетов:
   * true  - только счета в национальной валюте
   * false - кроме счетов в нац. валюте
   * null  - все валюты
   *
   */
  isNationalCurrency?: boolean;

  /** Буквенный ISO-код валюты счёта */
  currency?: string;

  /**
   * Включить в ответ информацию по депозитным счетам
   *
   */
  needDepositInfo?: boolean;

  /** Хэш код данных */
  hashCode?: string;

  /** Строка поиска */
  search?: string;
}

/**
 * Структура ответа со списком счетов
 */
export interface AccountsResponse {
  /**
   * Дата и время последнего обновления данных
   *
   * @format date-time
   */
  lastUpdateDateTime: string;

  /**
   * Наличие ошибок в последнем обновлении
   *
   */
  lastUpdateError: boolean;

  /**
   * Список счетов
   *
   */
  accountsList?: AccountDetail[];

  /**
   * Количество счетов в разрезе валют
   *
   */
  currencyCount?: CurrencyCount[];

  /**
   * Хэш код данных по счетам
   *
   */
  hashCode: string;
}

/**
 * Базовая сущность счета
 */
export interface AccountBase {
  /**
   * Тип объекта (account)
   *
   */
  entityKind: string;

  /**
   * Идентификатор счета
   *
   * @format int64
   */
  id: number;

  /**
   * Статус счёта:
   *     OPENED
   *     CLOSED
   *
   */
  state: string;

  /**
   * Наименование счёта
   *
   */
  name: string;

  /**
   * Наименование счёта с информацией о подопечном
   *
   */
  nominalName?: string;

  /**
   * Буквенный ISO-код валюты счёта
   *
   */
  currency: string;

  /**
   * Номер счета
   *
   */
  number: string;

  /**
   * Тип счёта
   *
   */
  type: string;

  /**
   * Наименование филиала, в котором открыт счет
   *
   */
  branchName: string;

  /**
   * Код филиала банка, в котором открыт счёт
   *
   */
  branchCode: string;

  /**
   * Признак, что этот счет используется по умолчанию
   *
   */
  isDefaultAccount: boolean;

  /**
   * Любимый счет, установленный клиентом
   *
   */
  isFavouriteAccount: boolean;

  /**
   * Признак наличия документов блокировок по счету
   *
   */
  hasBlockDocuments?: boolean;

  /**
   * Признак наличия документов очереди распоряжений
   *
   */
  hasCardDocuments?: boolean;

  /**
   * Информация о подопечном
   *
   */
  wardInfo?: WardInfo;
}

/**
 * Информация о подопечном
 */
export interface WardInfo {
  /**
   * Имя подопечного
   *
   */
  wardFirstName?: string;

  /**
   * Фамилия подопечного
   *
   */
  wardLastName?: string;

  /**
   * Отчество подопечного
   *
   */
  wardMiddleName?: string;
}

/**
 * Структура ответа со списком счетов
 */
export type AccountItem = AccountBase & { currentBalance?: number };

/**
 * Детальная сущность счета
 */
export type AccountDetail = AccountItem & {
  interestRate?: number;
  endDate?: string;
  openDate?: string;
  depositName?: string;
  planBalance?: number;
};

/**
 * Структура ответа со списком счетов
 */
export type AccountPayment = AccountBase & {
  availableBalance?: number;
  isCreditAllowed?: boolean;
  isDebitAllowed?: boolean;
};

/**
 * Структура ответа со списком счетов включая банк
 */
export type AccountExchange = AccountPayment & { bank?: Bank };

/**
 * Детальная информация по обмену валюты
 */
export interface OrderDetails {
  /**
   * Код статуса документа
   *
   */
  state: string;

  /**
   * Дата документа
   *
   * @format date
   */
  date: string;

  /**
   * Номер заявки
   *
   */
  number: string;

  /**
   * Сумма списания
   *
   */
  debitSum: string;

  /**
   * Сумма зачисления
   *
   */
  creditSum: string;

  /**
   * Курс операции
   *
   */
  currencyRate: string;

  /**
   * Описание валютной пары из Дилинга
   *
   */
  currencyPair?: string;

  /**
   * Права пользователя на действия с шаблоном
   *
   */
  accessRights: DocumentAccessRights;

  /**
   * Код вида валютной операции
   *
   */
  curOperationCode: string;

  /**
   * Тип сделки:
   *   sale       - Продажа.
   *   buy        - Покупка.
   *   conversion - Конверсия.
   *
   */
  kind: string;

  /**
   * Буквенный ISO-код валюты зачисления.
   *
   */
  currSaleCode: string;

  /**
   * Буквенный ISO-код валюты списания.
   *
   */
  currBuyCode: string;

  /**
   * Счет списания.
   *
   */
  debitAccountNumber: string;

  /**
   * Счет зачисления.
   *
   */
  creditAccountNumber: string;

  /**
   * Поле суммы, заполненное пользователем:
   *     DEBIT - сумма списания
   *     CREDIT - сумма зачисления
   *
   */
  specifiedSum: string;

  /**
   * Комментарий банка
   *
   */
  bankComment?: string;

  /**
   * Причина отказа
   *
   */
  bankInfoRejectReason?: string;
}

/**
 * Создание заявки на покупку/продажу/конверсию валюты
 */
export interface CurrencyOrderRequest {
  /**
   * Признак сохранения с имеющимися предупреждениями
   *
   */
  ignoreWarning: boolean;

  /**
   * Идентификатор текущего клиента от имени которого создается заявка
   *
   * @format int64
   */
  clientId: number;

  /**
   * Код вида заявки:
   *     SALE_CURRENCY           - на продажу валюты
   *     BUY_CURRENCY            - на покупку валюты
   *     CONVERSION_CURRENCY     - на конверсию валюты
   *
   */
  kind: string;

  /**
   * Дата документа
   *
   * @format date
   */
  date: string;

  /**
   * ФИО уполномоченного лица
   *
   */
  responsibleName: string;

  /**
   * Телефон уполномоченного лица
   *
   */
  responsiblePhone?: string;

  /**
   * Номер счета для списания
   *
   */
  debitAccountNumber: string;

  /**
   * Номер счета для зачисления
   *
   */
  creditAccountNumber: string;

  /**
   * Валюта списания (буквенный ISO-код валюты)
   *
   */
  debitCurrencyCode: string;

  /**
   * Валюта зачисления (буквенный ISO-код валюты)
   *
   */
  creditCurrencyCode: string;

  /**
   * Сумма списания
   *
   * @format double
   */
  debitSum?: number;

  /**
   * Сумма зачисления
   *
   * @format double
   */
  creditSum?: number;

  /**
   * Поле суммы, заполненное пользователем:
   *     DEBIT - сумма списания
   *     CREDIT - сумма зачисления
   *
   */
  specifiedSum: string;

  /**
   * Курс операции
   *
   * @format double
   */
  currencyRate?: number;

  /**
   * Тип сделки:
   *     BANK - по курсу банка
   *     DEALING - по курсу из дилинга
   *
   */
  currencyRateType: string;

  /**
   * Описание валютной пары из Дилинга
   *
   */
  currencyPair?: string;

  /**
   * Дата получения курса из Дилинга
   *
   * @format date-time
   */
  onlineDate?: string;

  /**
   * ip адрес клиента
   *
   */
  ipAddress?: string;

  /**
   * mac адрес клиента
   *
   */
  macAddress?: string;
}

/**
 * Структура ответа запроса курсов валют для главной страницы
 */
export interface CurrencyRateResponse {
  rates: CurrencyRateInf[];
}

/**
 * Курс валют для главной страницы
 */
export interface CurrencyRateInf {
  /**
   * Курс продажи валюты
   *
   * @format double
   */
  sellRate: number;

  /**
   * Курс покупки валюты
   *
   * @format double
   */
  buyRate: number;

  /**
   * ISO-строка валюты
   *
   */
  currencyIso: string;
}

/**
 * Структура ответа запроса курсов валют
 */
export interface ExchangeRatesResponse {
  /**
   * Дата(время) обновления курсов валют
   *
   * @format date-time
   */
  updateDateTime: string;
  rates: ExchangeRate[];

  /**
   * Название обменного курса
   *
   */
  label: string;
}

/**
 * Данные курса обмена валют по диапазону
 */
export interface ExchangeRate {
  /**
   * Курс валюты
   *
   * @format double
   */
  rate: number;

  /**
   * Минимальная ссума для данного курса
   *
   * @format double
   */
  minSum: number;

  /**
   * Максимальная ссума для данного курса
   *
   * @format double
   */
  maxSum: number;
}

/**
 * Запрос курса валюты для заявки на покупку/продажу/конверсию валюты
 */
export interface CurrencyOrderRateRequest {
  /**
   * Идентификатор текущего клиента от имени которого создается заявка
   *
   * @format int64
   */
  clientId: number;

  /**
   * Валюта списания (буквенный ISO-код валюты)
   *
   */
  debitCurrencyCode: string;

  /**
   * Валюта зачисления (буквенный ISO-код валюты)
   *
   */
  creditCurrencyCode: string;

  /**
   * Счет списания
   *
   */
  debitAccount: string;

  /**
   * Счет зачисления
   *
   */
  creditAccount: string;

  /**
   * Сумма списания
   *
   * @format double
   */
  debitSum?: number;

  /**
   * Сумма зачисления
   *
   * @format double
   */
  creditSum?: number;

  /**
   * Код вида заявки:
   *     SALE_CURRENCY           - на продажу валюты
   *     BUY_CURRENCY            - на покупку валюты
   *     CONVERSION_CURRENCY     - на конверсию валюты
   *
   */
  kind: string;

  /**
   * Дата получения курса из Дилинга
   *
   * @format date-time
   */
  onlineDate?: string;
}

/**
 * Ответ на запрос курса валюты для заявки на покупку/продажу/конверсию валюты
 */
export interface CurrencyOrderRateResponse {
  /**
   * Статус запроса ставки:
   *   OK        - определен
   *   ERROR     - ошибка определения курса валюты
   *
   */
  state: string;

  /**
   * Описание причины ошибки определения курса валюты
   *
   */
  description?: string;

  /**
   * Описание валютной пары
   *
   */
  currencyName?: string;

  /**
   * Сумма списания
   *
   * @format double
   */
  debitSum?: number;

  /**
   * Сумма зачисления
   *
   * @format double
   */
  creditSum?: number;

  /**
   * Курс операции
   *
   * @format double
   */
  currencyRate?: number;

  /**
   * Дата получения курса из Дилинга
   *
   * @format date-time
   */
  onlineDate?: string;
}

/**
 * Структура ответа количество счетов в разрезе валют
 */
export interface CurrencyCount {
  /**
   * Буквенный ISO-код валюты счёта
   *
   */
  currency: string;

  /**
   * Количество счетов
   *
   * @format int64
   */
  count: number;
}

/**
 * Структура ответа с реквизитами
 */
export interface AccountRequisitesResponse {
  /**
   * Корсчет Банка получателя
   *
   */
  bankCorAccount: string;

  /**
   * Наименование филиала, в котором открыт счет
   *
   */
  bankName: string;

  /**
   * ИНН банка получателя
   *
   */
  bankInn: string;

  /**
   * КПП банка получателя
   *
   */
  bankKpp: string;

  /**
   * БИК банка получателя
   *
   */
  bankBic: string;

  /**
   * Номер счёта
   *
   */
  accountNumber: string;

  /**
   * Название клиента, которому принадлежит счёт
   *
   */
  accountClientName: string;

  /**
   * ИНН клиента, которому принадлежит счёт
   *
   */
  accountClientInn?: string;

  /**
   * КПП клиента, которому принадлежит счёт
   *
   */
  accountClientKpp?: string;

  /**
   * SWIFT банка получателя
   *
   */
  bankSwift?: string;

  /**
   * Наименование Банка-корреспондента
   *
   */
  bankCorrespondentName?: string;

  /**
   * Корсчет Банка-корреспондента
   *
   */
  bankCorrespondentAccount?: string;

  /**
   * SWIFT Банка-корреспондента
   *
   */
  bankCorrespondentSwift?: string;

  /**
   * Информация о подопечном
   *
   */
  wardInfo?: WardInfo;
}

/**
 * Структура ответа с разрешениями
 */
export interface EntityPermissions {
  /**
   * Строковый идентификатор объекта системы
   *
   */
  entityStrId: string;
  permissions?: EntityPermission[];
}

/**
 * Параметры запроса на установку любимого счета
 */
export interface FavouriteAccountRequest {
  /**
   * Ид. счета. (если совпадает с установленным ранее любимым счетом, то признак снимается, подтверждение не требуется)
   *
   * @format int64
   */
  id: number;

  /**
   * Подтверждение смены любимого счета
   *
   */
  confirm: boolean;
}

/**
 * Параметры ответа на установку любимого счета
 */
export interface FavouriteAccountResponse {
  /**
   * Ид. старого любимого счета
   *
   * @format int64
   */
  oldFavouriteAccount?: number;

  /**
   * Ид. нового любимого счета
   *
   * @format int64
   */
  newFavouriteAccount?: number;
}

/**
 * Формат ответа с ошибкой установления любимого счета
 */
export interface FavouriteAccountErrorResponse {
  /**
   * Описание ошибки
   *
   */
  error: string;
}

/**
 * Данные пользователя клиента-смсника для отображения в списке "Мои сотрудники" Личного кабинета пользователя с правом первой подписи
 */
export interface ClientsActiveUsersResponse {
  /**
   * Идентификатор пользователя
   *
   * @format int64
   */
  id?: number;

  /**
   * Идентификатор пользователя во внешней системе
   *
   */
  externalId: string;

  /**
   * ФИО пользователя
   *
   */
  name: string;

  /**
   * Должность
   *
   */
  position: string;

  /**
   * Адрес электронной почты
   *
   */
  email: string;

  /**
   * Номер мобильного телефона
   *
   */
  phone: string;

  /**
   * Логин пользователя
   *
   */
  login?: string;

  /**
   * Признак подключения Мобильного Банка (мобильное приложение)
   *
   */
  hasMB?: boolean;

  /**
   * Тип подписи:
   * 0	ClientNoSign            Пользователь Клиента без права подписи
   * 0	ClientNoSignOnlyView    Пользователь Клиента без права подписи (просмотр)
   * 1	ClientFirstSign         Пользователь Клиента с правом первой подписи
   * 2	ClientSecondSign        Пользователь Клиента с правом второй подписи
   *
   * @format int32
   */
  signatureType?: number;

  /**
   * Статус пользователя:
   * 1	Активный      Пользователь в статусе User.state = ACTIVE
   * 2	Заблокирован  Пользователь в статусе User.state = BLOCKED
   * 3	Закрыт        Пользователь в статусе User.state = CLOSED
   * 4	Новый         Пользователя нет еще нет в ДБО, но есть в АБС ЦФТ
   * 5	Истекает      Пользователь в статусе User.state = ACTIVE и у пользователя полномочия (для токениста и смс-ника) или максимальная дата окончания сертификатов в полномочиях (для токениста) истекает меньше, чем через 2 месяца
   * 6	Неактивен     Пользователь в статусе User.state = ACTIVE и у пользователя истекла дата действия полномочий (для токениста и смс-ника), истекли все сертификаты в полномочиях (для токениста и смс-ника) или отключены каналы доступа пользователя (РКО_ИК (токенист, web-клиент), РКО_ИК_СМС (смсник, вход в web-клиент), РКО_МБ (мобильный банк))
   *
   * @format int32
   */
  state?: number;

  /**
   * Окончание действия полномочий или сертификатов
   * Меньшая из дат: окончание действия полномочий (для токениста и смс-ника), максимальная дата окончания сертификатов в полномочиях (для токениста)
   *
   * @format date
   */
  authorityEndDate?: string;

  /**
   * Тип изменения
   * 0 - нет изменений
   * 1 - новый пользователь
   * 2 - существующий, требуются изменения существенных данных
   *
   * @format int32
   */
  changeType?: number;
}

/**
 * Данные пользователя клиента-токениста для отображения в списке "Мои сотрудники" Личного кабинета пользователя с правом первой подписи
 */
export interface RetrieveAbsUsersResponse {
  /**
   * Тип обработки:
   * 0 - нет новых пользователей и изменений
   * 1 - заявление на изменение уже есть, оно не в финальном статусе и прошло менее 24 часов с его запуска
   * 2 - есть изменения, сформировано заявление на изменение договора и отправлено на выполнение
   *
   * @format int32
   */
  code: number;

  /**
   * Обновленный список пользователей
   *
   */
  users: ClientsActiveUsersResponse[];
}

/**
 * Структура ответа с подробной информацией о текущем пользователе
 */
export interface UsersResponse {
  /**
   * Идентификатор пользователя
   *
   * @format int64
   */
  id: number;

  /**
   * Идентификатор пользователя во внешней системе
   *
   */
  externalId: string;

  /**
   * Статус пользователя:
   *     ACTIVE
   *     BLOCKED
   *     CLOSED
   *
   */
  state: string;

  /**
   * Имя пользователя
   *
   */
  name: string;

  /**
   * Адрес
   *
   */
  address: string;

  /**
   * Номер мобильного телефона
   *
   */
  phone: string;

  /**
   * Адрес электронной почты
   *
   */
  email: string;

  /**
   * Должность
   *
   */
  position: string;

  /**
   * Дата последней авторизации
   *
   * @format date
   */
  lastLoginTime: string;

  /** Список разделов меню, в которые пользователь еще не заходил */
  unreadMenuList: MenuInfo[];
}

/**
 * Роль текущего пользователя
 */
export interface UserRole {
  /**
   * Название роли
   *
   */
  roleName: string;
}

/**
 * Информация о подразделении Банка (доп. офисе)
 */
export interface Branch {
  /**
   * Идентификатор подразделения
   *
   * @format int64
   */
  id: number;

  /**
   * Название подразделения
   *
   */
  name: string;

  /**
   * БИК
   *
   */
  bic: string;

  /**
   * Корсчет Банка-корреспондента
   *
   */
  bankCorrespondentAccount: string;

  /**
   * Адрес подразделения
   *
   */
  address: string;
}

/**
 * Информация о подразделении Банка (доп. офисе)
 */
export interface Okved {
  /**
   * Код оквэда
   *
   */
  code: string;

  /**
   * Наименование оквэда
   *
   */
  name: string;
}

/**
 * Структура ответа со списком баланса счетов
 */
export interface BalanceResponse {
  /**
   * Дата и время последнего обновления данных
   *
   * @format date-time
   */
  lastUpdateDateTime: string;

  /**
   * Наличие ошибок в последнем обновлении
   *
   */
  lastUpdateError: boolean;

  /**
   * Список остатков в разрезе валюты
   *
   */
  data: AccountBalance[];
}

/**
 * Структура ответа списка остатков в разрезе валюты
 */
export interface AccountBalance {
  /**
   * Буквенный ISO-код валюты счёта
   *
   */
  currency: string;

  /**
   * Сумма текущих остатков в валюте
   *
   */
  balance: number;

  /**
   * Сумма планируемых остатков в валюте
   *
   */
  cumulativePlannedBalance: number;
}

/**
 * Структура ответа со списком контрагентов
 */
export interface CorrespondentsResponse {
  /**
   * Текущий пользователь имеет права на создание нового контрагента
   *
   */
  canCreate: boolean;

  /**
   * Признак, что возможно загрузить больше значений
   *
   */
  hasMore: boolean;

  /**
   * Список контрагентов
   *
   */
  data: Correspondent[];
}

/**
 * Контрагент клиента
 */
export interface CorrespondentRequest {
  /**
   * Признак сохранения с имеющимися предупреждениями
   *
   */
  ignoreWarning: boolean;

  /** Номер счета контрагента */
  account: string;

  /** Адрес контрагента */
  address?: string;

  /** Банк контрагента */
  bank: Bank;

  /** Описание контрагента */
  desc?: string;

  /** Назначение платежа */
  ground?: string;

  /** ИНН контрагента */
  inn: string;

  /** КПП контрагента */
  kpp?: string;

  /** Наименование контрагента */
  name: string;

  /** Телефон контрагента */
  phone?: string;
}

/**
 * Сводная информация из экспресс-отчета по контрагенту
 */
export interface CorrespondentBriefReportSummary {
  /**
   * Наличие информации, помеченной зеленым цветом
   *
   */
  greenStatements?: boolean;

  /**
   * Наличие информации, помеченной желтым цветом
   *
   */
  yellowStatements?: boolean;

  /**
   * Наличие информации, помеченной красным цветом
   *
   */
  redStatements?: boolean;
}

/**
 * Структура ответа с экспресс-отчетом по контрагенту
 */
export interface CorrespondentBriefReportResponse {
  /**
   * Индивидуальная разовая ссылка на экспресс-отчет в Контур.Фокусе
   *
   */
  href?: string;

  /**
   * Сводная информация из экспресс-отчета
   *
   */
  summary?: CorrespondentBriefReportSummary;
}

/**
 * Подробная информация о распоряжении на зачислении средств на счета работников
 */
export interface WageTransferRequest {
  /**
   * Признак сохранения с имеющимися предупреждениями
   *
   */
  ignoreWarning: boolean;

  /**
   * Ид. текущего клиента от имени которого создается распоряжение
   *
   * @format int64
   */
  clientId: number;

  /**
   * Ид. в АБС зарплатного договора
   *
   */
  contract: string;

  /**
   * Дата открытия зарплатного договора
   *
   * @format date
   */
  contractDate: string;

  /**
   * Номер реестра
   *
   */
  registryNumber: string;

  /**
   * Дата реестра
   *
   * @format date
   */
  registryDate: string;

  /**
   * Зачисление сотрудникам-нерезидентам
   *
   */
  notResident: boolean;

  /**
   * Список сотрудников
   *
   */
  wageTransferEmployee: WageTransferEmployee[];

  /**
   * Общая сумма перечисления
   *
   */
  totalSum: number;

  /**
   * Идентификатор сформированного ПП на перечисление
   *
   * @format int64
   */
  paymentOrderId?: number;

  /**
   * Список идентификаторов платежей
   *
   */
  paymentRef?: number[];

  /**
   * Информация о внешних платежах
   *
   */
  externalRef?: WageExternal[];

  /**
   * Идентификатор сформированного ПП на комиссию за перечисление
   *
   * @format int64
   */
  commissionPaymentOrderId?: number;
}

/**
 * Подробная информация о распоряжении на выпуск карт
 */
export interface WageIssuingCardRequest {
  /**
   * Признак сохранения с имеющимися предупреждениями
   *
   */
  ignoreWarning: boolean;

  /**
   * Ид. текущего клиента от имени которого создается распоряжение
   *
   * @format int64
   */
  clientId: number;

  /**
   * Идентификатор договора/контракта
   *
   */
  contractId: string;

  /**
   * Номер реестра
   *
   */
  registryNumber: string;

  /**
   * Дата реестра
   *
   * @format date
   */
  registryDate: string;

  /**
   * Резидент
   *
   */
  resident: boolean;

  /**
   * Тип карт
   *
   */
  typeOfCard: string;

  /**
   * Идентификатор карты в ЦФТ
   *
   */
  absIdOfCard?: string;

  /**
   * Список сотрудников
   *
   */
  clientEmployee: WageEmployee[];
  paymentRef?: number[];

  /**
   * Информация о внешних платежах
   *
   */
  externalRef?: WageExternal[];

  /**
   * Идентификатор сформированного ПП на комиссию за выпуск карт
   *
   * @format int64
   */
  commissionPaymentOrderId?: number;
}

/**
 * Подробная информация о распоряжении на выпуск карт
 */
export interface WageIssuingCardEditRequest {
  /**
   * Признак сохранения с имеющимися предупреждениями
   *
   */
  ignoreWarning?: boolean;

  /**
   * Список сотрудников
   *
   */
  clientEmployee: WageEmployee[];
}

/**
 * Информация о сотруднике
 */
export interface WageEmployee {
  /**
   * Идентификатор сотрудника
   *
   */
  id?: string;

  /**
   * Имя
   *
   */
  name: string;

  /**
   * Фамилия
   *
   */
  family: string;

  /**
   * Отчество
   *
   */
  patronymic: string;

  /**
   * Дата рождения
   *
   * @format date
   */
  datebirth: string;

  /**
   * ИНН
   *
   */
  inn: string;

  /**
   * СНИЛС
   *
   */
  snils: string;

  /**
   * Табельный номер
   *
   */
  tabel: string;

  /**
   * Пол
   *
   */
  sexvalue: string;

  /**
   * ОМС
   *
   */
  oms: string;

  /**
   * Код страны рождния
   *
   */
  bplcountycode?: string;

  /**
   * Населенный пункт
   *
   */
  bplplace: string;

  /**
   * Район
   *
   */
  bplraion: string;

  /**
   * Код субъекта РФ по ОКАТО
   *
   */
  bplregion?: string;

  /**
   * Код страны
   *
   */
  contryNumericCode: string;

  /**
   * Карта
   *
   */
  card: WageCard;

  /**
   * Контактная информация
   *
   */
  contactInfo: WageInfo;

  /**
   * Документ удостоверяющий личность
   *
   */
  identitydoc: WageIdentityDoc;

  /**
   * Адрес
   *
   */
  address?: WageAddress;

  /**
   * Фактический адрес
   *
   */
  addressfact?: WageAddress;

  /**
   * Тип резидентства
   *
   */
  residenceTypes: string[];

  /**
   * Налоговый резидент иностранной юрисдикции
   *
   */
  taxResidentOfForeignJurisdiction: boolean;

  /**
   * Миграционные документы
   *
   */
  migrationDoc?: WageMigrationDoc;

  /**
   * Является ли бенефициарным владельцем иное физическое лицо
   *
   */
  beneficiaryOwner: boolean;
}

/**
 * Миграционные документы
 */
export interface WageMigrationDoc {
  /**
   * Налоговый резидент иностранной юрисдикции
   *
   */
  gringo: string;

  /**
   * Тип документа
   *
   */
  type: string;

  /**
   * Серия
   *
   */
  series: string;

  /**
   * Номер
   *
   */
  number: string;

  /**
   * Дата выдачи
   *
   */
  beginDate: string;

  /**
   * Дата окончания
   *
   */
  endDate: string;

  /**
   * Страна/юрисдикция налогового резиденства
   *
   */
  country: string;

  /**
   * Иностраннный номер налогоплательщика (TIN)
   *
   */
  tin: string;

  /**
   * Причина отсутствия иностранного номера налогоплательщика (TIN)
   *
   */
  reasonForNotHavingTin: string;

  /**
   * Серия миграционной карты
   *
   */
  mCardSeries: string;

  /**
   * Номер миграционной карты
   *
   */
  mCardNumber: string;
}

/**
 * Карта
 */
export interface WageCard {
  /**
   * Тип карты
   *
   */
  type: string;

  /**
   * Транслитерация
   *
   */
  latin: string;

  /**
   * Кодовое слово
   *
   */
  phrase: string;
}

/**
 * Документ удостоверяющий личность
 */
export interface WageIdentityDoc {
  /**
   * Тип документа
   *
   */
  type: string;

  /**
   * Кем выдан
   *
   */
  unit: string;

  /**
   * Код подразделения
   *
   */
  unitcode: string;

  /**
   * Нормер
   *
   */
  number: string;

  /**
   * Серия
   *
   */
  series: string;

  /**
   * Дата выдачи
   *
   * @format date
   */
  date: string;

  /**
   * Дата окончания срока
   *
   * @format date
   */
  dateend: string;
}

/**
 * Контактная информация
 */
export interface WageInfo {
  /**
   * Телефон
   *
   */
  tel: string;

  /**
   * Домашний телефон
   *
   */
  telhome: string;

  /**
   * Рабочий телефон
   *
   */
  telwork: string;

  /**
   * email
   *
   */
  email: string;

  /**
   * Смс информирование
   *
   */
  smsinfo: boolean;
}

/**
 * Подробная информация о адресе
 */
export interface WageAddress {
  /**
   * Идентификатор адреса
   *
   */
  id?: string;

  /**
   * Номер квартиры
   *
   */
  apartment: string;

  /**
   * Номер здания
   *
   */
  build: string;

  /**
   * Город
   *
   */
  city: string;

  /**
   * Номер дома
   *
   */
  house: string;

  /**
   * Номер дома
   *
   */
  housing: string;

  /**
   * Индекс
   *
   */
  postalCode: string;

  /**
   * Название района
   *
   */
  name: string;

  /**
   * Название района
   *
   */
  raion: string;

  /**
   * Названия региона
   *
   */
  region: string;

  /**
   * Улица
   *
   */
  street: string;

  /**
   * Тип субьекта
   *
   */
  type: string;

  /**
   * Тип улицы
   *
   */
  typestreet: string;

  /**
   * guid адреса из ФИАСа
   *
   */
  uuidfias: string;
}

/**
 * Подробная информация о валютном платеже
 */
export interface VedPaymentRequest {
  /**
   * Идентификатор текущего клиента от имени которого создается платеж
   *
   * @format int64
   */
  clientId?: number;

  /**
   * Идентификатор счета
   *
   * @format int64
   */
  payerAccountId?: number;

  /**
   * Город
   *
   */
  payerCity?: string;

  /**
   * Улица
   *
   */
  payerStreet?: string;

  /**
   * Сумма операции
   *
   */
  sum?: number;

  /**
   * Код валюты:
   *   USD - Доллар
   *   EUR - Евро
   *
   */
  currency?: string;

  /**
   * Идентификатор бенефециара платежа
   *
   * @format int64
   */
  beneficiarId?: number;

  /**
   * Описание платежа
   *
   */
  paymentDetails?: string;

  /**
   * Код платежа:
   *   OUR
   *   SHA
   *   BEN
   *
   */
  chargeType?: string;

  /** @format int64 */
  chargeAccountId?: number;
  chargeIsGrantType?: boolean;
  receiverInformation?: string;
  contact?: string;
  contactPhone?: string;

  /**
   * Данные бенефециара
   *
   */
  beneficiar?: BeneficiarySaveRequest;

  /**
   * Данные валютного контроля
   *
   */
  currencyControl?: VedPaymentCurrencyControl[];

  /** Список вложений */
  attachments?: AttachmentRequest[];

  /** Идентификаторы удаленных вложений */
  "removed-files"?: number[];
}

/**
 * Информация для валютного контроля о валютном платеже
 */
export interface VedPaymentCurrencyControl {
  /**
   * Идентификатор договора/контракта
   *
   */
  contractId?: string;

  /**
   * Номер договора/контракта
   *
   */
  contractNumber?: string;

  /**
   * Дата договора/контракта
   *
   * @format date
   */
  contractDate?: string;

  /**
   * Уникальный номер контракта/кредитного договора
   *
   */
  contractUnk?: string;

  /**
   * Сумма по коду вида операции
   *
   */
  paySum?: number;

  /**
   * Код валюты:
   *   USD - Доллар
   *   EUR - Евро
   *
   */
  payCurrency?: string;

  /**
   * Код операции
   *
   */
  kvo?: string;

  /**
   * Код валюты:
   *   USD - Доллар
   *   EUR - Евро
   *
   */
  contractCurrency?: string;
  contractCurrencySum?: number;

  /**
   * Ожидаемый срок
   *
   * @format date
   */
  expectedDate?: string;

  /** @format date */
  refundDate?: string;
}

/**
 * Подробная информация о валютном платеже
 */
export interface VedPaymentInfoResponse {
  /**
   * Город
   *
   */
  payerCity?: string;

  /**
   * Улица
   *
   */
  payerStreet?: string;

  /**
   * Наименование плательщика
   *
   */
  payerName?: string;

  /**
   * Идентификатор бенефециара
   *
   * @format int64
   */
  beneficiarId?: number;

  /**
   * Наименование бенефециара
   *
   */
  beneficiarName?: string;

  /**
   * Страна бенефециара
   *
   */
  beneficiarCountry?: string;

  /**
   * Город бенефециара
   *
   */
  beneficiarCity?: string;

  /**
   * Адрес бенефециара
   *
   */
  beneficiarAddress?: string;

  /**
   * Номер счета бенефециара
   *
   */
  beneficiarAccountNumber?: string;

  /**
   * Номер счета бенефециара в банке-посреднике
   *
   */
  beneficiarAgentAccountNumber?: string;

  /**
   * Банк бенефециара
   *
   */
  beneficiarBank?: VedPaymentInfoBankInfoResponse;

  /**
   * Банк-посредник бенефециара
   *
   */
  beneficiarAgentBank?: VedPaymentInfoBankInfoResponse;

  /**
   * Сумма операции
   *
   */
  sum?: number;

  /**
   * Код валюты:
   *   USD - Доллар
   *   EUR - Евро
   *
   */
  currency?: string;

  /**
   * Номер документа
   *
   */
  documentNumber?: string;

  /**
   * Статус документа
   *
   */
  documentState?: string;

  /**
   * Описание статуса документа
   *
   */
  documentStateDesc?: string;

  /**
   * Дата создания платежного документа
   *
   * @format date
   */
  createDate?: string;

  /**
   * Идентификатор счета плательщика
   *
   * @format int64
   */
  accountId?: number;

  /**
   * Номер счета плательщика
   *
   */
  accountNumber?: string;

  /**
   * Описание платежа
   *
   */
  paymentDetails?: string;

  /**
   * Код платежа:
   *   OUR
   *   SHA
   *   BEN
   *
   */
  chargeType?: string;

  /**
   * Идентификатор счета комиссии плательщика
   *
   * @format int64
   */
  chargeAccountId?: number;

  /**
   * Номер счета комиссии плательщика
   *
   */
  chargeAccountNumber?: string;
  chargeIsGrantType?: boolean;
  receiverInformation?: string;
  contact?: string;
  contactPhone?: string;

  /**
   * Идентификатор документа отзыва
   *
   */
  revokeId?: string;
  currencyControl?: VedPaymentCurrencyControl[];

  /** Список вложений */
  attachments?: AttachmentInfo[];
  permissions?: EntityPermission[];
}

/**
 * Подробная информация банке в валютном платеже
 */
export interface VedPaymentInfoBankInfoResponse {
  /**
   * Наименование банка
   *
   */
  name?: string;

  /**
   * Swift банка
   *
   */
  swift?: string;

  /**
   * Клиринговый код банка
   *
   */
  clearingCode?: string;

  /**
   * Страна банка
   *
   */
  country?: string;

  /**
   * Город банка
   *
   */
  city?: string;

  /**
   * Адрес банка
   *
   */
  address?: string;
}

/**
 * Структура ответа на сохранение валютных документов
 */
export interface VedDocumentSaveResponse {
  /**
   * Идентификатор документа
   *
   * @format int64
   */
  id: number;

  /**
   * Номер документа
   *
   */
  number: string;

  /**
   * Код статуса документа
   *
   */
  state: string;

  /**
   * Данные о доступных операциях с документе
   *
   */
  accessRights: DocumentAccessRights;

  /**
   * Данные о доступных операциях с документе
   *
   */
  validationErrors?: ValidationResponse;

  /**
   * Идентификатор бенефециара ВП
   *
   * @format int64
   */
  benefeciarId?: number;

  /** Список вложений */
  attachments?: AttachmentInfo[];
}

/**
 * Подробная информация о платеже
 */
export interface PaymentRequest {
  /**
   * Признак сохранения с имеющимися предупреждениями
   *
   */
  ignoreWarning: boolean;

  /**
   * Признак добавления получателя в справочник контрагентов
   *
   */
  addCorrespondent?: boolean;

  /**
   * Идентификатор текущего клиента от имени которого создается платеж
   *
   * @format int64
   */
  clientId: number;

  /**
   * Дата операции
   *
   * @format date
   */
  date: string;

  /**
   * Номер платежа
   *
   */
  number: string;

  /**
   * Сумма операции
   *
   */
  amount: number;

  /**
   * Код вида документа:
   *     PAYMENT_ORDER   - ПП
   *     PAYMENT_DEMAND  - ПТ
   *     PAYMENT_INCASSO - ИП
   *
   */
  kind: string;

  /**
   * Идентификатор выставленного счета, на основании которого создается платеж
   *
   * @format int64
   */
  invoiceId?: number;

  /**
   * Способ отправки:
   *     EMPTY           - Пусто
   *     URGENT          - Срочно
   *     ELECTRONICALLY  - Электронно
   *     MAIL            - Почтой
   *     TELEGRAPH       - Телеграфом
   *
   */
  sendType: string;

  /**
   * Очередность
   *
   * @format int32
   */
  priority: number;

  /**
   * Данные о плательщике
   *
   */
  payer: PaymentMember;

  /**
   * Данные о получателе
   *
   */
  receiver: PaymentMember;

  /**
   * Назначение платежа
   *
   */
  ground: string;

  /**
   * Признак налогового платежа
   *
   */
  isTaxPayment: boolean;

  /**
   * Статус отправителя
   *
   */
  taxPayerStatus?: string;

  /**
   * Код КБК
   *
   */
  kbk?: string;

  /**
   * Код ОКТМО
   *
   */
  oktmo?: string;

  /**
   * Код (УИН/УИП)
   *
   */
  uin?: string;

  /**
   * Условие оплаты (только для ПТ):
   *     1 - без акцепта
   *     2 - с акцептом
   *
   * @format int32
   */
  conditionPayment?: number;

  /**
   * Срок для акцепта (только для ПТ):
   *     1, 2, 3, 4, 5
   *
   * @format int32
   */
  acceptancePeriod?: number;

  /**
   * Основание налогового платежа
   *
   */
  taxPaymentGround?: string;

  /**
   * Налоговый период
   *
   */
  taxPeriod?: string;

  /**
   * Номер документа
   *
   */
  taxDocNumber?: string;

  /**
   * Дата документа
   *
   */
  taxDocDate?: string;

  /**
   * Код выплат
   *
   */
  payType?: string;

  /**
   * Код вида дохода
   *
   */
  incomeCode?: string;

  /**
   * Удержано по исполнительному документу
   *
   */
  holdByExecDocSum?: number;

  /**
   * Код валютной операции
   *
   */
  curOperKindCode?: string;

  /**
   * Идентификатор платежного документа
   *
   */
  communalServicesId?: string;

  /**
   * Идентификатор услуги ЖКХ (ЖКУ)
   *
   */
  communalServicesServiceId?: string;

  /**
   * Номер платежного документа (ПДИ)
   *
   */
  communalServicesDocNum?: string;

  /**
   * Единый лицевой счет (ЕЛС)
   *
   */
  communalServicesSpa?: string;

  /**
   * Номер лицевого счета (ЛСИ)
   *
   */
  communalServicesAccNum?: string;

  /**
   * Период оплаты
   *
   */
  communalServicesPeriod?: string;

  /**
   * ИНН налогоплательщика (платеж за третье лицо)
   *
   */
  innTaxPayer?: string;

  /**
   * КПП налогоплательщика (платеж за третье лицо)
   *
   */
  kppTaxPayer?: string;

  /**
   * Наименование налогоплательщика (платеж за третье лицо)
   *
   */
  taxPayerName?: string;

  /**
   * Адрес налогоплательщика (платеж за третье лицо)
   *
   */
  taxPayerAddress?: string;

  /** IP-адрес клиента */
  ipAddress?: string;

  /** MAC-адрес клиента */
  macAddress?: string;

  /**
   * Идентификатор документа основания
   * (на основе которого должен быть создан платёжный документ)
   * На данный момент может использоваться только выставленный счёт(Invoice)
   *
   * @format int64
   */
  basisDocument?: number;

  /** Идентификатор документа в АУСН. Обязательно для заполнения, если DocumentType = ПП ФЛ */
  ausnId?: string;

  /**
   * Тип документа полученный из АУСН
   * Типа документов:
   *   ЕНС
   *   ОСС
   *   ПП ФЛ
   *   НДФЛ
   *
   */
  documentType?: string;
}

/**
 * Структура ответа на сохранение документов (Платежи, Отзывы, Заявки)
 */
export interface DocumentSaveResponse {
  /**
   * Идентификатор документа
   *
   */
  id: string;

  /**
   * Номер документа
   *
   */
  number: string;

  /**
   * Код статуса документа
   *
   */
  state: string;

  /**
   * Данные о доступных операциях с документе
   *
   */
  accessRights: DocumentAccessRights;
}

/**
 * Структура ответа на сохранение бенефициара
 */
export interface BeneficiarySaveResponse {
  /**
   * Идентификатор документа
   *
   */
  id?: string;

  /**
   * Статус created/updated
   *
   */
  state?: string;
}

/**
 * Права пользователя на действия с платежем
 */
export interface DocumentAccessRights {
  /**
   * Доступно подписание документа
   *
   */
  canSign: boolean;

  /**
   * Причина невозможности подписания документа
   *
   */
  canNotSignReason?: string;

  /**
   * Доступно редактирование документа
   *
   */
  canEdit: boolean;

  /**
   * Причина невозможности редактирования документа
   *
   */
  canNotEditReason?: string;

  /**
   * Доступен отзыв документа
   *
   */
  canRevoke: boolean;

  /**
   * Причина невозможности отзыва документа
   *
   */
  canNotRevokeReason?: string;

  /**
   * Доступно удаление документа
   *
   */
  canDelete: boolean;

  /**
   * Причина невозможности удаления документа
   *
   */
  canNotDeleteReason?: string;

  /**
   * Доступна отправка квитанции платежа
   *
   */
  canSendTicket: boolean;

  /**
   * Доступно создание нового документа на основе текущего
   *
   */
  canReCreate: boolean;

  /**
   * Доступно создание шаблона по документу
   *
   */
  canCreateTemplate: boolean;
}

/**
 * Структура ответа со списком платежных документов
 */
export interface PaymentsResponse {
  /**
   * Признак того, возможна ли дальнейшая постраничная подгрузка
   *
   */
  hasMore: boolean;

  /**
   * Список платежей
   *
   */
  data: PaymentShort[];
}

/**
 * Краткая информация о платеже
 */
export interface PaymentShort {
  /**
   * Ид. платежа
   *
   */
  id: string;

  /**
   * Номер документа
   *
   */
  number: string;

  /**
   * Дата операции
   *
   * @format date
   */
  date: string;

  /**
   * Данные о плательщике
   *
   */
  payer: PaymentMemberShort;

  /**
   * Данные о получателе
   *
   */
  receiver: PaymentMemberShort;

  /**
   * Сумма операции
   *
   */
  amount: number;

  /**
   * Буквенный ISO-код валюты
   *
   */
  currency: string;

  /**
   * Код вида документа:
   *   PAYMENT_ORDER   - ПП
   *   PAYMENT_DEMAND  - ПТ
   *   PAYMENT_INCASSO - ИП
   *
   */
  kind: string;

  /**
   * Код статуса документа
   *
   */
  state: string;

  /**
   * Назначение платежа
   *
   */
  ground: string;
  permissions: EntityPermission[];
}

/**
 * Структура ответа с разрешениями
 */
export interface DocumentPermissionsShort {
  docsWithPermissions?: DocumentPermissionShort[];
}

/**
 * Список разрешений для платежей
 */
export interface DocumentPermissionShort {
  /**
   * Ид. платежа
   *
   */
  id: string;
  permissions: EntityPermission[];
}

/**
 * Данные о плательщике/получателе платежа в краткой информации о платеже
 */
export interface PaymentMemberShort {
  /**
   * Наименование контрагента
   *
   */
  name?: string;

  /**
   * Номер счета
   *
   */
  accountNumber?: string;

  /**
   * ИНН контрагента
   *
   */
  inn?: string;

  /**
   * Банк
   *
   */
  bank?: BankShort;
}

/**
 * Данные о плательщике/получателе платежа
 */
export interface PaymentMember {
  /**
   * Идентификатор субъекта
   *
   */
  id?: string;

  /**
   * Наименование субъекта
   *
   */
  name: string;

  /**
   * Номер счета
   *
   */
  accountNumber: string;

  /**
   * ИНН
   *
   */
  inn: string;

  /**
   * КПП
   *
   */
  kpp: string;

  /**
   * Банк
   *
   */
  bank: Bank;
  permissions?: EntityPermission[];
}

/**
 * Данные о плательщике/получателе платежа
 */
export interface Correspondent {
  /**
   * Идентификатор субъекта
   *
   */
  id: string;

  /**
   * Номер счета контрагента
   *
   */
  accountNumber: string;

  /**
   * Адрес контрагента
   *
   */
  address?: string;

  /**
   * Банк контрагента
   *
   */
  bank: Bank;

  /**
   * Описание контрагента
   *
   */
  desc?: string;

  /**
   * Назначение платежа для контрагента
   *
   */
  ground?: string;

  /**
   * ИНН контрагента
   *
   */
  inn: string;

  /**
   * КПП контрагента
   *
   */
  kpp: string;

  /**
   * Наименование контрагента
   *
   */
  name: string;

  /**
   * Телефон контрагента
   *
   */
  phone?: string;
  permissions: EntityPermission[];
}

/**
 * Информация о номере следующего реестра на выпуск карт
 */
export interface WageIssuingCardNextRegistryNumberResponse {
  /**
   * Номер реестра
   *
   */
  registryCardNumber: string;
}

/**
 * Информация о номере следующего реестра на зачисление средств
 */
export interface WageTransfersNextRegistryNumberResponse {
  /**
   * Номер реестра
   *
   */
  registryNumber: string;
}

/**
 * Подробная информация о распоряжении на зачисление средств
 */
export interface WageTransferInfoResponse {
  /**
   * Идентификатор документа
   *
   */
  id: string;

  /**
   * Статус документа
   *
   */
  state: string;

  /**
   * Дата документа
   *
   * @format date
   */
  date: string;

  /**
   * Дата отправки в банк
   *
   * @format date-time
   */
  acceptedDate?: string;

  /**
   * Номер документа
   *
   */
  number: string;

  /**
   * Общая сумма перечисления
   *
   */
  totalSum: number;

  /**
   * Внешний платеж
   *
   */
  external: boolean;

  /**
   * Зачисление сотрудникам за счет бюджетов РФ
   *
   */
  budjet: boolean;

  /**
   * Зачисление сотрудникам-нерезидентам
   *
   */
  notResident: boolean;

  /**
   * ИНН Клиента
   *
   */
  clientINN: string;

  /**
   * Наименование Клиента
   *
   */
  clientShortName: string;

  /**
   * Номер договора
   *
   */
  contract: string;

  /**
   * Дата договора
   *
   * @format date
   */
  contractDate: string;

  /**
   * Номер реестра
   *
   */
  registryNumber: string;

  /**
   * Дата реестра
   *
   * @format date
   */
  registryDate: string;

  /**
   * Список сотрудников
   *
   */
  wageTransferEmployee: WageTransferEmployee[];

  /**
   * Сформировать ПП на перечисление
   *
   */
  transfer: boolean;

  /**
   * Номер документа
   *
   */
  paymentNumber?: string;

  /**
   * Дата документа
   *
   * @format date
   */
  paymentDate?: string;

  /**
   * Вид платежа
   *
   */
  paymentTypeCode?: string;

  /**
   * Очередность
   *
   * @format int32
   */
  paymentPriority?: number;

  /**
   * Код вида доходов
   *
   */
  incomeTypeCode?: string;

  /**
   * Удержано по исполнительному документу
   *
   */
  paymentExecSum?: number;

  /**
   * Счет списания
   *
   */
  paymentPayer?: string;

  /**
   * БИК банка плательщика
   *
   */
  paymentPayerBankBIC?: string;

  /**
   * Название банка плательщика
   *
   */
  paymentPayerBankName?: string;

  /**
   * Счет банка плательщика
   *
   */
  paymentPayerBankCorrAcc?: string;

  /**
   * Счет зачисления
   *
   */
  paymentReceiverAcc?: string;

  /**
   * БИК банка получателя
   *
   */
  paymentReceiverBankBIC?: string;

  /**
   * Название банка получателя
   *
   */
  paymentReceiverBankName?: string;

  /**
   * Счет банка получателя
   *
   */
  paymentReceiverBankCorrAcc?: string;

  /**
   * Назначение платежа
   *
   */
  ground?: string;

  /**
   * Код вида операции
   *
   */
  codeOperationValue?: string;

  /**
   * Список платежей
   *
   */
  paymentRef?: PaymentShort[];

  /**
   * Информация о внешних платежах
   *
   */
  externalRef?: WageExternal[];

  /**
   * Сформировать ПП на комиссию за перечисление
   *
   */
  commission: boolean;

  /**
   * Очередность платежа комиссии
   *
   * @format int32
   */
  commissionPriority?: number;

  /**
   * Счет списания комиссии
   *
   */
  commissionDebit?: string;

  /**
   * Общая сумма комиссии
   *
   */
  commissionTotalSum?: number;

  /**
   * Счет зачисления комиссии
   *
   */
  commissionCreditAcc?: string;

  /**
   * Назначение платежа по комиссии
   *
   */
  commissionGround?: string;

  /**
   * Действия доступные для документа
   *
   */
  permissions: EntityPermission[];
}

/**
 * Подробная информация о сотрудниках распоряжения на зачисление средств
 */
export interface WageTransferEmployeesResponse {
  /**
   * Идентификатор документа
   *
   */
  id: string;

  /**
   * Номер реестра
   *
   */
  registryNumber: string;

  /**
   * Зачисление сотрудникам-нерезидентам
   *
   */
  notResident: boolean;

  /**
   * Список сотрудников
   *
   */
  lstEmployee: WageTransferEmployee[];
}

/**
 * Статус сотрудников в распоряжении на зачисление средств
 */
export interface WageTransferEmployeesStatusResponse {
  /**
   * Идентификатор документа
   *
   */
  id: string;

  /**
   * Номер реестра
   *
   */
  registryNumber: string;

  /**
   * Зачисление сотрудникам-нерезидентам
   *
   */
  notResident: boolean;
}

/**
 * Внешние платежи
 */
export interface WageExternal {
  /**
   * БИК банка плательщика
   *
   */
  bankBIC: string;

  /**
   * Наименование банка
   *
   */
  bankName?: string;

  /**
   * Номер
   *
   */
  number: string;

  /**
   * Дата
   *
   * @format date
   */
  date: string;

  /**
   * Счет плательщика
   *
   */
  account: string;

  /**
   * Код вида доходов
   *
   */
  incomeTypeCode: string;

  /** Сумма удержания */
  paymentExecSum?: number;

  /**
   * Назначение платежа
   *
   */
  ground: string;

  /**
   * Признак платежа на коммисию
   *
   */
  payComission: boolean;
}

/**
 * Данные по сотруднику
 */
export interface WageTransferEmployee {
  /**
   * Порядковый номер
   *
   * @format int64
   */
  number?: number;

  /**
   * Фамилия
   *
   */
  lastName: string;

  /**
   * Имя
   *
   */
  firstName: string;

  /**
   * Отчество
   *
   */
  patronym: string;

  /**
   * Счет
   *
   */
  account: string;

  /**
   * Сумма
   *
   */
  sum: number;

  /**
   * Код вида дохода
   *
   */
  incomeTypeCode?: string;

  /**
   * Сумма удержания
   *
   */
  paymentExecSum?: number;

  /**
   * Примечание
   *
   */
  note?: string;
}

/**
 * Подробная информация о платеже
 */
export interface PaymentInfoResponse {
  /**
   * Ид. платежа
   *
   */
  id: string;

  /**
   * Дата операции
   *
   * @format date
   */
  date: string;

  /**
   * Дата отправки в банк
   *
   * @format date-time
   */
  acceptedDate?: string;

  /**
   * Номер платежа
   *
   */
  number: string;

  /**
   * Сумма операции
   *
   */
  amount: number;

  /**
   * Буквенный ISO-код валюты
   *
   */
  currency: string;

  /**
   * Код вида документа:
   *     PAYMENT_ORDER   - ПП
   *     PAYMENT_DEMAND  - ПТ
   *     PAYMENT_INCASSO - ИП
   *
   */
  kind: string;

  /**
   * Код статуса документа
   *
   */
  state: string;

  /**
   * Комментарий банка
   *
   */
  noteBank?: string;

  /**
   * Способ отправки:
   *     EMPTY           - Пусто
   *     URGENT          - Срочно
   *     ELECTRONICALLY  - Электронно
   *     MAIL            - Почтой
   *     TELEGRAPH       - Телеграфом
   *
   */
  sendType: string;

  /**
   * Очередность
   *
   * @format int32
   */
  priority: number;

  /**
   * Данные о плательщике
   *
   */
  payer: PaymentMember;

  /**
   * Данные о получателе
   *
   */
  receiver: PaymentMember;

  /**
   * Назначение платежа
   *
   */
  ground: string;

  /**
   * Признак налогового платежа
   *
   */
  isTaxPayment: boolean;

  /**
   * Статус отправителя
   *
   */
  taxPayerStatus?: string;

  /**
   * Код КБК
   *
   */
  kbk?: string;

  /**
   * Код ОКТМО
   *
   */
  oktmo?: string;

  /**
   * Код (УИН/УИП)
   *
   */
  uin?: string;

  /**
   * Условие оплаты (только для ПТ):
   *     1 - без акцепта
   *     2 - с акцептом
   *
   * @format int32
   */
  conditionPayment?: number;

  /**
   * Срок для акцепта (только для ПТ):
   *     1, 2, 3, 4, 5
   *
   * @format int32
   */
  acceptancePeriod?: number;

  /**
   * Основание налогового платежа
   *
   */
  taxPaymentGround?: string;

  /**
   * Налоговый период
   *
   */
  taxPeriod?: string;

  /**
   * Номер документа
   *
   */
  taxDocNumber?: string;

  /**
   * Дата документа
   *
   */
  taxDocDate?: string;

  /**
   * Код выплат
   *
   */
  payType?: string;

  /**
   * Код вида дохода
   *
   */
  incomeCode?: string;

  /**
   * Удержано по исполнительному документу
   *
   */
  holdByExecDocSum?: number;

  /**
   * Код валютной операции
   *
   */
  curOperKindCode?: string;

  /**
   * Идентификатор платежного документа
   *
   */
  communalServicesId?: string;

  /**
   * Идентификатор услуги ЖКХ (ЖКУ)
   *
   */
  communalServicesServiceId?: string;

  /**
   * Номер платежного документа (ПДИ)
   *
   */
  communalServicesDocNum?: string;

  /**
   * Единый лицевой счет (ЕЛС)
   *
   */
  communalServicesSpa?: string;

  /**
   * Номер лицевого счета (ЛСИ)
   *
   */
  communalServicesAccNum?: string;

  /**
   * Период оплаты
   *
   */
  communalServicesPeriod?: string;

  /**
   * ИНН налогоплательщика (платеж за третье лицо)
   *
   */
  innTaxPayer?: string;

  /**
   * КПП налогоплательщика (платеж за третье лицо)
   *
   */
  kppTaxPayer?: string;

  /**
   * Наименование налогоплательщика (платеж за третье лицо)
   *
   */
  taxPayerName?: string;

  /**
   * Адрес налогоплательщика (платеж за третье лицо)
   *
   */
  taxPayerAddress?: string;

  /** Идентификатор документа в АУСН. Обязательно для заполнения, если DocumentType = ПП ФЛ */
  ausnId?: string;

  /**
   * Тип документа полученный из АУСН
   * Типа документов:
   *   ЕНС
   *   ОСС
   *   ПП ФЛ
   *   НДФЛ
   *
   */
  documentType?: string;

  /**
   * Действия доступные для документа
   *
   */
  permissions: EntityPermission[];
}

/**
 * Подробная информация о начислении полученному из ГИС ГМП по УИН
 */
export interface PaymentChargingResponse {
  /**
   * Дата операции
   * @format date
   */
  date?: string;

  /** Сумма операции */
  amount: number;

  /** Буквенный ISO-код валюты */
  currency: string;

  /**
   * Способ отправки:
   *     EMPTY           - Пусто
   *     URGENT          - Срочно
   *     ELECTRONICALLY  - Электронно
   *     MAIL            - Почтой
   *     TELEGRAPH       - Телеграфом
   *
   */
  sendType: string;

  /**
   * Очередность
   * @format int32
   */
  priority: number;

  /** Данные о плательщике */
  payer: PaymentMember;

  /** Данные о получателе */
  receiver: PaymentMember;

  /** Назначение платежа */
  ground: string;

  /** Признак налогового платежа */
  isTaxPayment: boolean;

  /** Статус отправителя */
  taxPayerStatus?: string;

  /** Код КБК */
  kbk?: string;

  /** Код ОКТМО */
  oktmo?: string;

  /** Код (УИН/УИП) */
  uin?: string;

  /** Основание налогового платежа */
  taxPaymentGround?: string;

  /** Налоговый период */
  taxPeriod?: string;

  /** Номер документа */
  taxDocNumber?: string;

  /** Дата документа */
  taxDocDate?: string;

  /** Код выплат */
  payType?: string;

  /** Код вида дохода */
  incomeCode?: string;

  /** Удержано по исполнительному документу */
  holdByExecDocSum?: number;

  /** Код валютной операции */
  curOperKindCode?: string;

  /**
   * ИНН налогоплательщика (платеж за третье лицо)
   *
   */
  innTaxPayer?: string;

  /**
   * КПП налогоплательщика (платеж за третье лицо)
   *
   */
  kppTaxPayer?: string;

  /**
   * Наименование налогоплательщика (платеж за третье лицо)
   *
   */
  taxPayerName?: string;

  /**
   * Адрес налогоплательщика (платеж за третье лицо)
   *
   */
  taxPayerAddress?: string;
}

/**
 * Поля истории документа
 */
export interface DocumentHistoryResponse {
  /**
   * Дата и время выполнения действия
   *
   * @format date-time
   */
  executeDate?: string;

  /**
   * Статус документа
   *
   */
  state?: string;

  /**
   * Исполнитель
   *
   */
  executor?: string;
}

/**
 * Список полей истории статусов документа
 */
export interface DocumentHistoryResponseList {
  /**
   * История платежа
   *
   */
  historyList?: DocumentHistoryResponse[];
}

/**
 * Параметры запроса подписания одного платежа
 */
export interface PaymentSignRequest {
  /**
   * Идентификатор клиента
   *
   * @format int64
   */
  clientId: number;

  /**
   * Код подтверждения (отсутствует для платежей в статусе "Подписан")
   *
   */
  confirmationCode?: string;

  /**
   * MAC-адрес клиента
   *
   */
  macAddress?: string;

  /**
   * IP-адрес клиента
   *
   */
  ipAddress?: string;
}

/**
 * Параметры запроса по получению начислений
 */
export interface PaymentChargingRequest {
  /**
   * Идентификатор начисления
   * @pattern ^(\d{20}|\d{25})$
   */
  uin: string;
}

/**
 * Параметры запроса подписания одного платежа с помощью PayControl 5.3
 */
export interface PaymentPC53SignRequest {
  /**
   * MAC-адрес клиента
   *
   */
  macAddress?: string;

  /**
   * IP-адрес клиента
   *
   */
  ipAddress?: string;
}

/**
 * Ответ на запрос: Подписание платежа с помощью PayControl 5.3
 */
export interface PaymentPC53SignResponse {
  /**
   * Идентификатор транзакции
   *
   */
  transactionId: string;
}

/**
 * Очередной актуальный номер документа
 */
export interface PaymentNumberResponse {
  /**
   * Очередной актуальный номер документа
   *
   */
  number: string;
}

/**
 * Структура ответа с признаком отображения поля "Код валютной операции"
 */
export interface IsCurrencyPaymentResponse {
  /**
   * Признак отображения поля "Код валютной операции"
   *
   */
  result: boolean;
}

/**
 * Структура полей Банка
 */
export interface Bank {
  /**
   * Идентификатор банка
   *
   * @format int64
   */
  id?: number;

  /**
   * Наименование банка
   *
   */
  name: string;

  /**
   * Тип населенного пункта
   *
   */
  placetype: string;

  /**
   * Наименование населенного пункта
   *
   */
  placename: string;

  /**
   * БИК банка
   *
   */
  bic: string;

  /**
   * Кор. счет банка
   *
   */
  corAccount: string;

  /**
   * Адресс банк
   *
   */
  adress?: string;

  /**
   * Идентификатор страны
   *
   * @format int64
   */
  countryId?: number;

  /**
   * Адресс латиницей
   *
   */
  latAdress?: string;

  /**
   * Имя латиницей
   *
   */
  latName?: string;

  /**
   * Признак того является ли банк резидентом
   *
   */
  isResident?: boolean;

  /**
   * SWIFT код
   *
   */
  swift?: string;
}

/**
 * Структура ответа со списком банков
 */
export interface BanksResponse {
  /**
   * Признак, что возможно загрузить больше значений
   *
   */
  hasMore: boolean;

  /**
   * Список банков
   *
   */
  data: Bank[];
}

/**
 * Структура полей Банка в краткой информации о платеже
 */
export interface BankShort {
  /**
   * Идентификатор банка
   *
   * @format int64
   */
  id?: number;

  /**
   * Наименование банка
   *
   */
  name?: string;

  /**
   * БИК банка
   *
   */
  bic?: string;

  /**
   * Кор. счет банка
   *
   */
  correspondentAccount?: string;
}

/**
 * Структура полей справочника
 */
export interface DictItem {
  /**
   * Код значения справочника
   *
   */
  code: string;

  /**
   * Описание значения справочника
   *
   */
  desc: string;
}

/**
 * Структура полей справочника тип ДУЛ
 */
export type IdentityDocTypeDictItem = DictItem & {
  detailedDesc: string;
  codeABS: string;
};

/**
 * Структура полей справочника
 */
export type ExtDictItem = DictItem & { id: number; detailedDesc: string };

/**
 * Структура полей справочника стран
 */
export interface CountryItem {
  /**
   * Идентификатор записи справочника
   *
   * @format int64
   */
  id?: number;

  /**
   * Код значения справочника
   *
   */
  code?: string;

  /**
   * Код ISO
   *
   */
  isoCode?: string;

  /**
   * Двухбуквенный код страны
   *
   */
  twoLetterCode?: string;

  /**
   * Описание значения справочника
   *
   */
  desc?: string;

  /**
   * Подробное описание значения справочника
   *
   */
  detailedDesc?: string;

  /**
   * Подробное описание значения справочника на латинице
   *
   */
  detailedDescLat?: string;
}

/**
 * Адрес
 */
export interface AddressItem {
  /**
   * Идентификатор
   *
   */
  uuid: string;

  /**
   * Регион
   *
   */
  region: string;

  /**
   * Уровень вложенности
   * - region - область,край
   * - area - Район
   * - city - Город
   * - locality - Населенный пункт
   * - street - Улица
   * - unknown
   *
   */
  level: string;

  /**
   * Полный адрес
   *
   */
  fullAddress: string;

  /**
   * Почтовый индекс
   *
   */
  postalCode: string;
}

/**
 * Дом
 */
export interface HouseItem {
  /**
   * Идентификатор
   *
   */
  uuid: string;

  /**
   * Тип номера
   * - building - Строение
   * - construction - Корпус
   * - unknown
   *
   */
  type: string;

  /**
   * Номер
   *
   */
  number: string;

  /**
   * Доп. номер
   *
   */
  extNumber?: string;
}

/**
 * Структура ответа со списком значений справочника
 */
export interface DictResponse {
  /**
   * Признак, что возможно загрузить больше значений
   *
   */
  hasMore: boolean;

  /**
   * Дата (миллисекунды) последнего изменения
   *
   * @format int64
   */
  lastUpdate: number;

  /**
   * Список значений справочника
   *
   */
  data: DictItem[];
}

/**
 * Структура ответа со списком значений справочника стран
 */
export interface CountryResponse {
  /**
   * Список значений справочника
   *
   */
  data?: CountryItem[];
}

/**
 * Структура ответа со списком адресов
 */
export interface AddressResponse {
  /**
   * Признак, что возможно загрузить больше значений
   *
   */
  hasMore: boolean;

  /**
   * Список адресов
   *
   */
  data: AddressItem[];
}

/**
 * Структура ответа со списком адресов
 */
export interface HouseResponse {
  /**
   * Список домов
   *
   */
  data: HouseItem[];
}

/**
 * Структура ответа по статусу услуги Проверка контрагента
 */
export interface CorrespondentCheckServiceStateResponse {
  /**
   * Код статуса услуги:
   *     OPENED  - подключена
   *     CLOSED  - отключена
   *     STOPPED - приостановлена
   *
   */
  state: string;

  /**
   * Ключ к api контур.фокус (при статусе OPENED)
   *
   */
  focusKonturKey?: string;
}

/**
 * Создание заявки на подключение/отключение услуги Проверка контрагентов
 */
export interface CorrespondentCheckOrderRequest {
  /**
   * Признак сохранения с имеющимися предупреждениями
   *
   */
  ignoreWarning: boolean;

  /**
   * Идентификатор текущего клиента от имени которого создается заявка
   *
   * @format int64
   */
  clientId: number;

  /**
   * Код вида заявки:
   *     CORRESPONDENT_CHECK_ON         - на подключение услуги
   *     CORRESPONDENT_CHECK_OFF        - на отключение услуги
   *
   */
  kind: string;

  /**
   * Документы, дающие право проводить операции от лица Клиента
   *
   */
  rightsDocument: string;

  /**
   * Руководитель/уполномоченное лицо
   *
   */
  responsibleName: string;
}

/**
 * Редактирование заявки на подключение/отключение услуги Проверка контрагентов
 */
export interface CorrespondentCheckOrderUpdateRequest {
  /**
   * Признак сохранения с имеющимися предупреждениями
   *
   */
  ignoreWarning: boolean;

  /**
   * Идентификатор текущего клиента от имени которого создается заявка
   *
   * @format int64
   */
  clientId: number;

  /**
   * Документы, дающие право проводить операции от лица Клиента
   *
   */
  rightsDocument?: string;

  /**
   * Руководитель/уполномоченное лицо
   *
   */
  responsibleName?: string;

  /**
   * Снять подписи с заявки
   *
   */
  resetSign?: boolean;
}

/**
 * Список заявок на подключение услуги «Проверка контрагентов»
 */
export interface CorrespondentCheckOrders {
  /**
   * Статус услуги «Проверка контрагентов»:
   *    OPENED  - услуга подключена
   *    CLOSED  - услуга отключена
   *    STOPPED - услуга приостановлена
   *
   */
  state: string;

  /**
   * Текущий пользователь имеет права на создание новой заявки
   *
   */
  canCreate: boolean;

  /**
   * Текущий пользователь имеет права на подписание заявок
   *
   */
  canSign: boolean;

  /**
   * Признак того, возможна ли дальнейшая постраничная подгрузка
   *
   */
  hasMore: boolean;

  /**
   * Список заявок
   *
   */
  orders: CorrespondentCheckOrder[];
}

/**
 * Информация о заявке на подключение услуги «Проверка контрагентов»
 */
export interface CorrespondentCheckOrder {
  /**
   * Идентификатор заявки
   *
   */
  id: string;

  /**
   * Номер документа
   *
   */
  number: string;

  /**
   * Дата документа
   *
   * @format date
   */
  date: string;

  /**
   * Код вида заявки:
   *     CORRESPONDENT_CHECK_ON  - на подключение услуги «Проверка контрагентов»
   *     CORRESPONDENT_CHECK_OFF - на отключение услуги «Проверка контрагентов»
   *
   */
  kind: string;

  /**
   * Код статуса документа
   *
   */
  state: string;

  /**
   * Документы, дающие право проводить операции от лица Клиента
   *
   */
  rightsDocument?: string;

  /**
   * Руководитель/уполномоченное лицо
   *
   */
  responsibleName?: string;

  /**
   * Данные о доступных операциях с документом
   *
   */
  accessRights: DocumentAccessRights;
}

/**
 * Данные о наличии действующего единого сервисного договора (ЕСД)
 */
export interface EsdResponse {
  /**
   * Признак наличия действующего ЕСД
   *
   */
  hasEsd: boolean;

  /**
   * Дата ЕСД
   *
   * @format date
   */
  date?: string;
}

/**
 * Список заявок на смену тарифного плана
 */
export interface TariffOrders {
  /**
   * Текущий пользователь имеет права на создание новой заявки
   *
   */
  canCreate: boolean;

  /**
   * Текущий пользователь имеет права на подписание заявок
   *
   */
  canSign: boolean;

  /**
   * Признак того, возможна ли дальнейшая постраничная подгрузка
   *
   */
  hasMore: boolean;

  /**
   * Список заявок
   *
   */
  orders: TariffOrder[];
}

/**
 * Информация о заявке на смену тарифного плана
 */
export interface TariffOrder {
  /**
   * Идентификатор заявки
   *
   */
  id: string;

  /**
   * Номер документа
   *
   */
  number: string;

  /**
   * Дата документа
   *
   * @format date
   */
  date: string;

  /**
   * Код статуса документа
   *
   */
  state: string;

  /**
   * Комментарий к статусу документа
   *
   */
  stateDesc: string;

  /**
   * Номер действующего счета
   *
   */
  accountNumber: string;

  /**
   * Номер договора
   *
   */
  agreementNumber?: string;

  /**
   * Дата смены тарифного плана
   *
   * @format date
   */
  changeDateTariff?: string;

  /**
   * Порядок взимания комиссионного вознаграждения:
   *     CURRENT - Обслуживание расчетного счета осуществлять в рамках тарифного плана.
   *     CHANGE  - Сменить действующий тарифный план.
   *     TARIFF  - В соответствии с Тарифами комиссионного вознаграждения
   *
   */
  chargingCommission?: string;

  /**
   * Код нового тарифного плана
   *
   * @format int64
   */
  newTariffCode?: number;

  /**
   * Расчетный период
   *
   */
  billingPeriod?: number;

  /**
   * Документы, дающие право проводить операции от лица Клиента
   *
   */
  rightsDocument?: string;

  /**
   * Контактный телефон Клиента
   *
   */
  clientPhone?: string;

  /**
   * ФИО уполномоченного представителя Клиента
   *
   */
  representativeName?: string;

  /**
   * Должность
   *
   */
  representativePosition?: string;

  /**
   * Данные о доступных операциях с документом
   *
   */
  accessRights: DocumentAccessRights;
}

/**
 * Создание заявки на смену тарифного плана
 */
export interface TariffOrderRequest {
  /**
   * Идентификатор текущего клиента от имени которого создается заявка
   * @format int64
   */
  clientId?: number;

  /**
   * Признак сохранения с имеющимися предупреждениями
   *
   */
  ignoreWarning: boolean;

  /**
   * Порядок взимания комиссионного вознаграждения:
   *     CURRENT - Обслуживание расчетного счета осуществлять в рамках тарифного плана.
   *     CHANGE  - Сменить действующий тарифный план.
   *     TARIFF  - В соответствии с Тарифами комиссионного вознаграждения
   *
   */
  chargingCommission?: string;

  /**
   * Код нового тарифного плана, если не задан - тарифный план по умолчанию
   *
   * @format int64
   */
  newTariffCode?: number;

  /**
   * Номер действующего счета
   *
   */
  accountNumber: string;

  /**
   * Расчетный период
   *
   */
  billingPeriod?: number;

  /**
   * Снять подписи с заявки
   *
   */
  resetSign?: boolean;
}

/**
 * Список заявок на запрос справок
 */
export interface BankStatementOrders {
  /**
   * Текущий пользователь имеет права на создание новой заявки
   *
   */
  canCreate: boolean;

  /**
   * Текущий пользователь имеет права на подписание заявок
   *
   */
  canSign: boolean;

  /**
   * Признак того, возможна ли дальнейшая постраничная подгрузка
   *
   */
  hasMore: boolean;

  /**
   * Список заявок
   *
   */
  orders: BankStatementOrder[];
}

/**
 * Информация о заявке на запрос справок
 */
export interface BankStatementOrder {
  /**
   * Идентификатор заявки
   *
   */
  id: string;

  /**
   * Номер документа
   *
   */
  number: string;

  /**
   * Дата документа
   *
   * @format date
   */
  date: string;

  /**
   * Код статуса документа
   *
   */
  state: string;

  /**
   * Комментарий к статусу документа
   *
   */
  stateDesc: string;

  /**
   * ID Доп. офис
   * @format int64
   */
  branchId: number;

  /** Номера счетов */
  accountNumbers: string[];

  /** Текст запроса */
  textOrders?: ReferenceType[];

  /**
   * Данные о доступных операциях с документом
   *
   */
  accessRights: DocumentAccessRights;
}

/**
 * Данные организации для заявки на подключение к ДБО, полученные из АБС с помощью сервисов GetCustomerDetailsLE_v2 и GetRequestConnectDBOLE
 */
export interface ClientInfoFromABS {
  /**
   * Полное наименование организации (юр.лица) Клиента
   *
   */
  fullName: string;

  /**
   * Краткое наименование организации (юр.лица) Клиента
   *
   */
  shortName: string;

  /**
   * ИНН
   *
   */
  inn: string;

  /**
   * КПП
   *
   */
  kpp: string;

  /**
   * Полное наименование организации (юр.лица) Клиента на латинице
   *
   */
  nameLatin?: string;

  /**
   * Адрес строкой. Действующий адрес из списка адресов клиента с типом АдрЮр, в формате КЛАДР
   *
   */
  legalAddress: string;

  /**
   * ОГРН
   *
   */
  ogrn?: string;

  /**
   * Адрес строкой на латинице
   *
   */
  addrStrLat?: string;

  /**
   * ОКПО
   *
   */
  okpo?: string;

  /**
   * ОКАТО
   *
   */
  okato?: string;

  /**
   * Дата регистрации организации
   *
   * @format date
   */
  orgRegDate?: string;

  /**
   * Код страны юр.лица
   *
   */
  country: string;

  /**
   * Контактный телефон
   *
   */
  phoneNumber?: string;

  /**
   * Адрес электронной почты
   *
   */
  email: string;

  /**
   * ФИО генерального директора
   *
   */
  chiefName?: string;

  /**
   * ФИО главного бухгалтера
   *
   */
  accChiefName?: string;

  /**
   * Тип организации (Резидент/Нерезидент)
   *
   */
  orgType: boolean;

  /**
   * Тип заявки
   *
   */
  type: string;

  /**
   * Наименование подразделения банка
   *
   */
  branchName: string;

  /**
   * Идентификатор клиента в АБС
   *
   */
  idABS: string;

  /**
   * Номер заявки в CRM
   *
   */
  crmId?: string;

  /**
   * Дата документа в CRM
   *
   * @format date
   */
  crmDate?: string;

  /**
   * Без подключения счетов
   *
   */
  absAccountsNo?: boolean;

  /**
   * Список счетов для поля "Номер счета для списания комиссии"
   *
   */
  accCommissionList?: string[];

  /**
   * Список с информацией по представителям клиента, уполномоченным подписывать документы
   *
   */
  proxyPersons?: ProxyPerson[];

  /**
   * Список с информацией по счетам клиента из АБС
   *
   */
  accountsFromABS?: ABSAccount[];

  /**
   * Ответ на запрос из CRM реквизитов «Заявки на подключение к ДБО»
   *
   */
  DBOResponse?: DBOResponse;
}

/**
 * Реквизиты представителя клиента (уполномоченного лица)
 */
export interface ProxyPerson {
  /**
   * ФИО подписанта
   *
   */
  fullName: string;

  /**
   * Группа подписи/право подписи.
   * Возвращаются значения:
   *  «1» - владелец 1-ой подписи
   *  «2» - владелец 2-ой подписи
   *
   */
  signType: string;

  /**
   * Адрес места жительства в формате КЛАДР. Действующий адрес из
   * списка адресов клиента с типом АдрПроп, в формате КЛАДР
   *
   */
  cioAddr: string;

  /**
   * Наименование документа, удостоверяющего личность (ДУЛ) подписанта
   *
   */
  dulName: string;

  /**
   * Серия/номер ДУЛ подписанта
   *
   */
  dulNumber: string;

  /**
   * Орган, выдавший ДУЛ
   *
   */
  dulIssue?: string;

  /**
   * Уникальный идентификатор подписанта
   *
   */
  extId: string;

  /**
   * Начало срока полномочий
   *
   * @format date
   */
  dulCredentialsDateBegin: string;

  /**
   * Окончание срока полномочий
   *
   * @format date
   */
  dulCredentialsDateEnd: string;

  /**
   * Наименование должности
   *
   */
  dulPosition?: string;

  /**
   * Когда выдан ДУЛ
   *
   * @format date
   */
  dulIssueDate?: string;

  /**
   * Телефон
   *
   */
  dulPhone?: string;

  /**
   * Электронная почта
   *
   */
  dulEmail?: string;

  /**
   * Буквенный код страны
   *
   */
  country: string;
}

/**
 * Реквизиты счета клиента из АБС
 */
export interface ABSAccount {
  /**
   * 20-значный номер счета клиента, является уникальным идентификатором счета
   *
   */
  accountNumber: string;

  /**
   * Тип счёта
   *
   */
  accountType: string;

  /**
   * Номер договора клиента
   *
   */
  agrNumber: string;

  /**
   * Дата открытия договора клиента
   *
   * @format date
   */
  agrDate: string;
}

/**
 * Ответ на запрос из CRM реквизитов «Заявки на подключение к ДБО»
 */
export interface DBOResponse {
  /**
   * Номер заявки
   *
   */
  documentNumber: string;

  /**
   * Дата документа
   *
   * @format date
   */
  documentDate: string;

  /**
   * Номер Телефона
   *
   */
  securityTel?: string;

  /**
   * Адрес электронной почты
   *
   */
  securityEmail?: string;

  /**
   * ФИО Представителя Клиента из блока "Реквизиты Представителя Клиента, подписавшего заявку"
   *
   */
  agentFio: string;

  /**
   * Документ, на основании которого Представитель клиента подписал Заявку
   *
   */
  agentDocument: string;

  /**
   * ФИО Представителя Клиента из блока "Реквизиты Представителя Клиента"
   *
   */
  contactFio: string;

  /**
   * Телефон Представителя Клиента
   *
   */
  contactTel: string;
}

/**
 * Создание заявки на подключение к ДБО
 */
export interface JoinIClientRequest {
  /**
   * Признак сохранения с имеющимися предупреждениями
   *
   */
  ignoreWarning: boolean;

  /**
   * Данные организации для заявки на подключение к ДБО
   *
   */
  clientInfoFromABS: ClientInfoFromABS;

  /**
   * Номер счета для списания комиссии за ДБО
   *
   */
  accCommission: string;
}

/**
 * Краткая информация о заявке на подключение к ДБО
 */
export interface JoinIClientShortResponse {
  /**
   * Номер заявки
   *
   */
  documentNumber?: string;

  /**
   * Дата заявки
   *
   * @format date
   */
  documentDate?: string;

  /**
   * Статус
   *
   */
  state?: string;
}

/**
 * Параметры запроса для валидации ИНН/КПП
 */
export interface ValidationINNRequest {
  /**
   * ИНН
   *
   */
  inn: string;

  /**
   * КПП
   *
   */
  kpp?: string;
}

/**
 * Заявка на регистрацию СИО в реестре УЦ
 */
export interface JoinCA {
  /**
   * Ид. заявки на регистрацию СИО
   *
   */
  id?: string;

  /**
   * Дата документа
   *
   * @format date
   */
  documentDate: string;

  /**
   * Наименование клиента
   *
   */
  clientShortName: string;

  /**
   * ФИО
   *
   */
  fio: string;

  /**
   * Документ, удостоверяющий личность
   *
   */
  doc: string;

  /**
   * Серия и номер документа
   *
   */
  docNumber: string;

  /**
   * Дата выдачи
   *
   * @format date
   */
  docDate: string;

  /**
   * Кем выдан документ
   *
   */
  docUnit: string;

  /**
   * Страна/регион
   *
   */
  country: string;

  /**
   * Адрес места жительства
   *
   */
  address: string;

  /**
   * Подразделение в организации
   *
   */
  unit: string;

  /**
   * Адрес эл. почты
   *
   */
  email: string;
}

/**
 * Структура ответа со списком заявок на регистрацию СИО в реестре УЦ
 */
export interface JoinCAResponse {
  /**
   * Признак, что возможно загрузить больше значений
   *
   */
  hasMore: boolean;

  /**
   * Список заявок на регистрацию СИО в реестре УЦ
   *
   */
  data: JoinCAShort[];
}

/**
 * Краткая информация о заявке на регистрацию СИО в реестре УЦ
 */
export interface JoinCAShort {
  /**
   * Ид. заявки на регистрацию СИО
   *
   */
  id: string;

  /**
   * Дата
   *
   * @format date
   */
  documentDate: string;

  /**
   * Номер
   *
   */
  documentNumber: string;

  /**
   * Фамилия Имя Отчество СИО
   *
   */
  FIO: string;

  /**
   * Дата обработки
   *
   * @format date
   */
  finalDate?: string;

  /**
   * Состояние
   *
   */
  state: string;
}

/**
 * Данные для создания заявки на сертификат
 */
export interface CertReqCreateData {
  /**
   * ФИО владельца
   *
   */
  name: string;

  /**
   * Наименование организации
   *
   */
  organization: string;

  /**
   * Подразделение
   *
   */
  department: string;

  /**
   * Должность
   *
   */
  position: string;

  /**
   * e-mail
   *
   */
  email: string;

  /**
   * Страна
   *
   */
  country: string;

  /**
   * Криптосистема
   *
   */
  cryptoSystem?: string;

  /**
   * Крипроустройство подтверждения
   *
   */
  cryptoApprDev?: string;
}

/**
 * Заявка на выдачу сертификата
 */
export interface CertReq {
  /**
   * Ид. заявки на выдачу сертификата
   *
   */
  id: string;

  /**
   * Владелец ключа ЭП
   *
   */
  owner: string;

  /**
   * Организация
   *
   */
  organization: string;

  /**
   * Подразделение
   *
   */
  department: string;

  /**
   * E-mail
   *
   */
  email: string;

  /**
   * Страна
   *
   */
  country: string;

  /**
   * Статус документа
   *
   */
  state: string;

  /**
   * Имя ключевого контейнера
   *
   */
  cryptoReqId: string;

  /**
   * Центр сертификации
   *
   */
  authority: string;

  /**
   * Серийный номер выпущенного сертификата
   *
   */
  certIssued: string;
}

/**
 * Структура ответа со списком заявок на сертификат
 */
export interface CertReqResponse {
  /**
   * Признак, что возможно загрузить больше значений
   *
   */
  hasMore: boolean;

  /**
   * Список заявок на сертификат
   *
   */
  data: CertReqShort[];
}

/**
 * Краткая информация о заявке на сертификат
 */
export interface CertReqShort {
  /**
   * Ид. заявки на сертификат
   *
   */
  id: string;

  /**
   * Дата
   *
   * @format date
   */
  documentDate: string;

  /**
   * Дата и время создания документа (в миллисекундах)
   *
   */
  dateCreate?: string;

  /**
   * Номер
   *
   */
  documentNumber: string;

  /**
   * Фамилия Имя Отчество СИО
   *
   */
  owner: string;

  /**
   * Состояние
   *
   */
  state: string;

  /**
   * Описание состояния
   *
   */
  stateDesc?: string;

  /**
   * Серийный номер
   *
   */
  certIssued: string;

  /**
   * Название
   *
   */
  cryptoSystem: string;

  /**
   * Издатель
   *
   */
  issuer: string;

  /**
   * Идентификатор клиента
   *
   * @format int64
   */
  clientId?: number;
}

/**
 * Создание заявки на сертификат
 */
export interface CertCreateReqRequest {
  /**
   * Признак сохранения с имеющимися предупреждениями
   *
   */
  ignoreWarning: boolean;

  /**
   * Идентификатор сертификата
   *
   */
  uuid: string;

  /**
   * Открытый ключ
   *
   * @format base64
   */
  data: string;

  /**
   * Статус запроса в криптосистему
   *
   */
  status: string;

  /**
   * Ответ криптосистемы
   *
   */
  reason: string;

  /**
   * Идентификатор старого сертификата
   *
   */
  oldCertId?: string;
}

/**
 * Результат ответа из криптосистемы
 */
export interface CryptoAnswerRequest {
  /**
   * Статус запроса в криптосистему
   *
   */
  status: string;

  /**
   * Ответ криптосистемы
   *
   */
  reason: string;
}

/**
 * Результат ответа из УЦ
 */
export interface CertCreateResult {
  /**
   * Криптосистема
   *
   */
  provider: string;

  /**
   * Идентификатор запроса в СКЗИ
   *
   */
  uuid: string;

  /**
   * Данные ответа на запрос из СКЗИ
   *
   * @format base64
   */
  data: string;
}

/**
 * Информация о схеме подписания
 */
export interface SignSchem {
  /**
   * Количество подписантов
   *
   */
  value: string;

  /**
   * Описание
   *
   */
  description: string;
}

/**
 * Структура ответа со списком ККБ полей
 */
export interface CryptoBlockInfoResponse {
  /**
   * Номер документа
   *
   */
  documentNumber: string;

  /**
   * Дата документа
   *
   * @format date
   */
  documentDate: string;

  /**
   * Название документа
   *
   */
  documentName: string;

  /**
   * Список полей ККБ документа
   *
   */
  data: CCBInfo;
}

/**
 * Структура ответа со списком ККБ полей
 */
export interface CCBInfo {
  /**
   * Header
   *
   */
  header: string;

  /**
   * Footer
   *
   * @format string
   */
  footer: string;

  /**
   * Список полей ККБ документа
   *
   */
  data: CCBField[];
}

/**
 * Поле ККБ
 */
export interface CCBField {
  /**
   * Название поля
   *
   */
  name: string;

  /**
   * Значение
   *
   * @format string
   */
  value: string;

  /**
   * Описание поля
   *
   */
  description: string;

  /**
   * Префикс
   *
   * @format string
   */
  prefix: string;

  /**
   * Суффикс
   *
   */
  suffix: string;

  /**
   * Есть ли дочерняя сущность
   *
   */
  entity: boolean;

  /**
   * Дочерняя сущность
   *
   */
  childValue: CCBInfo;
}

/**
 * Структура ответа со списком шаблонов
 */
export interface TemplatesResponse {
  /**
   * Признак того, возможна ли дальнейшая постраничная подгрузка
   *
   */
  hasMore: boolean;

  /**
   * Список шаблонов
   *
   */
  data: TemplateShort[];
}

/**
 * Краткая информация о шаблоне
 */
export interface TemplateShort {
  /**
   * Ид. шаблона
   *
   */
  id: string;

  /**
   * Данные о получателе
   *
   */
  receiver: PaymentMemberShort;

  /**
   * Название шаблона
   *
   */
  name: string;

  /**
   * Код вида документа:
   *     PAYMENT_ORDER   - ПП
   *     PAYMENT_DEMAND  - ПТ
   *     PAYMENT_INCASSO - ИП
   *
   */
  kind: string;

  /**
   * Признак перевода между своими счетами
   *
   */
  isTransfer?: boolean;
}

/**
 * Подробная информация о шаблоне
 */
export interface TemplateInfoResponse {
  /**
   * Ид. шаблона
   *
   */
  id: string;

  /**
   * Название шаблона
   *
   */
  name: string;

  /**
   * Сумма операции
   *
   */
  amount?: number;

  /**
   * Код вида документа:
   *     PAYMENT_ORDER   - ПП
   *     PAYMENT_DEMAND  - ПТ
   *     PAYMENT_INCASSO - ИП
   *
   */
  kind: string;

  /**
   * Способ отправки:
   *     EMPTY           - Пусто
   *     URGENT          - Срочно
   *     ELECTRONICALLY  - Электронно
   *     MAIL            - Почтой
   *     TELEGRAPH       - Телеграфом
   *
   */
  sendType: string;

  /**
   * Очередность
   *
   * @format int32
   */
  priority?: number;

  /**
   * Данные о плательщике
   *
   */
  payer: PaymentMember;

  /**
   * Данные о получателе
   *
   */
  receiver: PaymentMember;

  /**
   * Назначение платежа
   *
   */
  ground: string;

  /**
   * Признак налогового платежа
   *
   */
  isTaxPayment: boolean;

  /**
   * Статус отправителя
   *
   */
  taxPayerStatus?: string;

  /**
   * Код КБК
   *
   */
  kbk?: string;

  /**
   * Код ОКТМО
   *
   */
  oktmo?: string;

  /**
   * Код (УИН/УИП)
   *
   */
  uin?: string;

  /**
   * Условие оплаты (только для ПТ):
   *     1 - без акцепта
   *     2 - с акцептом
   *
   * @format int32
   */
  conditionPayment?: number;

  /**
   * Срок для акцепта (только для ПТ):
   *     1, 2, 3, 4, 5
   *
   * @format int32
   */
  acceptancePeriod?: number;

  /**
   * Основание налогового платежа
   *
   */
  taxPaymentGround?: string;

  /**
   * Налоговый период
   *
   */
  taxPeriod?: string;

  /**
   * Номер документа
   *
   */
  taxDocNumber?: string;

  /**
   * Дата документа
   *
   */
  taxDocDate?: string;

  /**
   * Код выплат
   *
   */
  payType?: string;

  /**
   * Код вида дохода
   *
   */
  incomeCode?: string;

  /**
   * Удержано по исполнительному документу
   *
   */
  holdByExecDocSum?: number;

  /**
   * Код валютной операции
   *
   */
  curOperKindCode?: string;

  /**
   * Идентификатор платежного документа
   *
   */
  communalServicesId?: string;

  /**
   * Идентификатор услуги ЖКХ (ЖКУ)
   *
   */
  communalServicesServiceId?: string;

  /**
   * Номер платежного документа (ПДИ)
   *
   */
  communalServicesDocNum?: string;

  /**
   * Единый лицевой счет (ЕЛС)
   *
   */
  communalServicesSpa?: string;

  /**
   * Номер лицевого счета (ЛСИ)
   *
   */
  communalServicesAccNum?: string;

  /**
   * Период оплаты
   *
   */
  communalServicesPeriod?: string;

  /**
   * ИНН налогоплательщика (платеж за третье лицо)
   *
   */
  innTaxPayer?: string;

  /**
   * КПП налогоплательщика (платеж за третье лицо)
   *
   */
  kppTaxPayer?: string;

  /**
   * Наименование налогоплательщика (платеж за третье лицо)
   *
   */
  taxPayerName?: string;

  /**
   * Адрес налогоплательщика (платеж за третье лицо)
   *
   */
  taxPayerAddress?: string;

  /**
   * Права пользователя на действия с шаблоном
   *
   */
  accessRights: DocumentAccessRights;
}

/**
 * Подробная информация о шаблоне Распоряжения на зачисление средств
 */
export interface WageTransferTemplateRequest {
  /**
   * Признак сохранения с имеющимися предупреждениями
   *
   */
  ignoreWarning: boolean;

  /**
   * Идентификатор текущего клиента от имени которого создается шаблон
   *
   * @format int64
   */
  clientId: number;

  /**
   * Наименование шаблона
   *
   */
  name: string;

  /**
   * Код вида документа
   *
   */
  kind: string;

  /**
   * Общая сумма перечисления
   *
   */
  totalSum: number;

  /**
   * Внешний платеж
   *
   */
  external: boolean;

  /**
   * Зачисление сотрудникам за счет бюджетов РФ
   *
   */
  budjet: boolean;

  /**
   * Зачисление сотрудникам-нерезидентам
   *
   */
  notResident: boolean;

  /**
   * Идентификатор договора в АБС
   *
   */
  contract: string;

  /**
   * Дата договора
   *
   * @format date
   */
  contractDate: string;

  /**
   * Номер реестра
   *
   */
  reestrNumber: string;

  /**
   * Список сотрудников
   *
   */
  wageTransferEmployee: WageTransferEmployee[];

  /**
   * Сформировать ПП на перечисление
   *
   */
  transfer: boolean;

  /**
   * Номер документа
   *
   */
  paymentNumber?: string;

  /**
   * Дата документа
   *
   * @format date
   */
  paymentDate?: string;

  /**
   * Вид платежа
   *
   */
  paymentTypeCode?: string;

  /**
   * Очередность
   *
   * @format int32
   */
  paymentPriority?: number;

  /**
   * Код вида доходов
   *
   */
  incomeTypeCode?: string;

  /**
   * Удержано по исполнительному документу
   *
   */
  paymentExecSum?: number;

  /**
   * Счет списания
   *
   */
  paymentPayer?: string;

  /**
   * БИК банка плательщика
   *
   */
  paymentPayerBankBIC?: string;

  /**
   * Название банка плательщика
   *
   */
  paymentPayerBankName?: string;

  /**
   * Счет банка плательщика
   *
   */
  paymentPayerBankCorrAcc?: string;

  /**
   * Счет зачисления
   *
   */
  paymentReceiverAcc?: string;

  /**
   * БИК банка получателя
   *
   */
  paymentReceiverBankBIC?: string;

  /**
   * Название банка получателя
   *
   */
  paymentReceiverBankName?: string;

  /**
   * Счет банка получателя
   *
   */
  paymentReceiverBankCorrAcc?: string;

  /**
   * Назначение платежа
   *
   */
  ground?: string;

  /**
   * Код вида операции
   *
   */
  codeOperationValue?: string;

  /**
   * Список идентификаторов платежей
   *
   */
  paymentRef?: number[];

  /**
   * Информация о внешних платежах
   *
   */
  externalRef?: WageExternal[];

  /**
   * Сформировать ПП на комиссию за перечисление
   *
   */
  commission: boolean;

  /**
   * Очередность платежа комиссии
   *
   * @format int32
   */
  commissionPriority?: number;

  /**
   * Счет списания комиссии
   *
   */
  commissionDebit?: string;

  /**
   * Общая сумма комиссии
   *
   */
  commissionTotalSum?: number;

  /**
   * Счет зачисления комиссии
   *
   */
  commissionCreditAcc?: string;

  /**
   * Назначение платежа по комиссии
   *
   */
  commissionGround?: string;
}

/**
 * Подробная информация о шаблоне
 */
export interface TemplateRequest {
  /**
   * Признак сохранения с имеющимися предупреждениями
   *
   */
  ignoreWarning: boolean;

  /**
   * Признак добавления получателя в справочник контрагентов
   *
   */
  addCorrespondent?: boolean;

  /**
   * Идентификатор текущего клиента от имени которого создается шаблон
   * @format int64
   */
  clientId?: number;

  /**
   * Название шаблона
   *
   */
  name: string;

  /**
   * Сумма операции
   *
   */
  amount?: number;

  /**
   * Код вида документа:
   *     PAYMENT_ORDER   - ПП
   *     PAYMENT_DEMAND  - ПТ
   *     PAYMENT_INCASSO - ИП
   *
   */
  kind: string;

  /**
   * Способ отправки:
   *     EMPTY           - Пусто
   *     URGENT          - Срочно
   *     ELECTRONICALLY  - Электронно
   *     MAIL            - Почтой
   *     TELEGRAPH       - Телеграфом
   *
   */
  sendType: string;

  /**
   * Очередность
   *
   * @format int32
   */
  priority: number;

  /**
   * Данные о плательщике
   *
   */
  payer: PaymentMember;

  /**
   * Данные о получателе
   *
   */
  receiver: PaymentMember;

  /**
   * Назначение платежа
   *
   */
  ground: string;

  /**
   * Признак налогового платежа
   *
   */
  isTaxPayment: boolean;

  /**
   * Статус отправителя
   *
   */
  taxPayerStatus?: string;

  /**
   * Код КБК
   *
   */
  kbk?: string;

  /**
   * Код ОКТМО
   *
   */
  oktmo?: string;

  /**
   * Код (УИН/УИП)
   *
   */
  uin?: string;

  /**
   * Идентификатор документа в АУСН
   *
   */
  ausnId?: string;

  /**
   * Тип документа полученный из АУСН
   *
   */
  documentType?: string;

  /**
   * Условие оплаты (только для ПТ):
   *     1 - без акцепта
   *     2 - с акцептом
   *
   * @format int32
   */
  conditionPayment?: number;

  /**
   * Срок для акцепта (только для ПТ):
   *     1, 2, 3, 4, 5
   *
   * @format int32
   */
  acceptancePeriod?: number;

  /**
   * Основание налогового платежа
   *
   */
  taxPaymentGround?: string;

  /**
   * Налоговый период
   *
   */
  taxPeriod?: string;

  /**
   * Номер документа
   *
   */
  taxDocNumber?: string;

  /**
   * Дата документа
   *
   */
  taxDocDate?: string;

  /**
   * Код выплат
   *
   */
  payType?: string;

  /**
   * Код вида дохода
   *
   */
  incomeCode?: string;

  /**
   * Удержано по исполнительному документу
   *
   */
  holdByExecDocSum?: number;

  /**
   * Код валютной операции
   *
   */
  curOperKindCode?: string;

  /**
   * Идентификатор платежного документа
   *
   */
  communalServicesId?: string;

  /**
   * Идентификатор услуги ЖКХ (ЖКУ)
   *
   */
  communalServicesServiceId?: string;

  /**
   * Номер платежного документа (ПДИ)
   *
   */
  communalServicesDocNum?: string;

  /**
   * Единый лицевой счет (ЕЛС)
   *
   */
  communalServicesSpa?: string;

  /**
   * Номер лицевого счета (ЛСИ)
   *
   */
  communalServicesAccNum?: string;

  /**
   * Период оплаты
   *
   */
  communalServicesPeriod?: string;

  /**
   * ИНН налогоплательщика (платеж за третье лицо)
   *
   */
  innTaxPayer?: string;

  /**
   * КПП налогоплательщика (платеж за третье лицо)
   *
   */
  kppTaxPayer?: string;

  /**
   * Наименование налогоплательщика (платеж за третье лицо)
   *
   */
  taxPayerName?: string;

  /**
   * Адрес налогоплательщика (платеж за третье лицо)
   *
   */
  taxPayerAddress?: string;
}

/**
 * Структура ответа сохранения шаблона
 */
export interface TemplateResponse {
  /**
   * Идентификатор созданного шаблона
   *
   */
  id: string;

  /**
   * Данные о доступных операциях с шаблоном
   *
   */
  accessRights: DocumentAccessRights;
}

/**
 * Заявление на отзыв документа
 */
export interface Revoke {
  /**
   * Идентификатор заявления на отзыв документа
   *
   */
  id: string;

  /**
   * Номер документа отзыва
   *
   */
  number?: string;

  /**
   * Тип отзыва:
   *     PAYMENT
   *
   */
  type: string;

  /**
   * Код статуса заявки на отзыв
   *
   */
  state: string;

  /**
   * Причина отзыва документа
   *
   */
  reason: string;

  /**
   * Данные о платежном документе
   *
   */
  payment?: RevokePayment;

  /**
   * Права пользователя на действия с документом
   *
   */
  accessRights: DocumentAccessRights;
}

/**
 * Структура платежа в отзыве платежа
 */
export interface RevokePayment {
  /**
   * Идентификатор платежного документа
   *
   */
  id: string;

  /**
   * Номер платежного документа
   *
   */
  number: string;

  /**
   * Дата платежного документа
   *
   * @format date
   */
  date: string;

  /**
   * Код вида платежного документа:
   *     PAYMENT_ORDER   - ПП
   *     PAYMENT_DEMAND  - ПТ
   *     PAYMENT_INCASSO - ИП
   *
   */
  kind: string;

  /**
   * Признак перевода между своими счетами у платежного документа
   *
   */
  isTransfer: boolean;

  /**
   * Сумма платежа
   *
   */
  amount: number;

  /**
   * Буквенный ISO-код валюты платежа
   *
   */
  currency: string;

  /**
   * Наименование контрагента
   *
   */
  correspondent: string;

  /**
   * Назначение платежа
   *
   */
  ground: string;
}

export interface BannersResponse {
  /** Баннеры */
  banners: Banner[];
}

export interface Banner {
  /**
   * Идентификатор баннера
   *
   * @format int64
   */
  id: number;

  /**
   * Заголовок текста баннера
   *
   */
  bannerTitle: string;

  /**
   * Текст баннера (полный)
   *
   */
  text: string;

  /**
   * Текст баннера (сокращенный)
   *
   */
  textShort: string;

  /**
   * Показывать кнопку
   *
   */
  showButton: boolean;

  /**
   * Текст баннера
   *
   */
  buttonText: string;

  /**
   * Цвет баннера
   *
   */
  buttonColor: string;

  /**
   * Признак просмотра баннера
   *
   */
  isViewed: boolean;

  /**
   * Цвет текста кнопки
   *
   */
  buttonTextColor: string;

  /**
   * URL-адрес ссылки ДБО
   *
   */
  urlDBO: string;
}

export interface BannersMobileResponse {
  /** Баннеры */
  banners: MobileBanner[];
}

export interface MobileBanner {
  /**
   * Идентификатор баннера
   *
   * @format int64
   */
  id: number;

  /**
   * Признак просмотра баннера
   *
   */
  isViewed: boolean;

  /**
   * Текст баннера для отображения в ленте (превью)
   *
   */
  previewText: string;

  /**
   * Заголовок баннера
   *
   */
  bannerTitle: string;

  /**
   * Текст баннера (полный)
   *
   */
  bannerSubtitle: string;

  /**
   * Показывать кнопку
   *
   */
  showButton: boolean;

  /**
   * Текст баннера
   *
   */
  buttonText: string;

  /**
   * Цвет баннера
   *
   */
  buttonColor: string;

  /**
   * Цвет текста кнопки
   *
   */
  buttonTextColor: string;

  /**
   * URL-адрес ссылки для кнопки
   *
   */
  buttonLink: string;

  /**
   * Ссылка на иконку для отображения в ленте (превью)
   *
   */
  previewIcon: string;

  /**
   * Ссылка на изображение в ленте (превью)
   *
   */
  previewBackgroundImage: string;

  /**
   * Ссылка на иконку для отображения при просмотре
   *
   */
  viewIcon: string;

  /**
   * Ссылка на изображение для отображения при просмотре
   *
   */
  viewBackgroundImage: string;
}

/**
 * Валюта для оформления заявок на покупку/продажу/конверсию валюты
 */
export interface Currency {
  /**
   * Идентификатор валюты
   *
   * @format int64
   */
  id?: number;

  /**
   * Валюта (буквенный ISO-код валюты)
   *
   */
  code: string;

  /**
   * Валюта (цифровой ISO-код валюты)
   *
   * @format int64
   */
  numberCode?: number;

  /**
   * Наименование валюты
   *
   */
  name: string;

  /**
   * Код графического символа
   *
   */
  symbol?: string;
}

/**
 * Запрос на закрытие баннера
 */
export interface CloseRequest {
  /**
   * Список id выбранных для закрытия баннеров
   *
   * @format int64
   */
  bannerIdList: number[];
}

/**
 * Запрос на закрытие баннера
 */
export interface DocumentsIdRequest {
  /**
   * Список id документов
   *
   * @format int64
   */
  documentIdList: number[];
}

/**
 * Структура ответа со списком писем
 */
export interface LettersResponse {
  /** Признак того, возможна ли дальнейшая постраничная подгрузка */
  hasMore: boolean;

  /** Общее количество страниц */
  totalPages?: number;

  /** Общее количество писем */
  totalLetters?: number;

  /** Список писем */
  data: LetterInfo[];
}

/**
 * Структура ответа со списком писем
 */
export interface LettersSearchResponse {
  /** Признак того, возможна ли дальнейшая постраничная подгрузка */
  hasMore?: boolean;

  /** Общее количество страниц */
  totalPages?: number;

  /** Общее количество писем */
  totalLetters?: number;

  /** Список писем */
  data: LetterSearchInfo[];
}

/**
 * Структура ответа с разрешениями
 */
export interface LettersPermissions {
  permissions?: EntityPermission[];
}

/**
 * Структура ответа на отправку письма
 */
export interface LetterSendResponse {
  /**
   * Идентификатор письма
   *
   */
  id: string;

  /**
   * Номер документа
   *
   */
  documentNumber?: string;

  /**
   * Требуется подписание письма
   *
   */
  signRequired?: boolean;

  /**
   * Отправлено
   *
   */
  isSent: boolean;
}

/**
 * Структура ответа письма
 */
export interface LetterInfo {
  /** Идентификатор письма */
  id: string;

  /** Номер документа */
  documentNumber?: string;

  /**
   * Дата отправки письма
   * @format date-time
   */
  sendDate?: string;

  /**
   * Дата создания письма
   * @format date-time
   */
  createDate?: string;

  /** Признак, что письмо прочитано */
  isRead?: boolean;

  /** Отправитель */
  sender?: MailAddressItem;

  /** Получатель */
  recipient?: MailAddressItem;

  /** Заголовок письма */
  subject?: string;

  /** Текст письма */
  text?: string;

  /** Признак, что письмо сгенерировано автоматически */
  isAuto?: boolean;

  /** Признак, что письмо относится к папке Входящие */
  isInbox?: boolean;

  /** Тип письма */
  mailType?: string;

  /** Признак, что письмо помечено как важное */
  isImportant?: boolean;

  /** Идентификатор письма на которое отвечаем */
  parentMessage?: string;

  /** Список вложений */
  attachments?: AttachmentInfo[];
  permissions?: EntityPermission[];
}

/**
 * Параметры для вложения
 */
export interface AttachmentParamsInfo {
  /**
   * Максимальный размер вложений
   * @format int64
   */
  maxTotalSize?: number;
  types?: string[];
}

/**
 * Поисковой результат письма
 */
export interface LetterSearchInfo {
  /** Данные письма */
  data: LetterInfo;

  /**
   * Тип письма для клиента:
   * INBOX
   * OUTBOX
   * DRAFT
   *
   */
  type: string;
}

/**
 * Информация о вложении
 */
export interface AttachmentInfo {
  /**
   * ID вложения
   * @format int64
   */
  id?: number;

  /** Название файла */
  name?: string;

  /**
   * Размер файла в байтах
   * @format int64
   */
  size?: number;

  /** Позиция файла */
  position?: number;

  /** Формат вложения */
  format?: string;
}

/**
 * Информация о вложениях в письме
 */
export interface AttachmentsResponse {
  /**
   * Общий размер вложений
   * @format int64
   */
  totalSize?: number;

  /**
   * Количество вложений
   * @format int64
   */
  totalAttachments?: number;

  /** Список вложений */
  data?: AttachmentInfo[];
}

/**
 * Запрос и редактировании вложений
 */
export interface EditFilesRequest {
  /** @format int64 */
  removeFileList?: number[];

  /** Список новых вложений */
  addFileList?: AttachmentRequest[];
}

/**
 * Информация о вложении
 */
export interface AttachmentRequest {
  /** Имя файла */
  fileName: string;

  /**
   * Файл в формате base64
   * @format base64
   */
  encodedString: string;
}

/**
 * Вложение
 */
export interface AttachmentResponse {
  /**
   * Файл в формате base64
   * @format base64
   */
  encodedString?: string;
}

/**
 * Подробная информация о письме
 */
export interface LetterRequest {
  /** Заголовок письма */
  subject?: string;

  /**
   * Получатель письма
   * @format int64
   */
  recipient?: number;

  /** Текст письма */
  text?: string;

  /** Признак, что письмо является уведомлением */
  isAnnouncement?: boolean;

  /** Список вложений */
  attachments?: AttachmentRequest[];

  /** Идентификаторы удаленных вложений */
  "removed-files"?: number[];
}

/**
 * Структура ответа со списком почтовых адресов
 */
export interface SendToResponse {
  /** Список адресов */
  data?: MailAddressItem[];
}

/**
 * Почтовый адрес
 */
export interface MailAddressItem {
  /**
   * id адреса в системе
   * @format int64
   */
  id?: number;

  /** uuid адреса */
  uuid?: string;

  /** Имя адресата */
  name?: string;
}

/**
 * Результат импорта из 1С
 */
export interface ImportResponse {
  /** Общее количество документов для импорта */
  documentsCount?: number;

  /** Количество импортированных документов */
  importedCount?: number;

  /** Массив ошибок */
  errors?: string[];
}

/**
 * Результат импорта Распоряжения на зачисление средств сотрудникам
 */
export interface WageTransferImportResponse {
  /**
   * Дата документа
   *
   * @format date
   */
  date?: string;

  /**
   * Номер документа
   *
   */
  number?: string;

  /**
   * Дата реестра
   *
   * @format date
   */
  registryDate?: string;

  /**
   * Номер платежа
   *
   */
  paymentNumber?: string;

  /**
   * Номер счета
   *
   */
  paymentAccount?: string;

  /**
   * Наименование банка
   *
   */
  paymentBankName?: string;

  /**
   * БИК банка
   *
   */
  paymentBankBIC?: string;

  /**
   * Список сотрудников
   *
   */
  wageTransferEmployee?: WageTransferEmployee[];

  /**
   * Общая сумма перечисления
   *
   */
  totalSum?: number;

  /**
   * Внешний платеж
   *
   */
  external?: boolean;

  /**
   * Информация о внешних платежах
   *
   */
  externalRef?: WageExternal[];

  /** Массив остальных ошибок */
  errors?: string[];

  /** Массив ошибок парсинга данных платежа */
  paymentErrors?: string[];
}

/**
 * Параметры запроса Подписание документа Распоряжения на зачисление средств сотрудникам в рамках зарплатного проекта с помощью PayControl
 */
export interface WageTransferSignRequest {
  /**
   * Идентификатор клиента
   *
   * @format int64
   */
  clientId: number;

  /**
   * Код подтверждения (отсутствует для документов в статусе "Подписан")
   *
   */
  confirmationCode?: string;

  /**
   * MAC-адрес клиента
   *
   */
  macAddress?: string;

  /**
   * IP-адрес клиента
   *
   */
  ipAddress?: string;
}

/**
 * Параметры запроса Подписание документа Распоряжения на зачисление средств сотрудникам в рамках зарплатного проекта с помощью PayControl 5.3
 */
export interface WageTransferPC53SignRequest {
  /**
   * MAC-адрес клиента
   *
   */
  macAddress?: string;

  /**
   * IP-адрес клиента
   *
   */
  ipAddress?: string;
}

/**
 * Ответ на запрос: Подписание документа Распоряжения на зачисление средств сотрудникам в рамках зарплатного проекта с помощью PayControl 5.3
 */
export interface WageTransferPC53SignResponse {
  /**
   * Идентификатор транзакции
   *
   */
  transactionId: string;
}

/**
 * Структура глобальных настроек приложения
 */
export interface GlobalSettingsResponse {
  /**
   * Таймаут для прокрутки слайдера историй, мс
   * @format int64
   */
  storiesTimeout: number;

  /**
   * Время отображения истории, календарный день
   * @format int64
   */
  storiesActiveTime: number;

  /**
   * Время в течение которого не требуется повторно вызывать сервис
   * @format int64
   */
  serviceInvokeTimeBreak?: number;

  /** Значения через запятую поля 101 для ввода ИНН, отличного от ИНН клиента */
  values101?: string;

  /** Настройки выписки */
  extractSettings?: ExtractSettings;

  /**
   * Значение глобального параметра "Предупредить за количество дней" (DictOptionRes.NOTICE_OPTION_DAY_COUNT)
   *
   * @format int64
   */
  noticeOptionDayCount?: number;

  /** Ссылка ведущая на сайт ФНС */
  ftsLink?: string;

  /** Ссылка ведущая на анкету обновления идентфикационных данных */
  updateIdentificationDataLink?: string;

  /** Ссылка на Условия присоединения к ДБО */
  dboLink?: string;

  /** Текст предупреждения об обязательной продаже валютной выручки */
  saleCurrencyEarningsText?: string;

  /** Включена обработка валютного документа Валютный платеж */
  paymentOrderCurrencyEnabled?: boolean;

  /** Включена обработка валютного документа Заявка на покупку/продажу/конверсию иностранной валюты */
  docConverseCurrencyEnabled?: boolean;

  /** Включена обработка валютного документа Распоряжение по транзитному счету */
  docObSaleEnabled?: boolean;

  /** Включена обработка валютных Договоры ВЭД */
  agreementCurrencyEnabled?: boolean;

  /** Включена обработка валютных Запрос информации ВК */
  requestCurControlInfoCurrencyEnabled?: boolean;

  /** Включена обработка валютных документов Заявление о внесении изменений */
  changeContractInfoCurrencyEnabled?: boolean;

  /** Включена обработка валютных документов Заявление о снятии с учёта контракта/кредитного договора */
  closeContractInfoCurrencyEnabled?: boolean;

  /** Включена обработка валютных документов Справка о подтверждающих документах */
  certConDocCurrencyEnabled?: boolean;

  /** Включена обработка валютных документов Сведения о контракте для постановки на учет */
  contractRegCurrencyEnabled?: boolean;

  /** Включена обработка валютных документов Информация о валютных операциях */
  ivoCurrencyEnabled?: boolean;

  /** Включена обработка валютных Зачислений */
  enrolmentCurrencyEnabled?: boolean;

  /** Доступность функционала Тарифы в главном меню */
  tariffsMenuEnabled?: boolean;

  /** Включен досыл документов для ВЭД */
  vedAddFileSendingEnabled?: boolean;

  /** Включена обработка валютных документов Запросы ВБК */
  vbkInfoCurrencyEnabled?: boolean;

  /** Включена обработка валютных документов Отзывы */
  revokeCurrencyEnabled?: boolean;
}

/**
 * Структура настроек микросервиса для конкретного клиента
 */
export interface MsSettingsResponse {
  /** Использование микросервиса */
  isAvailable: boolean;
}

/**
 * Структура настроек стойкости пароля
 */
export interface StrengthSettingsResponse {
  /**
   * Минимальная длина пароля пользователя
   * @format int64
   */
  minLength?: number;

  /**
   * Максимальная длина пароля пользователя
   * @format int64
   */
  maxLength?: number;

  /** Набор символов, разрешённых в паролях на вход в систему */
  allowedChars?: string;

  /** Набор спец символов, разрешённых в паролях на вход в систему */
  specialAllowedChars?: string;

  /**
   * Минимальное количество знаков, совпадающих с предыдущим паролем
   * @format int64
   */
  differentCharsLength?: number;

  /** Регулярное выражение для обязательных символов */
  requiredChars?: string;

  /** Обязательные спецсимволы */
  specialRequiredChars?: string;

  /** Группа символов */
  charsGroup?: CharsGroup[];
}

/**
 * Структура настроек стойкости пароля
 */
export interface JCWebClientResponse {
  /** Лицензия JCWebClient */
  JCWebClientLicense?: string;
}

export interface CharsGroup {
  /** Название группы */
  name?: string;

  /** Является ли группа разрешённой */
  allowedGroup?: boolean;

  /** Является ли группа обязательной */
  requiredGroup?: boolean;
}

export interface LetterCountResponse {
  /**
   * Количество писем
   * @format int64
   */
  count: number;
}

/**
 * Структура ответа настроек выписки
 */
export interface ExtractSettings {
  /**
   * Максимальный диапазон выписки (дней)
   * @format int64
   */
  maxRangeMonths: number;

  /**
   * Максимальная глубина выписки (лет)
   * @format int64
   */
  maxDepthYears: number;
}

/**
 * Структура запроса выписки списка счетов
 */
export interface ExtractAccountsRequest {
  /**
   * Начальная дата
   * @format date
   */
  fromDate: string;

  /**
   * Конечная дата
   * @format date
   */
  toDate: string;

  /** С итогами по дням */
  dayTotal?: boolean;

  /** С покрытием в национальной валюте */
  national?: boolean;

  /** Включить назначение платежа */
  itemDesc?: boolean;

  /** С электронной подписью */
  withSig?: boolean;

  /** Без нулевых оборотов */
  withoutZero?: boolean;

  /** Не упаковывать выписку в архив, если единственный счет и нет электронной подписи */
  withoutZip?: boolean;

  /** Буквенные ISO-коды валют, для которых включить курс ЦБ на текущую дату */
  currencyRates?: string[];

  /** Формат файла для экспорта */
  type?: string;

  /**
   * Разделы выписки
   * - WITH_DOCUMENTS    - табличная часть с документами  (по умолчанию)
   * - WITHOUT_DOCUMENTS - табличная часть без документов
   * - ONLY_DOCUMENTS    - документы без табличной части
   *
   */
  sections?: string;

  /** E-mail назначения */
  email?: string;

  /** Идентификаторы счетов */
  accounts: number[];

  /** Хеш код запроса выписки */
  requestHash?: string;
}

/**
 * Структура ответа выписки
 */
export interface ExtractResponse {
  /**
   * Начальная дата
   * @format date
   */
  fromDate: string;

  /**
   * Конечная дата
   * @format date
   */
  toDate: string;

  /** Курсы ЦБ на текущую дату */
  currencyRates?: ExtractCurrencyRate[];

  /** Хеш код запроса выписки */
  reqeuestHash?: string;
  items: ExtractItem[];
}

/**
 * Выписка по счету
 */
export interface ExtractItem {
  /** Номер счета */
  account: string;

  /** Наименование счета, включая информацию о подопечных для номинальных счетов */
  accountName?: string;

  /** Буквенный ISO-код валюты счёта */
  currency: string;

  /** Сумма оборотов по дебету в валюте счета */
  amountDb: number;

  /** Сумма оборотов по дебету в рублях */
  amountDbRub?: number;

  /** Сумма оборотов по кредиту в валюте счета */
  amountCr: number;

  /** Сумма оборотов по кредиту в рублях */
  amountCrRub?: number;

  /** Входящий остаток в валюте счета */
  begShDate: number;

  /** Входящий остаток в рублях */
  begShDateRub?: number;

  /** Исходящий остаток в валюте счета */
  endShDate: number;

  /** Исходящий остаток в рублях */
  endShDateRub?: number;
  dayTotal?: ExtractItemDayTotal[];
  operations?: ExtractItemOperation[];
}

/**
 * Итоги по дням
 */
export interface ExtractItemDayTotal {
  /**
   * Дата, на которую предоставлена информация
   * @format date
   */
  balanceDate: string;

  /** Итого обороты за день по дебету в валюте счета */
  dayAmountDb: number;

  /** Итого обороты за день по дебету в рублях */
  dayAmountDbRub?: number;

  /** Итого обороты за день по кредиту в валюте счета */
  dayAmountCr: number;

  /** Итого обороты за день по кредиту в рублях */
  dayAmountCrRub?: number;

  /** Входящий остаток за день в валюте счета */
  dayBegShDate: number;

  /** Входящий остаток за день в рублях */
  dayBegShDateRub?: number;

  /** Исходящий остаток за день в валюте счета */
  dayEndShDate: number;

  /** Исходящий остаток за день в рублях */
  dayEndShDateRub?: number;

  /** Сумма операций за день (исх. ост. - вх. ост.) */
  operationResult?: number;

  /** Сумма операций за день в рублях (исх. ост. руб - вх. ост. руб) */
  operationResultRub?: number;
}

/**
 * Описание выполненных операций по счёту
 */
export interface ExtractItemOperation {
  /**
   * Дата операции
   * @format date
   */
  date: string;

  /** Описание операции или назначение */
  desc?: string;

  /** Знак операции */
  sign: string;

  /** Сумма операции в валюте счета */
  amount: number;

  /** Сумма операции в рублях */
  amountRub?: number;

  /** Номер документа */
  documentNumber?: string;

  /** Дата документа */
  documentDate?: string;

  /** Код вида документа */
  kind?: string;

  /** Способ отправки */
  sendType?: string;

  /** Очередность */
  priority?: string;

  /** Статус отправителя 101 */
  taxPayerStatus?: string;

  /** КБК 104 */
  kbk?: string;

  /** ОКТМО 105 */
  oktmo?: string;

  /** Уникальный идентификатор начисления */
  uin?: string;

  /** Основание налогового платежа 106 */
  taxPaymentGround?: string;

  /** Налоговый период 107 */
  taxPeriod?: string;

  /** Номер налогового документа 108 */
  taxDocNumber?: string;

  /**
   * Дата налогового документа
   * @format date
   */
  taxDocDate?: string;

  /** Дата налогового документа */
  taxDocDateString?: string;

  /** Код вида дохода */
  incomeCode?: string;

  /** Данные о плательщике */
  payer?: PaymentMember;

  /** Данные о получателе */
  receiver?: PaymentMember;
}

/**
 * Курс ЦБ валюты на дату
 */
export interface ExtractCurrencyRate {
  /**
   * Дата курса ЦБ
   * @format date
   */
  date: string;

  /** Буквенный ISO-код валюты */
  currencyISO: string;

  /**
   * Курс ЦБ валюты
   * @format double
   */
  currencyRateCB: number;
}

/**
 * Структура запроса обновления access токена
 */
export interface RefreshTokenRequest {
  /** Access токен с истекшим сроком */
  expiredAccessToken: string;
}

/**
 * Структура ответа обновления access токена
 */
export interface RefreshTokenResponse {
  /** Access токен */
  jwt?: string;
}

/**
 * Информация о типе подписания документа а также о ниличии у него подписей
 */
export interface DocumentCheckSignResponse {
  /**
   * Тип подписи
   *
   */
  typeSign: string;

  /**
   * Количество подписей
   *
   * @format int64
   */
  countOfSign: number;
}

/**
 * Параметры запроса для подписания документа
 */
export interface DocumentSigningRequest {
  /**
   * Идентификатор документа
   *
   * @format int64
   */
  documentId: number;

  /**
   * Идентификатор сертификата
   *
   */
  certId: string;

  /**
   * Подпись
   *
   * @format base64
   */
  signature: string;
}

/**
 * Параметры запроса установки признака прочитанности раздела меню
 */
export interface MenuInfoRequest {
  /**
   * Строковый идентификатор раздела меню
   *
   */
  strId: string;
}

/**
 * Структура раздела меню
 */
export interface MenuInfo {
  /**
   * Строковый идентификатор раздела
   *
   */
  strId: string;

  /**
   * Название раздела
   *
   */
  name?: string;

  /**
   * Описание раздела
   *
   */
  desc?: string;
}

/**
 * Создание заявления на отзыв документа
 */
export interface RevokeRequest {
  /**
   * Идентификатор клиента
   * @format int64
   */
  clientId: number;

  /** Ид. документа, который необходимо отозвать */
  id: string;

  /** Причина отзыва документа */
  reason: string;

  /**
   * Код причины отзыва документа
   * @example OTHER_REASON
   */
  revokeReason?: string;
}

/**
 * Информация заявления на отзыв документа
 */
export interface RevokeResponse {
  /**
   * Ид. документа
   * @format int64
   */
  id: number;

  /** Номер документа */
  number: string;

  /**
   * Дата документа
   * @format date
   */
  date: string;

  /** Статус документа */
  state: string;

  /**
   * Ид. отзываемого документа
   * @format int64
   */
  documentRefId?: number;

  /** Номер отзываемого документа */
  documentRefNumber?: string;

  /**
   * Дата отзываемого документа
   * @format date
   */
  documentRefDate?: string;

  /** Тип отзываемого документа */
  documentRefType?: string;

  /**
   * Код причины отзыва документа
   * @example OTHER_REASON
   */
  revokeReason?: string;

  /** Причина отзыва документа */
  reason?: string;
  permissions?: EntityPermission[];
}

/**
 * Информация о блокировке по счету
 */
export interface AccountBlockInfo {
  /**
   * Дата начала блокировки
   *
   */
  startDate: string;

  /**
   * Сумма блокировки
   *
   */
  amountBlockInfo?: number;

  /**
   * Сумма блокировки в национальной валюте
   *
   */
  amountNationalBlockInfo?: number;

  /**
   * Лимит остатка
   *
   */
  limitBlockInfo?: number;

  /**
   * Код органа, установившего блокировку
   *
   */
  authorityCode?: string;

  /**
   * Наименование органа, установившего блокировку
   *
   */
  authorityName?: string;

  /**
   * Тип постановления
   *
   */
  resolutionType?: string;

  /**
   * Номер постановления
   *
   */
  resolutionNumber?: string;

  /**
   * Дата постановления
   *
   * @format date
   */
  resolutionDate?: string;

  /**
   * Тип блокировки
   *
   */
  blockType?: string;

  /**
   * Код типа блокировки
   *
   */
  blockTypeCode?: string;
}

/**
 * Информация о документе из выписки по Картотеке №2 по счету
 */
export interface AccountStatementK2 {
  /**
   * Номер документа
   *
   */
  documentNumber: string;

  /**
   * Дата документа
   *
   * @format date
   */
  documentDate: string;

  /**
   * Наименование получателя средств
   *
   */
  receiverName: string;

  /**
   * Первоначальная сумма документа
   *
   */
  initialAmount: number;

  /**
   * Сумма остатка, подлежащего списанию
   *
   */
  balance: number;

  /**
   * Назначение платежа
   *
   */
  ground: string;

  /**
   * Буквенный ISO-код валюты
   *
   */
  currency?: string;

  /**
   * Счет получателя
   *
   */
  receiverAccount?: string;

  /**
   * Идентификатор клиента
   * @format int64
   */
  parentDocumentId?: number;
}

/**
 * Счет-фактура
 */
export interface InvoiceRequest {
  /**
   * Идентификатор текущего клиента от имени которого создается документ
   * @format int64
   */
  clientId: number;

  /** Номер документа */
  number: string;

  /** Признак сохранения с имеющимися предупреждениями */
  ignoreWarning: boolean;

  /**
   * Дата документа
   * @format date
   */
  date: string;

  /** Список товаров/услуг по счету */
  goodsList: InvoiceGoodsItem[];

  /** Общая сумма по счету */
  amount?: number;

  /**
   * Значение налоговой ставки.
   * Если 0, то o	НДС не облагается.
   * Если null, то НДС не указана.
   *
   */
  taxRate?: number;

  /** Номер счета зачисления */
  receiverAccountNumber: string;

  /** Плательщик по счету */
  payer: InvoicePayer;

  /** Список подписантов счета-фактуры */
  signers: InvoiceSigner[];
}

/**
 * Плательщик по счету
 */
export interface InvoicePayer {
  /**
   * Идентификатор плательщика (заполняется, если плательщик был выбран из справочника)
   * @format int64
   */
  id?: number;

  /** Наименование плательщика */
  name: string;

  /** ИНН */
  inn: string;

  /** КПП */
  kpp?: string;

  /** Адрес плательщика */
  address?: string;

  /** Номер договора */
  agreementNumber?: string;

  /**
   * Дата договора
   * @format date
   */
  agreementDate?: string;

  /** Список подписантов счета-фактуры */
  signers?: InvoiceSigner[];

  /** Признак редактирования позиции в справочнике */
  isEdit?: boolean;
}

/**
 * Получатель по счету
 */
export interface InvoiceReceiver {
  /** Наименование получателя */
  name: string;

  /** ИНН получателя */
  inn: string;

  /** КПП получателя */
  kpp?: string;

  /**
   * Расчетный счет получателя
   * @format int64
   */
  account?: number;

  /** Номер расчетного счета получателя */
  accountNumber: string;

  /** Реквизиты банка получателя */
  bank: Bank;
}

/**
 * Подписант счета-фактуры
 */
export interface InvoiceSigner {
  /**
   * Идентификатор подписанта
   * @format int64
   */
  id?: number;

  /** ФИО подписанта */
  name: string;

  /** Должность подписанта */
  position?: string;
}

/**
 * Структура ответа на формирование счета-фактуры
 */
export interface InvoiceResponse {
  /**
   * Идентификатор выставленного счёта
   * @format int64
   */
  id?: number;

  /** Номер документа */
  number?: string;

  /** Статус выставленного счёта */
  state?: string;
}

/**
 * Структура ответа со справочником плательщиков счета-фактуры
 */
export interface InvoicePayersResponse {
  /** Признак возможности дальнейшей подгрузки */
  hasMore: boolean;

  /** Список плательщиков счета-фактуры */
  data: InvoicePayer[];
}

/**
 * Структура ответа со списком выставленных счетов
 */
export interface InvoicesInfoResponse {
  /** Признак того, возможна ли дальнейшая постраничная подгрузка */
  hasMore: boolean;

  /** Список выставленных счетов */
  invoices: InvoiceShort[];
}

/**
 * Сущность для отображения входящих документов с непрочитанными уведомлениями
 */
export interface InvoicesIncomingDocumentWithNotification {
  /**
   * Количество входящих документов с непрочитанными уведомлениями
   * @format int32
   */
  documentCount: number;
}

/**
 * Краткая информация о выставленном счете
 */
export interface InvoiceShort {
  /** Ид. счета */
  id: string;

  /**
   * Дата счета
   * @format date
   */
  date: string;

  /** Статус выставленного счёта */
  state: string;

  /**
   * Сторона выставленного счёта
   * - incoming (входящий счёт)
   * - outgoing (исходящий счёт)
   *
   */
  direction: string;

  /** Номер счета */
  number: string;

  /** Сумма счета */
  amount: number;

  /** Наименование плательщика */
  payerName: string;

  /** ИНН плательщика */
  payerInn?: string;

  /** Наименование получателя */
  receiverName: string;

  /** Номер расчетного счета получателя */
  receiverAccountNumber: string;

  /** ИНН получателя */
  receiverInn?: string;

  /** Редактирование счета разрешено */
  editable: boolean;

  /** Новое умедомление по выставленному счёту */
  hasNewNotification?: boolean;

  /**
   * Количество закрывающих документов в выставленном счёте
   * @format int32
   */
  countClousingDocuments?: number;
  permissions: EntityPermission[];
}

/**
 * Подробная информация о выставленном счете
 */
export interface InvoiceInfoResponse {
  /** Ид. счета */
  id: string;

  /**
   * Дата счета
   * @format date
   */
  date: string;

  /** Номер счета */
  number: string;

  /** Сумма счета */
  amount: number;

  /** Сумма НДС счета */
  tax: number;

  /** Суммы НДС по ставкам НДС */
  taxes: Record<string, number>;
  goodsList: InvoiceGoodsItem[];

  /** Данные о плательщике */
  payer: InvoicePayer;

  /** Данные о получателе */
  receiver: InvoiceReceiver;

  /** Список подписантов счета-фактуры */
  signers: InvoiceSigner[];

  /** E-mail для отправки счета */
  email: string;

  /** Состояние счета */
  state: string;

  /**
   * Сторона выставленного счёта
   * - incoming (входящий счёт)
   * - outgoing (исходящий счёт)
   *
   */
  direction: string;

  /** Редактирование счета разрешено */
  editable: boolean;
  permissions: EntityPermission[];
}

/**
 * Товар или услуга по выставленному счету
 */
export interface InvoiceGoodsItem {
  /**
   * Идентификатор позиции в счете
   * @format int64
   */
  id?: number;

  /**
   * Идентификатор товара/услуги
   * @format int64
   */
  goodsId?: number;

  /** Наименование товара/услуги */
  name: string;

  /** Описание товара/услуги */
  desc?: string;

  /**
   * Количество
   * @format double
   */
  quantity: number;

  /** Единица измерения */
  unit: string;

  /**
   * Идентификатор единицы измерения
   * @format int64
   */
  unitId?: number;

  /** Цена */
  price: number;

  /** Сумма позиции */
  amount?: number;

  /** Номер позиции */
  number?: number;

  /** Ставка НДС позиции */
  taxRate?: number;

  /** Признак изменения позиции в справочнике */
  isEdit?: boolean;
}

/**
 * Краткий список товаров/услуг по счету
 */
export interface InvoiceGoodsShort {
  /** Признак того, возможна ли дальнейшая постраничная подгрузка */
  hasMore: boolean;

  /** Товары/услуги по выставленному счету */
  goods: InvoiceGoodShort[];
}

/**
 * Краткая информация по товару/услуге по выставленному счету
 */
export interface InvoiceGoodShort {
  /**
   * Идентификатор товара/услуги
   * @format int64
   */
  id?: number;

  /** Наименование товара/услуги */
  name: string;

  /** Единица измерения */
  unit?: string;

  /**
   * Идентификатор единицы измерения
   * @format int64
   */
  unitId?: number;

  /** Код единицы измерения */
  unitCode?: string;

  /** Цена */
  price?: number;

  /** Ставка НДС позиции */
  taxRate?: number;
}

/**
 * Список отчетных документов по выставленному счету
 */
export interface InvoiceDocuments {
  /** Отчетные документы по выставленному счету */
  documents: InvoiceDocument[];
}

/**
 * Отчетный документ по выставленному счету
 */
export interface InvoiceDocument {
  /**
   * Идентификатор документа
   * @format int64
   */
  id: number;

  /** Номер документа */
  number: string;

  /**
   * Дата документа
   * @format date
   */
  date: string;

  /** Наименование документа */
  name: string;

  /**
   * Тип документа
   * - act (Акт выполненных работ)
   * - waybill (Накладная)
   * - taxInvoice (Счет-фактура)
   *
   */
  docType: string;

  /** Документ прочитан получателем */
  receiverRead: boolean;

  /** Документ отправлен получателю по email */
  receiverSent: boolean;
}

/**
 * Список единиц измерения товаров/услуг по счету
 */
export interface InvoiceUnits {
  /** Единицы измерения товаров/услуг по выставленному счету */
  units: InvoiceUnit[];
}

/**
 * Единица измерения товаров/услуг по выставленному счету
 */
export interface InvoiceUnit {
  /**
   * Идентификатор единицы измерения
   * @format int64
   */
  id: number;

  /** Код единицы измерения */
  code?: string;

  /** Наименование единицы измерения */
  name: string;

  /** Описание единицы измерения */
  desc?: string;

  /** Принадлежность единицы измерения справочнику ОКЕИ */
  standard: boolean;
}

/**
 * Очередной актуальный номер документа
 */
export interface DocumentNumberResponse {
  /**
   * Очередной актуальный номер документа
   *
   */
  number: string;
}

/**
 * Запрос на формирование печатных форм
 */
export interface InvoiceDocumentsPrintRequest {
  /** Запросы на формирование печатных форм по каждому документу */
  documents: InvokePrintRequest[];
}

/**
 * Запрос на получение печатной формы
 */
export interface InvokePrintRequest {
  /**
   * Тип шаблона печатной формы
   * - act (Акт выполненных работ)
   * - waybill (Накладная)
   * - taxInvoice (Счет-фактура)
   *
   * @example act
   */
  templateType: string;

  /** Номер документа */
  number: string;

  /**
   * Дата документа
   * @format date
   */
  date: string;

  /** Список товарных позиций счета для печатной формы */
  goods: number[];

  /** Текст перед таблицей печатной формы */
  textBefore?: string;

  /** Текст после таблицы печатной формы */
  textAfter?: string;

  /** Подписанты документа */
  signers: InvoiceSigner[];
}

/**
 * Отправка подписанного документа в банк
 */
export interface PaymentsSend {
  /**
   * Идентификатор подписанного платёжного документа
   * @format int64
   */
  id: number;

  /**
   * Идентификатор клиента
   * @format int64
   */
  clientId: number;

  /** IP-адрес клиента */
  ipAddress?: string;

  /** MAC-адрес клиента */
  macAddress?: string;
}

/**
 * Неуспешный результат удаления платжного документа
 */
export interface PaymentFailedDeleteResponse {
  /** Сообщение ошибки */
  message: string;

  /** Список оквэдов клиента */
  linkedDocuments: LinkedDocuments[];
}

/**
 * Связанные документы
 */
export interface LinkedDocuments {
  /** Тип документа */
  documentType: string;

  /**
   * Идентификатор документа
   * @format int64
   */
  documentId: number;
}

/**
 * Запрос на получение sms кода подтверждения авторизации
 */
export interface SmsConfirmCodeRequest {
  /** Логин пользователя */
  login: string;

  /** Пароль пользователя */
  password: string;
}

/**
 * Ответ на получение sms кода подтверждения авторизации
 */
export interface SmsConfirmCodeResponse {
  /**
   * Время действия sms пароля (сек)
   * @format int64
   */
  activeTime?: number;
}

/**
 * Запрос на проверку необходимости sms подтверждения пользователю
 */
export interface CheckSmsConfirmUserRequest {
  /** Логин пользователя */
  login: string;
}

/**
 * Ответ ссылка для перехода в Дилинг 2.0
 */
export interface DealingUrlResponse {
  /** Ссылка для перехода в Дилинг 2.0 */
  url?: string;
}

/**
 * Ответ для списка заявлений
 */
export interface VedPaymentResponse {
  /**
   * Признак того, возможна ли дальнейшая постраничная подгрузка
   *
   */
  hasMore: boolean;

  /**
   * Список данных
   *
   */
  data: VedPaymentResponseData[];
}

/**
 * Ответ для списка заявлений
 */
export interface VedPaymentResponseData {
  /**
   * id
   * @format int64
   */
  id?: number;

  /** Номер документа */
  number?: string;

  /**
   * Дата документа
   * @format date
   */
  date?: string;

  /** Состояние документа */
  status?: string;

  /** название бенефициара */
  beneficiarName?: string;

  /** SWIFT банка бенефициара */
  beneficiarSwift?: string;

  /** Наименование банка бенефициара */
  beneficiarBank?: string;

  /** Назначение платежа */
  purpose?: string;

  /** Валюта списания */
  payerAccountCurrency?: string;

  /** Сумма перевода */
  sum?: number;

  /** Валюта перевода */
  payCurrency?: string;

  /**
   * Идентификатор документа отзыва
   *
   */
  revokeId?: string;
  permissions?: EntityPermission[];
}

/**
 * Ответ для списка стран
 */
export interface VedCountriesResponse {
  /** Идентификатор */
  id?: string;

  /** код ISO */
  isoCode?: string;

  /** название страны */
  nationName?: string;

  /** чиловой код страны */
  numericCode?: string;

  /** сокращенное имя */
  shortName?: string;

  /** буквенный код страны */
  twoLettersCode?: string;

  /** название страны латиницей */
  nameLat?: string;
}

/**
 * Ответ для списка уведомлений
 */
export interface UserNotification {
  /** Идентификатор клиента (АБС) */
  clientExtId?: string;

  /**
   * Идентификатор клиента (ДБО)
   * @format int64
   */
  clientId?: number;

  /** Содержимое уведомления */
  docText?: string;

  /** Заголовок уведомления */
  docName?: string;

  /**
   * Дата уведомления
   * @format date
   */
  messageDate?: string;
}

/**
 * Ответ по тарифным планам
 */
export interface DictTariffPlanResponse {
  /**
   * Идентификатор
   * @format int64
   */
  id?: number;

  /** Наименование тарифного плана */
  name?: string;

  /** Описание тарифного плана */
  description?: string;

  /**
   * Цифровой код тарифного плана
   * @format int64
   */
  code?: number;

  /** Признак "Использовать расчётный период" */
  useCalcPeriod?: boolean;

  /** Признак "Доступность для счетов в иностранной валюте" */
  isUseForeignCurrency?: boolean;

  /** Признак "Отсутствует возможность перевода" */
  isNotAvailable?: boolean;

  /** Тарифный план является архивным */
  isArchived?: boolean;

  /** Тарифный план является тарифом по умолчанию */
  isDefault?: boolean;

  /**
   * Идентификатор картинки
   * @format int64
   */
  imageId?: number;

  /** Список услуг по данному тарифному плану */
  services?: DictTariffPlanServiceCost[];
}

/**
 * Стоимости услуг по тарифному плану
 */
export interface DictTariffPlanServiceCost {
  /**
   * Идентификатор услуги в справочнике услуг для тарифных планов
   * @format int64
   */
  id?: number;

  /** Варианты стоимости услуги для конкретного тарифного плана из справочника стоимости услуг по конкретному тарифному плану */
  costOptions?: DictTariffPlanServiceCostOption[];
}

/**
 * Вариант стоимости услуги по тарифному плану
 */
export interface DictTariffPlanServiceCostOption {
  /** Условия для варианта стоимости услуги */
  condition?: string;

  /** Стоимости услуги для конкретного варианта */
  cost?: string;
}

/**
 * Услуги по тарифным планам
 */
export interface DictTariffPlanService {
  /**
   * Идентификатор услуги в справочнике услуг для тарифных планов
   * @format int64
   */
  id?: number;

  /** Наименование услуги в справочнике услуг для тарифных планов */
  name?: string;

  /** Описание услуги в справочнике услуг для тарифных планов */
  desc?: string;

  /**
   * Номер группы для услуги тарифных планов (номер блока)
   * @format int64
   */
  groupIndex?: number;

  /** Группа для услуги тарифных планов (наименование блока) */
  group?: string;

  /** Услуга входит в основную группу услуг тарифных планов (основной блок) */
  generalGroup?: boolean;

  /** Услуга является абонентской платой (Стоимость обслуживания) */
  isSubscriptionFee?: boolean;

  /**
   * Идентификатор картинки
   * @format int64
   */
  imageId?: number;
}

/**
 * Картинки для тарифных планов
 */
export interface DictTariffPlanImage {
  /**
   * Идентификатор картинки
   * @format int64
   */
  id?: number;

  /** Наименование картинки */
  name?: string;

  /** Описание картинки */
  desc?: string;

  /**
   * Вид картинок
   *   IC - для интернет-клиента
   *   MB - для мобильного приложения
   *
   */
  imageType?: string;

  /**
   * Вид целевых объектов
   *   TariffPlan    - для тарифных планов
   *   TariffPlanSvc - для услуг тарифных планов
   *
   */
  tariffKind?: string;

  /** Картинка по умолчанию для заданных видов картинки и целевого объекта */
  isDefaultImage?: boolean;
}

/**
 * Справочник «Виды справок»
 */
export interface DictTypeReferences {
  /** Цифровой код вида справки */
  code?: string;

  /** Наименование вида справки */
  name?: string;

  /** Признак «Обязательный выбор счёта */
  mandatoryAccountSelection?: boolean;
}

/**
 * Параметры запроса подписания одного отзыва платежа
 */
export interface RevokeSignRequest {
  /**
   * Код подтверждения (отсутствует для платежей в статусе "Подписан")
   *
   */
  confirmationCode?: string;
}

/**
 * Параметры запроса подписания одного отзыва платежа с помощью PayControl 5.3
 */
export type RevokePC53SignRequest = object;

/**
 * Ответ на запрос: Подписание отзыва платежа с помощью PayControl 5.3
 */
export interface RevokePC53SignResponse {
  /**
   * Идентификатор транзакции
   *
   */
  transactionId: string;
}

/**
 * Параметры запроса для подписания документа
 */
export interface PayControlDocumentSignRequest {
  /**
   * Идентификатор документа
   *
   * @format int64
   */
  documentId: number;

  /**
   * Код подтверждения
   *
   */
  confirmationCode: string;
}

/**
 * Параметры запроса подписания документа с помощью PayControl 5.3
 */
export type DocumentPC53SignRequest = object;

/**
 * Ответ на запрос: Подписание документа с помощью PayControl 5.3
 */
export interface DocumentPC53SignResponse {
  /**
   * Идентификатор транзакции
   *
   */
  transactionId: string;
}

/**
 * Параметры запроса подписания заявки
 */
export interface OrderSignRequest {
  /**
   * Код подтверждения (отсутствует для заявок в статусе "Подписан")
   *
   */
  confirmationCode?: string;

  /**
   * MAC-адрес клиента
   *
   */
  macAddress?: string;

  /**
   * IP-адрес клиента
   *
   */
  ipAddress?: string;
}

/**
 * Параметры запроса подписания заявки с помощью PayControl 5.3
 */
export type OrderPC53SignRequest = object;

/**
 * Ответ на запрос: Подписание заявки с помощью PayControl 5.3
 */
export interface OrderPC53SignResponse {
  /**
   * Идентификатор транзакции
   *
   */
  transactionId: string;
}

/**
 * Параметры запроса журнализации сообщения
 */
export interface JournalizeMessageRequest {
  /**
   * Версия rest api
   *
   */
  apiVersion: string;

  /**
   * Тип сообщения
   * - ERROR
   * - INFO
   *
   */
  type: string;

  /**
   * Сообщение
   *
   */
  message: string;

  /**
   * Данные об iOS устройстве
   *
   */
  iOSDevice?: IOSDeviceInfo;

  /**
   * Данные об Android устройстве
   *
   */
  androidDevice?: AndroidDeviceInfo;
}

/**
 * Информация о валютных операциях
 */
export interface IvoDocumentResponse {
  /**
   * Id
   *
   */
  id?: string;

  /**
   * ФИО бухгалтера
   *
   */
  accountantName?: string;

  /**
   * Комментарий оператора системы антифрода
   *
   */
  antiFraudComment?: string;

  /**
   * Результат обработки в системе антифрода
   *
   */
  antiFraudResult?: string;

  /**
   * Комментарий банка
   *
   */
  bankComment?: string;

  /**
   * Комментарий
   *
   */
  bankInfoComment?: string;

  /**
   * Пользователь, выполнивший обработку
   *
   */
  bankInfoEmployee?: string;

  /**
   * Дата обработки
   *
   * @format date
   */
  bankInfoProcessDate?: string;

  /**
   * Дата представления
   *
   * @format date
   */
  bankInfoReceiveDate?: string;

  /**
   * Причина возврата
   *
   */
  bankInfoRejectReason?: string;

  /**
   * Номер счета резидента в уполномоченном банке
   *
   */
  clientAcc?: string;

  /**
   * Валюта счета
   *
   */
  accountCurr?: string;

  /**
   * Наименование банка
   *
   */
  clientBankName?: string;

  /**
   * ИНН клиента
   *
   */
  clientInn?: string;

  /**
   * КПП клиента
   *
   */
  clientKpp?: string;

  /**
   * Наименование клиента
   *
   */
  clientName?: string;

  /**
   * Дата и время отправки документа клиентом
   *
   * @format date
   */
  clientSendDate?: string;

  /**
   * Краткое наименование Клиента
   *
   */
  clientShortName?: string;

  /**
   * Идентификатор корректировки
   *
   */
  correctingId?: string;

  /**
   * Дата корректировки
   *
   * @format date
   */
  correctingDate?: string;

  /**
   * Номер корректировки
   *
   */
  correctingNumber?: string;

  /**
   * Должность бухгалтера
   *
   */
  counterPost?: string;

  /**
   * Код страны банка-нерезидента
   *
   */
  countryNumCode?: string;

  /**
   * Причина возврата
   *
   */
  curControlRejectStr?: string;

  /**
   * Идентификатор ЦС ДБО
   *
   */
  dboId?: string;

  /**
   * Статус в ЦС НДБО
   *
   */
  dboState?: string;

  /**
   * Дата принятия решения
   *
   * @format date
   */
  decisionDate?: string;

  /**
   * Дата обработки документа
   *
   * @format date
   */
  docHandlingDate?: string;

  /**
   * Адрес доставки документов при возврате
   *
   */
  docReturnAddress?: string;

  /**
   * Дата документа
   *
   * @format date
   */
  documentDate?: string;

  /**
   * Номер документа
   *
   */
  documentNumber?: string;

  /**
   * Дата отправки документа в банк
   *
   * @format date
   */
  documentSendDate?: string;

  /**
   * Признак досылки
   *
   */
  isAddFileSending?: boolean;

  /**
   * Признак автоматически созданного документа из Платежного документа
   *
   */
  isAutoCreated?: boolean;

  /**
   * Признак корректировки
   *
   */
  isCorrecting?: boolean;

  /**
   * Признак возврата документа
   *
   */
  isDocRetByIB?: boolean;

  /**
   * Признак возврата документа под расписку
   *
   */
  isDocRetByProc?: boolean;

  /**
   * Признак выгрузки документа в электронный архив
   *
   */
  isDownloadEA?: boolean;

  /**
   * Признак возврата Заказным почтовым отправлением с уведомлением о вручении
   *
   */
  isRegistMail?: boolean;

  /**
   * Признак отклонения документа
   *
   */
  isRejected?: boolean;

  /**
   * Признак, что документ выгружен в АБС
   *
   */
  loadedToABS?: boolean;

  /**
   * ФИО руководителя
   *
   */
  managerName?: string;

  /**
   * Должность руководителя
   *
   */
  managerPost?: string;

  /**
   * Описание причины отклонения
   *
   */
  rejectReasonDesc?: string;

  /**
   * ФИО ответственного по сделке
   *
   */
  responsiblePersonFIO?: string;

  /**
   * Телефон
   *
   */
  responsiblePersonPhone?: string;

  /**
   * Самостоятельно отозван
   *
   */
  selfRevoked?: boolean;

  /**
   * Статус
   *
   */
  state?: string;

  /**
   * Колличество документов ИВО в списке
   *
   */
  count?: number;

  /**
   * Дата изменения статуса
   *
   * @format date-time
   */
  stateChangeDate?: string;

  /**
   * Дата создания
   *
   * @format date-time
   */
  dateCreate?: string;

  /**
   * Действия доступные для документа
   *
   */
  permissions?: EntityPermission[];

  /**
   * Список операций
   *
   */
  operations?: IvoOperation[];

  /**
   * Список вложений
   *
   */
  attachments?: AttachmentInfoResponse[];
}

/**
 * Документ информация о валютных операциях
 */
export interface IvoOperation {
  /**
   * id
   *
   */
  id?: string;

  /**
   * type
   *
   */
  type?: string;

  /**
   * Код услуги
   *
   */
  codeService?: string;

  /**
   * Код вида валютной операции
   *
   */
  codeTypeCurTr?: string;

  /**
   * Примечание
   *
   */
  comment?: string;

  /**
   * Идентификатор договора/контракта
   *
   */
  contractId?: string;

  /**
   * Валюта контракта
   *
   */
  contractCurr?: string;

  /**
   * Код валюты контракта
   *
   */
  contractCurrCode?: string;

  /**
   * Код страны нерезидента
   *
   */
  countryNumCode?: string;

  /**
   * Направление платежа
   *
   */
  dirPay?: string;

  /**
   * Порядковый номер документа
   *
   * @format int64
   */
  docNum?: string;

  /**
   * Ожидаемый срок
   *
   * @format date
   */
  expectedDate?: string;

  /**
   * Признак отсутствия номера договора (контракта)
   *
   */
  isWithoutContNum?: boolean;

  /**
   * Признак отсутствия номера уведомления документа
   *
   */
  isWithoutNotNum?: boolean;

  /**
   * Признак отсутствия номера иного документа
   *
   */
  isWithoutNumber?: boolean;

  /**
   * Признак отсутствия номера расчетного документа
   *
   */
  isWithoutPayNum?: boolean;

  /**
   * Дата уведомления
   *
   * @format date
   */
  noticeDate?: string;

  /**
   * Номер уведомления
   *
   */
  noticeNumber?: string;

  /**
   * Идентификатор операции (возвращается, если при сохранении операция выбрана из списка)
   *
   */
  operationId?: string;

  /**
   * Дата операции
   *
   * @format date
   */
  operationDate?: string;

  /**
   * Дата иного документа
   *
   * @format date
   */
  otherDocDate?: string;

  /**
   * Номер иного документа
   *
   */
  otherDocNumber?: string;

  /**
   * Дата расчетного документа
   *
   * @format date
   */
  payDocDate?: string;

  /**
   * Номер расчетного документа
   *
   */
  payDocNumber?: string;

  /**
   * Валюта платежа
   *
   */
  paymentCurr?: string;

  /**
   * Код валюты платежа
   *
   * @format int64
   */
  paymentCurrCode?: number;

  /**
   * Сумма платежа
   *
   */
  paymentSum?: number;

  /**
   * Срок возврата аванса
   *
   * @format date
   */
  returnDate?: string;

  /**
   * Дата договора (контракта)
   *
   * @format date
   */
  stReservDate?: string;

  /**
   * Номер договора (контракта)
   *
   */
  stReservNumber?: string;

  /**
   * Сумма в валюте контракта
   *
   */
  sumContractCurr?: number;

  /**
   * Номер распоряжения по транзитному счету
   *
   */
  trAccInstNum?: string;

  /**
   * Номер паспорта сделки
   *
   */
  trPassportNumber?: string;

  /**
   * Список вложений
   *
   */
  attachments?: AttachmentInfoResponse[];
}

/**
 * Первичные данные ИВО
 */
export interface IvoPrimaryDataResponse {
  /**
   * Наименование банка
   *
   */
  clientBankName?: string;

  /**
   * Наименование резидента
   *
   */
  clientName?: string;

  /**
   * Дата документа
   *
   * @format date
   */
  dateDocument?: string;

  /**
   * Номер документа
   *
   * @format int64
   */
  docNum?: number;
}

/**
 * Элемент списка ссылок на api
 */
export interface ApiSettingsResponse {
  /**
   * Контур
   *
   */
  circuit?: string;

  /**
   * Ссылка на монолит
   *
   */
  monolith?: string;

  /**
   * Ссылка на микросервисы
   *
   */
  microservice?: string;
}

/**
 * Дописать
 */
export interface AddFileSendingResponse {
  /**
   * ID
   *
   * @format int64
   */
  id?: number;

  /**
   * Номер документа
   *
   */
  documentNumber?: string;

  /**
   * Статус документа
   *
   */
  documentState?: string;

  /** Список действий */
  permissions?: EntityPermission[];

  /**
   * Дата Документа
   *
   * @format date
   */
  documentDate?: string;

  /**
   * Ответ на получение списка файлов.
   *
   */
  fileList?: AttachmentInfo[];
}

/**
 * Объект с полями бенефициара
 */
export interface Beneficiary {
  /** Имя клиента */
  clientName?: string;

  /** Название банка */
  bankName?: string;

  /** SWIFT */
  swift?: string;
}

/**
 * Объект с полями документа конверсии
 */
export interface Conversion {
  /** Тип сделки */
  transactionType?: string;

  /** Счет списания */
  writeOffAccount?: string;

  /** Сумма списания */
  writeOffAmount?: number;

  /** Валюта списания */
  writeOffCurrency?: string;

  /** Счет зачисления */
  enrollmentAccount?: string;

  /** Сумма зачисления */
  enrollmentAmount?: number;

  /** Валюта зачисления */
  enrollmentCurrency?: string;

  /**
   * Курс сделки
   * @format double
   */
  dealRate?: number;
}

/**
 * Объект с полями документа валютного платежа
 */
export interface PaymentOrderCurrency {
  /** Сумма списания */
  writeOffAmount?: number;

  /** Валюта списания */
  writeOffCurrency?: string;

  /** Сумма перевода */
  transferAmount?: number;

  /** Валюта перевода */
  transferCurrency?: string;

  /** Объект с полями бенефициара */
  beneficiary?: Beneficiary;
}

/**
 * Объект для ответа о истории операций
 */
export interface DocumentListResponse {
  /** Список документов */
  documents?: DocumentResponse[];

  /** Есть ли еще документы */
  hasMore?: boolean;

  /**
   * Общее количество документов
   *
   */
  count?: number;
}

/**
 * Объект с полями документов истории операций
 */
export interface DocumentResponse {
  /** ID документа */
  documentId?: string;
  type?: string;

  /**
   * Дата документа
   * @format date-time
   */
  date?: string;

  /**
   * Номер документа
   * @format int64
   */
  number?: number;

  /** Состояние документа */
  status?: string;

  /** Назначение платежа */
  purposeOperation?: string;

  /** Сумма по документу */
  amount?: number;

  /** Валюта */
  currency?: string;

  /** Наименование организации */
  name?: string;

  /** ИНН */
  inn?: string;

  /** Номер счета */
  accountNumber?: string;

  /** Номер счета клиента */
  clientAccount?: string;

  /** Номер карты */
  cardNumber?: string;
  operationType?: string;

  /** Идентификатор в АБС */
  absId?: string;

  /** Код филиала */
  branch?: string;

  /** Краткое наименование подсистемы */
  systemShortName?: string;

  /** Объект с полями документа конверсии */
  conversion?: Conversion;

  /** Объект с полями документа валютного платежа */
  paymentOrderCurrency?: PaymentOrderCurrency;

  /** Список действий */
  permissions?: EntityPermission[];
  specifiedSum?: string;
}

/**
 * Запрос на сохранение ИВО
 */
export interface IvoDocumentSaveRequest {
  /**
   * Идентификатор текущего клиента от имени которого создается документ
   *
   * @format int64
   */
  clientId?: number;

  /**
   * Номер документа
   *
   */
  documentNumber?: number;

  /**
   * Дата документа
   *
   * @format date
   */
  documentDate?: string;

  /**
   * Наименование банка
   *
   */
  bankName?: string;

  /**
   * Наименование резидента
   *
   */
  clientName?: string;

  /**
   * Номер счета по операциям
   *
   */
  clientAcc?: string;

  /**
   * Код страны банка-нерезидента
   *
   */
  countryNumCode?: string;

  /**
   * Идентификатор ответственного лица, заполняется, если ответственное лицо существует
   *
   */
  responsiblePersonId?: string;

  /**
   * ФИО ответственного по документу
   *
   */
  responsiblePersonFio?: string;

  /**
   * Телефон ответственного
   *
   */
  responsiblePersonPhone?: string;

  /**
   * Признак корректировки
   *
   */
  isCorrecting?: boolean;

  /**
   * Идентификатор корректировки
   *
   */
  correctingId?: string;

  /**
   * Дата корректировки
   *
   * @format date
   */
  correctingDate?: string;

  /**
   * Номер корректируемого документа
   *
   */
  correctingNumber?: string;

  /**
   * Список валютных операций
   *
   */
  operations?: CurrencyOperation[];

  /**
   * Список вложений
   *
   */
  attachments?: AttachmentRequest[];
}

/**
 * Ответ на сохранение ИВО
 */
export interface IvoDocumentSaveResponse {
  /**
   * Идентификатор документа ИВО
   *
   * @format int64
   */
  id?: number;
}

/**
 * Ответственное лицо
 */
export interface ResponsiblePerson {
  /**
   * ФИО
   *
   */
  fullName?: string;

  /**
   * Телефон
   *
   */
  phone?: string;

  /**
   * Должность
   *
   */
  position?: string;
}

/**
 * Запрос на редактирование ИВО
 */
export interface IvoDocumentUpdateRequest {
  /**
   * Идентификатор текущего клиента от имени которого создается документ
   *
   * @format int64
   */
  clientId?: number;

  /**
   * Номер документа
   *
   */
  documentNumber?: number;

  /**
   * Дата документа
   *
   * @format date
   */
  documentDate?: string;

  /**
   * Наименование банка
   *
   */
  bankName?: string;

  /**
   * Наименование резидента
   *
   */
  clientName?: string;

  /**
   * Номер счета по операциям
   *
   */
  clientAcc?: string;

  /**
   * Код страны банка-нерезидента
   *
   */
  countryNumCode?: string;

  /**
   * Идентификатор ответственного лица, заполняется, если ответственное лицо существует
   *
   */
  responsiblePersonId?: string;

  /**
   * ФИО ответственного по документу
   *
   */
  responsiblePersonFio?: string;

  /**
   * Телефон ответственного
   *
   */
  responsiblePersonPhone?: string;

  /**
   * Признак корректировки
   *
   */
  isCorrecting?: boolean;

  /**
   * Идентификатор корректировки
   *
   */
  correctingId?: string;

  /**
   * Дата корректировки
   *
   * @format date
   */
  correctingDate?: string;

  /**
   * Номер корректируемого документа
   *
   */
  correctingNumber?: string;

  /**
   * Список валютных операций
   *
   */
  operations?: CurrencyOperation[];

  /** Идентификаторы удаленных вложений */
  removedAttachments?: number[];

  /**
   * Список вложений
   *
   */
  attachments?: AttachmentRequest[];
}

/**
 * Документ информация о валютных операциях
 */
export interface CurrencyOperation {
  /**
   * Порядковый номер операции
   *
   */
  docNum?: number;

  /**
   * Идентификатор операции (заполняется если операция выбрана из списка)
   *
   */
  operationId?: string;

  /**
   * Тип операции
   * - PAYMENT_ORDER_CURRENCY_TRANSIT_CURRENCY - Заявление на перевод иностранной валюты (валютный или транзитный счет)
   * - TRANS_ACC_NOTIF_TRANSIT - Уведомление о зачислении валюты (транзитный счет)
   * - PAYMENT_RUB - Платежное поручение (рублевый счет)
   * - TRANS_ACC_NOTIF_RUB - Уведомление о зачислении валюты (рублевый счет)
   *
   */
  type?: string;

  /**
   * Направление операции
   *
   */
  dirPay?: string;

  /**
   * Дата операции
   *
   * @format date
   */
  operationDate?: string;

  /**
   * Номер операции
   *
   */
  payDocNumber?: string;

  /**
   * Дата документа
   *
   * @format date
   */
  payDocDate?: string;

  /**
   * Сумма оплаты
   *
   */
  paymentSum?: number;

  /**
   * Валюта операции
   *
   */
  paymentCurr?: string;

  /**
   * Код валюты операции
   *
   */
  paymentCurrCode?: number;

  /**
   * УНК
   *
   */
  trPassportNumber?: string;

  /**
   * Номер договора
   *
   */
  stReservNumber?: string;

  /**
   * Дата договора
   *
   * @format date
   */
  stReservDate?: string;

  /**
   * Код вида операции
   *
   */
  codeTypeCurTr?: string;

  /**
   * Сумма договора
   *
   */
  sumContractCurr?: number;

  /**
   * Валюта договора
   *
   */
  contractCurr?: string;

  /**
   * Код валюты договора
   *
   */
  contractCurrCode?: number;

  /**
   * Ожидаемый срок
   *
   * @format date
   */
  expectedDate?: string;

  /**
   * Срок возврата аванса
   *
   * @format date
   */
  returnDate?: string;

  /**
   * Примечание
   *
   */
  comment?: string;
}

/**
 * Структура ответа со списком значений кодификатора
 */
export interface CodeKindsResponse {
  /**
   * Список значений кодификаторов
   *
   */
  data: CodeKind[];

  /**
   * Признак, что возможно загрузить больше значений.
   * false - достигнут конец списка
   *
   */
  hasMore: boolean;

  /**
   * Дата (миллисекунды) последнего изменения справочника
   *
   * @format int64
   */
  lastUpdateDateTime: number;
}

/**
 * Структура полей кодификатора
 */
export interface CodeKind {
  /**
   * Значение кодификатора
   *
   */
  code: string;

  /**
   * Описание кодификатора
   *
   */
  desc: string;
}

/**
 * Структура ответа со списком счетов
 */
export type AccountInfo = AccountBase & {
  availableBalance: number;
  currentBalance: number;
  openDate: string;
  closeDate?: string;
  hasStatementK2: boolean;
  hasBlockInfo: boolean;
};

/**
 * Параметры запроса справки
 */
export interface ReferenceOrderRequest {
  /**
   * Признак сохранения с имеющимися предупреждениями
   *
   */
  ignoreWarning: boolean;

  /**
   * Дата документа
   *
   * @format date
   */
  date: string;

  /**
   * ID Доп. офис
   * @format int64
   */
  branchId: number;

  /** Номера счетов */
  accountNumbers?: string[];

  /** Текст запроса */
  requestText: ReferenceType[];
}

/**
 * Структура полей справочника видов справок
 */
export interface ReferenceType {
  /** Значение справочника */
  code: string;

  /** Описание значения справочника */
  desc: string;

  /** Признак обязательного выбора счета */
  requiredAccount?: boolean;
}

/**
 * Операции ИВО клиента
 */
export interface IvoOperationInfoResponse {
  /**
   * Идентификатор операции
   *
   */
  id?: string;

  /**
   * Номер
   *
   */
  payDocNumber?: string;

  /**
   * Дата
   *
   * @format date
   */
  payDocDate?: string;

  /**
   * Сумма
   *
   */
  paymentSum?: number;

  /**
   * Валюта
   *
   */
  paymentCurr?: string;

  /**
   * Код валюты
   *
   */
  paymentCurrCode?: number;

  /**
   * Тип операции
   *
   */
  operationType?: string;

  /**
   * Дата и время изменения состояния операции
   *
   * @format date-time
   */
  operationStateChange?: string;
}

/**
 * Структура ответа со списком подразделений Банка (доп. офисов)
 */
export interface BranchesResponse {
  /** Список подразделений */
  data: BranchResponse[];
}

/**
 * Информация о подразделении банка
 */
export interface BranchResponse {
  /**
   * Идентификатор подразделения
   * @format int64
   */
  id?: number;

  /** Наименование подразделения */
  name?: string;

  /** БИК */
  bic?: string;

  /** Адрес подразделения */
  address?: string;

  /** Время работы подразделения */
  operationTimeWork?: string;
}

/**
 * Первичные данные СПД
 */
export interface SpdPrimaryDataResponse {
  /**
   * Наименование банка
   *
   */
  clientBankName?: string;

  /**
   * Наименование резидента
   *
   */
  clientName?: string;

  /**
   * Дата документа
   *
   * @format date
   */
  dateDocument?: string;

  /**
   * Номер документа
   *
   * @format int64
   */
  docNum?: number;
}

/**
 * Документ СПД
 */
export interface SpdDocumentResponse {
  /**
   * СПД id
   *
   */
  spdId?: string;

  /**
   * Номер документа
   *
   */
  documentNumber?: string;

  /**
   * Дата документа
   *
   * @format date
   */
  documentDate?: string;

  /**
   * Наименование банка
   *
   */
  bankName?: string;

  /**
   * Наименование резидента
   *
   */
  clientName?: string;

  /**
   * Код договора
   *
   */
  contractId?: string;

  /**
   * УНК
   *
   */
  trPassportNumber?: string;

  /**
   * ФИО ответственного по документу
   *
   */
  responsiblePersonFio?: string;

  /**
   * Телефон ответственного
   *
   */
  responsiblePersonPhone?: string;

  /**
   * Признак корректировки
   *
   */
  isCorrecting?: boolean;

  /**
   * Дата корректировки
   *
   * @format date
   */
  corrDate?: string;

  /**
   * Количество документов
   *
   */
  count?: number;

  /**
   * Статус докемента
   *
   */
  state?: string;

  /**
   * Идентификатор корректируемой записи
   *
   */
  correctingDocId?: string;

  /**
   * Номер корректируемой записи
   *
   */
  corrNum?: string;

  /**
   * Признак досылки
   *
   */
  isAddFileSending?: boolean;

  /**
   * Причина отказа из справочника
   *
   */
  bankInfoRejectReason?: string;

  /**
   * Причина отказа в виде комментария
   *
   */
  bankInfoComment?: string;

  /**
   * Дата изменения статуса
   *
   * @format date-time
   */
  stateChangeDate?: string;

  /**
   * Дата создания
   *
   * @format date-time
   */
  dateCreate?: string;

  /**
   * Действия доступные для документа
   *
   */
  permissions?: EntityPermission[];

  /**
   * Подтверждающие документы
   *
   */
  confDocuments?: SpdConfDocument[];

  /**
   * Информация о приложениях для СПД
   *
   */
  spdConfAttachments?: AttachmentInfoResponse[];
}

/**
 * Подтверждающие документы для СПД
 */
export interface SpdConfDocument {
  /**
   * Идентификатор подтверждающего документа
   *
   */
  confDocId?: string;

  /**
   * Номер документа
   *
   * @format int64
   */
  docNum?: number;

  /**
   * Идентификатор декларации о товарах
   *
   */
  declarationId?: string;

  /**
   * Признак поставки
   *
   */
  signSupply?: string;

  /**
   * Признак отсутствия номера подтверждающего документа
   *
   */
  isWithoutNumber?: boolean;

  /**
   * Дата подтверждающего документа
   *
   * @format date
   */
  date?: string;

  /**
   * Номер подтвреждающего документа
   *
   */
  docConfirmNumber?: string;

  /**
   * Код вида подтверждающего документа
   *
   */
  codeTypeDoc?: string;

  /**
   * Валюта документа
   *
   */
  docCurr?: string;

  /**
   * Код валюты документа
   *
   */
  docCurrCode?: string;

  /**
   * Сумма в единицах валюты документа
   *
   */
  sumDoc?: number;

  /**
   * Сумма в единицах валюты документа 2
   *
   */
  sumDoc2?: number;

  /**
   * Валюта договора
   *
   */
  contrCurr?: string;

  /**
   * Код валюты договора
   *
   */
  contrCurrCode?: string;

  /**
   * Сумма в единицах валюты договора
   *
   */
  sumContr?: number;

  /**
   * Сумма в единицах валюты договора 2
   *
   */
  sumContr2?: number;

  /**
   * Ожидаемый срок
   *
   * @format date
   */
  expectedDate?: string;

  /**
   * Код страны грузоотправителя
   *
   */
  countryNumCode?: string;

  /**
   * Примечание
   *
   */
  comment?: string;

  /**
   * Информация о приложениях для СПД
   *
   */
  spdConfAttachments?: AttachmentInfoResponse[];
}

/**
 * Документ СПД для редактирования
 */
export interface SpdDocumentUpdateRequest {
  /**
   * Номер документа
   *
   */
  documentNumber?: string;

  /**
   * Дата документа
   *
   * @format date
   */
  documentDate?: string;

  /**
   * Наименование банка
   *
   */
  clientBankName?: string;

  /**
   * Наименование резидента
   *
   */
  clientName?: string;

  /**
   * Код операции (если выбрана из списка)
   *
   */
  contractId?: string;

  /**
   * УНК
   *
   */
  trPassportNumber?: string;

  /**
   * ФИО ответственного по документу
   *
   */
  responsiblePersonFio?: string;

  /**
   * Телефон ответственного
   *
   */
  responsiblePersonPhone?: string;

  /**
   * Идентификатор ответственного лица, заполняется, если ответственное лицо существует
   *
   */
  responsiblePersonId?: string;

  /**
   * Признак корректировки
   *
   */
  isCorrecting?: boolean;

  /**
   * Идентификатор корректируемой записи
   *
   */
  correctingDocId?: string;

  /**
   * Номер корректируемой записи
   *
   */
  corrNum?: string;

  /**
   * Дата корректировки
   *
   * @format date
   */
  corrDate?: string;

  /**
   * Подтверждающие документы
   *
   */
  confDocuments?: SpdConfDocumentSave[];

  /** Идентификаторы удаленных вложений */
  removedAttachments?: number[];

  /**
   * Вложения для подтверждающих документов СПД
   *
   */
  spdConfAttachments?: AttachmentRequest[];
}

/**
 * Документ СПД для сохранения
 */
export interface SpdDocumentSaveRequest {
  /**
   * Номер документа
   *
   */
  documentNumber?: string;

  /**
   * Дата документа
   *
   * @format date
   */
  documentDate?: string;

  /**
   * Наименование банка
   *
   */
  clientBankName?: string;

  /**
   * Наименование резидента
   *
   */
  clientName?: string;

  /**
   * Код операции (если выбрана из списка)
   *
   */
  contractId?: string;

  /**
   * УНК
   *
   */
  trPassportNumber?: string;

  /**
   * ФИО ответственного по документу
   *
   */
  responsiblePersonFio?: string;

  /**
   * Телефон ответственного
   *
   */
  responsiblePersonPhone?: string;

  /**
   * Идентификатор ответственного лица, заполняется, если ответственное лицо существует
   *
   */
  responsiblePersonId?: string;

  /**
   * Признак корректировки
   *
   */
  isCorrecting?: boolean;

  /**
   * Идентификатор корректируемой записи
   *
   */
  correctingDocId?: string;

  /**
   * Номер корректируемой записи
   *
   */
  corrNum?: string;

  /**
   * Дата корректировки
   *
   * @format date
   */
  corrDate?: string;

  /**
   * Подтверждающие документы
   *
   */
  confDocuments?: SpdConfDocumentSave[];

  /**
   * Вложения для подтверждающих документов СПД
   *
   */
  spdConfAttachments?: AttachmentRequest[];
}

/**
 * Подтверждающие документы для СПД для сохранения
 */
export interface SpdConfDocumentSave {
  /**
   * Номер документа
   *
   * @format int64
   */
  docNum?: number;

  /**
   * Идентификатор декларации о товарах
   *
   */
  declarationId?: string;

  /**
   * Признак поставки
   *
   */
  signSupply?: string;

  /**
   * Признак отсутствия номера подтверждающего документа
   *
   */
  isWithoutNumber?: boolean;

  /**
   * Дата подтверждающего документа
   *
   * @format date
   */
  date?: string;

  /**
   * Номер подтвреждающего документа
   *
   */
  docConfirmNumber?: string;

  /**
   * Код вида подтверждающего документа
   *
   */
  codeTypeDoc?: string;

  /**
   * Валюта документа
   *
   */
  docCurr?: string;

  /**
   * Код валюты документа
   *
   */
  docCurrCode?: string;

  /**
   * Сумма в единицах валюты документа
   *
   */
  sumDoc?: number;

  /**
   * Сумма в единицах валюты документа 2
   *
   */
  sumDoc2?: number;

  /**
   * Валюта договора
   *
   */
  contrCurr?: string;

  /**
   * Код валюты договора
   *
   */
  contrCurrCode?: string;

  /**
   * Сумма в единицах валюты договора
   *
   */
  sumContr?: number;

  /**
   * Сумма в единицах валюты договора 2
   *
   */
  sumContr2?: number;

  /**
   * Ожидаемый срок
   *
   * @format date
   */
  expectedDate?: string;

  /**
   * Код страны грузоотправителя
   *
   */
  countryNumCode?: string;

  /**
   * Примечание
   *
   */
  comment?: string;
}

/**
 * Ответ на сохранение СПД
 */
export interface SpdIdResponse {
  /**
   * Идентификатор документа СПД
   *
   * @format int64
   */
  id?: number;
}

/**
 * Сведения о постановке контракта на учет
 */
export interface ContractRegResponse {
  /**
   * id клиента
   * @format int64
   */
  dboClientId?: number;

  /**
   * Количество документов СдПнУ Клиента в НДБО
   * @format int32
   */
  contractAmount: number;

  /**
   * Признак того, возможна ли дальнейшая постраничная подгрузка
   *
   */
  hasMore: boolean;

  /**
   * Список данных
   *
   */
  contractReg?: ContractRegResponseData[];
}

/**
 * Ответ для списка сведений о постановке контракта на учет
 */
export interface ContractRegResponseData {
  /** id */
  id: string;

  /** Тип документа СдПнУ */
  type: string;

  /**
   * Тип документа, описываемого в СдПнУ
   * @format int64
   */
  registrationMethod?: number;

  /** Порядковый номер СдПнУ Клиента */
  documentNumber: string;

  /** Статус выполнения СдПнУ */
  state: string;

  /**
   * Дата документа СдПнУ
   * @format date
   */
  documentDate?: string;

  /** УНК контракта */
  bankDocNumber?: string;

  /** УНК из предыдущего банка */
  strDocNumber?: string;

  /** Признак "Без номера договора" */
  isWithoutNumber?: boolean;

  /** Номер контракта */
  contractNumber?: string;

  /**
   * Дата подписания контракта
   * @format date
   */
  contrSignDate: string;

  /**
   * Признак "Без суммы"
   *
   */
  isUndefinedSum?: boolean;

  /** Сумма контракта */
  contractSum?: number;

  /** Валюта контракта */
  contractCurr?: ContractRegInfoCurrency;

  /**
   * Дата завершения исполнения обязательств по контракту
   * @format date
   */
  cntrctCloseDate?: string;

  /** Количество контрагентов */
  nonresidentAmount: string;

  /** Контрагенты по контракту */
  nonresident?: Nonresident[];
  permissions?: EntityPermission[];
}

/**
 * Контрагенты по договору ВЭД
 */
export interface Nonresident {
  /** Наименование контрагента */
  nonresName: string;

  /** Идентификатор страны контрагента */
  nonresCountry: number;
}

/**
 * Детальная информации по документу о Сведениях о постановке на учет
 */
export interface ContractRegInfoResponse {
  /**
   * Идентификатор документа СдПнУ
   * @format int64
   */
  id?: number;

  /**
   * Идентификатор Клиента в НДБО
   * @format int64
   */
  dboClientId?: number;

  /** Тип документа СдПнУ */
  type?: string;

  /**
   * Тип документа, описываемого в СдПнУ
   * @format int64
   */
  registrationMethod?: number;

  /** Наименование резидента */
  clientName?: string;

  /** Адрес резидента */
  clientAddress?: string;

  /** ОГРН резидента */
  clientOgrn?: string;

  /**
   * Дата внесения записи в государственный реестр
   * @format date
   */
  clientRegisterDate?: string;

  /** ИНН резидента */
  clientInn?: string;

  /** КПП резидента */
  clientKpp?: string;

  /** Порядковый номер СдПнУ Клиента */
  documentNumber?: string;

  /** Статус выполнения СдПнУ */
  state?: string;

  /** Причина отказа */
  bankInfoRejectReason?: string;

  /** Комментарий операциониста */
  bankInfoComment?: string;

  /**
   * Дата документа СдПнУ
   * @format date
   */
  documentDate?: string;

  /**
   * Идентификатор ответственного лица по сделке
   * @format int64
   */
  responsiblePersonId?: number;

  /** ФИО ответственного по сделке */
  responsiblePersonFIO?: string;

  /** телефон ответственного по сделке */
  responsiblePersonPhone?: string;

  /** УНК контракта */
  bankDocNumber?: string;

  /**
   * Дата постановки на учет
   * @format date
   */
  stateRegDate?: string;

  /** УНК из предыдущего банка */
  strDocNumber?: string;

  /**
   * Дата постановки на учет
   * @format date
   */
  docDate?: string;

  /**
   * Дата снятия с учета
   * @format date
   */
  prevNumCloseDate?: string;

  /** Регистрационный номер предыдущего банка */
  prevNum?: string;

  /** УНК, присвоенный ранее */
  contractDocNum?: string;

  /** Контрагенты по контракту */
  nonresident?: ContractRegInfoNonresident[];

  /** Признак "Без номера договора" */
  isWithoutNumber?: boolean;

  /** Номер контракта */
  contractNumber?: string;

  /**
   * Дата подписания контракта
   * @format date
   */
  contrSignDate?: string;

  /**
   * Дата завершения исполнения обязательств по контракту/кредитному договору
   * @format date
   */
  cntrctCloseDate?: string;

  /** Признак "Без суммы" */
  isUndefinedSum?: boolean;

  /** Сумма контракта */
  contractSum?: number;

  /**
   * Валюта для Сведений о постановке контракта на учет
   *
   */
  contractCurr?: ContractRegInfoCurrency;

  /** Погашение за счет валютной выручки */
  currEarnRepay?: number;

  /**
   * Ожидаемый срок репатриации
   * @format date
   */
  expectedDate?: string;

  /** Сумма зачисления на счета за рубежом */
  creditOnAccAbr?: number;

  /** Код срока привлечения */
  repayPeriodCode?: number;

  /** Задолженность на предыдущую дату */
  debtSum?: number;

  /** Валюта суммы задолженности на предыдущую дату */
  debtCurr?: ContractRegInfoCurrency;

  /** Список траншей */
  tranches?: TrancheContractReg[];

  /** Сведения из кредитного договора */
  isContractInfo?: boolean;

  /** Оценочные данные */
  isEvaluationData?: boolean;

  /** График платежей */
  crdAgrPaySchRtrn?: CreditPaymentsScheduleResponse[];

  /** Вложения к документу СдПнУ */
  attachments?: AttachmentsContractRegInfo[];

  /** Массив документов досыла к документу СдПнУ */
  addfilesending?: AddAttachmentsContractRegInfo[];

  /** Признак, что на данный момент договор не находится на учете в другом банке */
  isNotRegisteredForeign?: boolean;

  /** Признак срочной постановки на учет */
  isUrgent?: boolean;
  permissions?: EntityPermission[];
}

/**
 * Контрагенты по договору ВЭД для Детальной информации Сведений о постановке контракта на учет
 */
export interface ContractRegInfoNonresident {
  /** Наименование контрагента */
  nonresName: string;

  /**
   * Страна нерезидента для Сведений о постановке контракта на учет
   *
   */
  nonresCountry: NonresidentCountry;

  /** Признак аффилированного лица */
  isAffiliated?: boolean;
}

/**
 * Страна нерезидента для Сведений о постановке контракта на учет
 */
export interface NonresidentCountry {
  /**
   * Идентификатор записи справочника
   *
   * @format int64
   */
  id?: number;

  /**
   * Код значения справочника
   *
   */
  code?: string;

  /**
   * Подробное описание значения справочника
   *
   */
  detailedDesc?: string;

  /**
   * Подробное описание значения справочника на латинице
   *
   */
  detailedDescLat?: string;
}

/**
 * Валюта для Сведений о постановке контракта на учет
 */
export interface ContractRegInfoCurrency {
  /**
   * Идентификатор валюты
   *
   * @format int64
   */
  id?: number;

  /**
   * Валюта (буквенный ISO-код валюты)
   *
   */
  code?: string;

  /**
   * Валюта (цифровой ISO-код валюты)
   *
   * @format int64
   */
  numberCode?: number;

  /**
   * Наименование валюты
   *
   */
  name?: string;

  /**
   * Код графического символа
   *
   */
  symbol?: string;
}

/**
 * Вложенный файл к контракту внешнеэкономической деятельности
 */
export interface AttachmentsContractRegInfo {
  /**
   * Идентификатор файла вложения
   * @format int64
   */
  attachId?: number;

  /** Название типа вложения */
  type?: string;

  /**
   * Идентификатор Клиента
   * @format int64
   */
  dboClientId?: number;

  /** Имя файла */
  name?: string;

  /**
   * Размер файла
   * @format int64
   */
  size?: number;
}

/**
 * Массив документов досыла к документу СдПнУ
 */
export interface AddAttachmentsContractRegInfo {
  /**
   * Идентификатор документа досыл
   * @format int64
   */
  id?: number;

  /**
   * Дата документа досыл
   * @format date
   */
  dateCreate?: string;

  /** Статус документа досыл */
  state?: number;

  /** Вложения к документу СдПнУ */
  attachments?: AttachmentsContractRegInfo[];
  permissions?: EntityPermission[];
}

/**
 * Транш кредитного договора ВЭД
 */
export interface TrancheContractReg {
  /** Сумма транша */
  trancheSum?: number;

  /** Код срока привлечения */
  trancheCode?: number;

  /** Валюта транша */
  trancheCurr?: ContractRegInfoCurrency;

  /**
   * Ожидаемая дата поступления транша
   * @format date
   */
  trancheData?: string;
}

/**
 * График платежей
 */
export interface CreditPaymentsScheduleResponse {
  /**
   * Порядковый номер платежа
   *
   * @format int64
   */
  docNum?: number;

  /**
   * Валюта кредитного договора
   *
   */
  contractCurr?: ContractRegInfoCurrency;

  /**
   * Дата погашения основного долга
   *
   * @format date
   */
  princPaymDate?: string;

  /**
   * Сумма погашения основного долга
   *
   */
  princPaymSum?: number;

  /**
   * Дата платежа в счет процентов
   *
   * @format date
   */
  ratePaymDate?: string;

  /**
   * Сумма погашения процентов
   *
   */
  ratePaymSum?: number;

  /**
   * Валюта платежа в счет процентов
   *
   */
  interestPmtCurr?: ContractRegInfoCurrency;

  /**
   * Описание особых условий
   *
   */
  specConditions?: string;
}

/**
 * Создание СДПНУ
 */
export type ContractRegCreateRequest = ContractRegRequest & { type: string };

/**
 * Обновление СДПНУ
 */
export type ContractRegUpdateRequest = ContractRegRequest & {
  type?: string;
  "removed-files"?: number[];
};

/**
 * Изменение СДПНУ
 */
export interface ContractRegRequest {
  /**
   * Идентификатор клиента
   *
   * @format int64
   */
  dboClientId: number;

  /**
   * Вид постановки договора на учёт
   *
   * @format int64
   */
  registrationMethod?: number;

  /**
   * Идентификатор ответственного лица по сделке
   *
   * @format int64
   */
  responsiblePersonId?: number;

  /**
   * ФИО ответственного лица по сделке
   *
   */
  responsiblePersonFIO?: string;

  /**
   * Телефон ответственного лица по сделке
   *
   */
  responsiblePersonPhone?: string;

  /**
   * Дата постановки на учет
   *
   * @format date
   */
  docDate?: string;

  /**
   * Дата снятия с учета
   *
   * @format date
   */
  prevNumCloseDate?: string;

  /**
   * Сведения о ранее присвоенном контракту/ кредитному договору уникальном номере
   *
   */
  contractDocNum?: string;

  /**
   * Уникальный номер контракта/кредитного договора
   *
   */
  strDocNumber?: string;

  /** Нерезиденты */
  nonresident?: NonresidentRequest[];

  /**
   * Признак "Без номера договора"
   *
   */
  isWithoutNumber?: boolean;

  /**
   * Номер договора
   *
   */
  contractNumber?: string;

  /**
   * Дата
   *
   * @format date
   */
  contrSignDate?: string;

  /**
   * Дата завершения обязательств
   *
   * @format date
   */
  cntrctCloseDate?: string;

  /**
   * Признак "Без суммы"
   *
   */
  isUndefinedSum?: boolean;

  /**
   * Сумма
   *
   */
  contractSum?: number;

  /**
   * Валюта
   *
   * @format int64
   */
  contractCurr?: number;

  /**
   * Ожидаемый срок репатриации
   *
   * @format date
   */
  expectedDate?: string;

  /**
   * Погашение за счет валютной выручки
   *
   */
  currEarnRepay?: number;

  /**
   * Сумма зачисления на счета за рубежом
   *
   */
  creditOnAccAbr?: number;

  /**
   * Код срока привлечения
   *
   * @format int64
   */
  repayPeriodCode?: number;

  /**
   * Задолженность на предыдущую дату
   *
   */
  debtSum?: number;

  /**
   * Идентификатор валюты суммы задолженности на предыдущую дату
   *
   * @format int64
   */
  debtCurr?: number;

  /** Транши */
  tranches?: TrancheRequest[];

  /**
   * Сведения из кредитного договора
   *
   */
  isContractInfo?: boolean;

  /**
   * Оценочные данные
   *
   */
  isEvaluationData?: boolean;

  /** График платежей по возврату заемных средств */
  crdAgrPaySchRtrn?: CreditPaymentsScheduleRequest[];

  /** Вложения к документу СдПнУ */
  attachments?: AttachmentRequest[];

  /**
   * Признак, что на данный момент договор не находится на учете в другом банке
   *
   */
  isNotRegisteredForeign?: boolean;

  /**
   * Признак срочной постановки на учет
   *
   */
  isUrgent?: boolean;
}

/**
 * Нерезидент
 */
export interface NonresidentRequest {
  /**
   * Название нерезидента
   *
   */
  nonresName: string;

  /**
   * Идентификатор страны нерезидента
   *
   * @format int64
   */
  nonresCountry: number;

  /**
   * Признак аффилированного лица
   *
   */
  isAffiliated?: boolean;
}

/**
 * Транш
 */
export interface TrancheRequest {
  /**
   * Сумма
   *
   */
  trancheSum: number;

  /**
   * Идентификатор валюты суммы
   *
   * @format int64
   */
  trancheCurr: number;

  /**
   * Дата поступления
   *
   * @format date
   */
  trancheData: string;

  /**
   * Код срока привлечения
   *
   * @format int64
   */
  trancheCode: number;
}

/**
 * Описание графика платежей по возврату основного долга и процентных платежей
 */
export interface CreditPaymentsScheduleRequest {
  /**
   * Дата погашения основного долга
   *
   * @format date
   */
  princPaymDate: string;

  /**
   * Сумма погашения основного долга
   *
   */
  princPaymSum: number;

  /**
   * Идентификатор валюты кредитного договора
   *
   * @format int64
   */
  contractCurr: number;

  /**
   * Идентификатор пользователя в PayControl
   *
   * @format date
   */
  ratePaymDate: string;
}

/**
 * Результат создания СДПНУ
 */
export interface ContractRegSuccessResponse {
  /**
   * Идентификатор документа
   *
   * @format int64
   */
  id?: number;

  /**
   * Идентификатор клиента
   *
   * @format int64
   */
  dboClientId?: number;
}

/**
 * Ответ ЦФТ на запрос о статусе реестра на зачисление
 */
export interface GetStatusPayrollResponse {
  /**
   * Код статуса в ЦФТ
   *
   */
  recordCode?: string;

  /**
   * Статус передачи в АС ДБО ЮЛ
   *
   */
  statusDbo?: string;

  /**
   * Статус документа на фронте
   *
   */
  restFrontDocumentState?: string;
  registryErrors?: string[];
}

/**
 * Получение списка документов
 */
export interface ChangeContractResponse {
  /**
   * id клиента
   * @format int64
   */
  dboClientId?: number;

  /**
   * Количество документов
   * @format int32
   */
  statementAmount?: number;

  /**
   * Признак того, возможна ли дальнейшая постраничная подгрузка
   *
   */
  hasMore: boolean;

  /**
   * Результирующие данные
   *
   */
  statements?: ChangeContractResponseStatement[];
}

/**
 * Ответ для списка сведений о постановке контракта на учет
 */
export interface ChangeContractResponseStatement {
  /** id */
  id?: string;

  /** Cтатус документа ЗоВИ */
  state?: string;

  /** Номер документа ЗоВИ */
  documentNumber?: string;

  /**
   * Дата создания ЗоВИ
   * @format date
   */
  documentDate?: string;
  contractLoanNumList?: ContractLoanNumList[];
  docReasonList?: DocReasonList[];
  changeResidentNumList?: ChangeResidentNumList[];
  permissions?: EntityPermission[];
}

/**
 * Изменения в сведения о резиденте
 */
export interface ChangeResidentNumList {
  /** Уникальный номер контракта */
  number?: string;
}

/**
 * Документы, являющиеся основанием для внесения изменений
 */
export interface DocReasonList {
  /**
   * Вид документа
   *
   */
  docKind?: string;

  /**
   * Номер документа, на основании которого внесены изменения в сведения о контракте
   *
   */
  docNum?: string;

  /** Без номера */
  isWithoutDocNum?: boolean;

  /**
   * Дата документа, на основании которого внесены изменения в сведения о контракте
   *
   * @format date
   */
  docDate?: string;

  /** Примечание */
  docDesc?: string;
}

/**
 * Сведение о контракте (кредитном договоре)
 */
export interface ContractLoanNumList {
  /** Уникальный номер контракта */
  number?: string;
  changes?: ContractLoanNumListChange[];
}

/**
 * Ведомости банковского контроля
 */
export interface ContractLoanNumListChange {
  /** Номер пункта */
  itemNum?: string;

  /** Номер графы */
  columnNum?: string;

  /** Содержание изменений */
  newData?: string;
}

/**
 * Структура разрешения для вида объекта системы
 */
export interface EntityPermission {
  /**
   * Название действия
   *
   */
  name: string;

  /**
   * Описание действия
   *
   */
  desc: string;

  /**
   * Признак доступности действия
   *
   */
  isAvailable: boolean;

  /**
   * Признак блокировки действия (блокировка клиента СФМ)
   *
   */
  isActionBlocked: boolean;
}

/**
 * Обновление ЗОВИ
 */
export type ChangeContractUpdateRequest = ChangeContractRequest & {
  "removed-files"?: number[];
};

/**
 * Создание ЗоВИ
 */
export interface ChangeContractRequest {
  /**
   * Идентификатор клиента
   *
   * @format int64
   */
  dboClientId: number;

  /**
   * Идентификатор ответственного лица по сделке
   * @format int64
   */
  responsiblePersonId?: number;

  /** ФИО ответственного по сделке */
  responsiblePersonFIO?: string;

  /** телефон ответственного по сделке */
  responsiblePersonPhone?: string;

  /** Изменения в сведения о контракте (кредитном договоре) */
  contractLoanNumList?: ContractLoanNumRequest[];

  /** Документы, являющиеся основанием для внесения изменений */
  docReasonList?: DocReasonRequest[];

  /** Изменения в сведения о резиденте */
  changeResidentNumList?: ChangeResidentNumRequest[];

  /** Новое наименование резидента */
  newClientName?: string;

  /** Адрес резидента */
  newAddress?: AddressRequest;

  /** Новый ОГРН */
  newClientOgrn?: string;

  /**
   * Новая Дата внесения записи в государственный реестр
   * @format date
   */
  newClientRegisterDate?: string;

  /** Новый ИНН */
  newClientInn?: string;

  /** Новый КПП */
  newClientKpp?: string;

  /** С тарифами Банка согласны */
  agreementTariff?: boolean;

  /** Вложения к документу */
  attachments?: AttachmentRequest[];
}

/**
 * Изменение в сведения о контракте (кредитном договоре)
 */
export interface ContractLoanNumRequest {
  /** Идентификатор контракта (кредитного договора) */
  id?: string;

  /** Уникальный номер контракта (кредитного договора) */
  number?: string;

  /** Пункты и графы раздела I ведомости банковского контроля, в которые вносятся изменения */
  changes?: ChangeNumRequest[];
}

/**
 * Пункт и граф раздела I ведомости банковского контроля, в которые вносятся изменения
 */
export interface ChangeNumRequest {
  /** Номер пункта */
  itemNum?: string;

  /** Номер графы */
  columnNum?: string;

  /** Содержание изменений */
  newData?: string;
}

/**
 * Документ, являющиеся основанием для внесения изменений
 */
export interface DocReasonRequest {
  /** Вид документа */
  docKind?: string;

  /** Номер документа, на основании которого внесены изменения в сведения о контракте */
  docNum?: string;

  /** Признак "Без номера" */
  isWithoutDocNum?: boolean;

  /**
   * Дата документа, на основании которого внесены изменения в сведения о контракте
   * @format date
   */
  docDate?: string;

  /** Примечание */
  docDesc?: string;
}

/**
 * Изменение в сведения о резиденте
 */
export interface ChangeResidentNumRequest {
  /** Идентификатор контракта (кредитного договора) */
  id?: string;

  /** Уникальный номер контракта (кредитного договора) */
  number?: string;
}

/**
 * Адрес резидента
 */
export interface AddressRequest {
  /** Субъект РФ */
  region?: string;

  /** Район */
  area?: string;

  /** Город */
  city?: string;

  /** Населенный пункт */
  locality?: string;

  /** Улица (проспект, переулок и т.д.) */
  street?: string;

  /** Номер дома (владение) */
  house?: string;

  /** Корпус (строение) */
  struct?: string;

  /** Офис (квартира) */
  flat?: string;
}

/**
 * Результат создания ЗоВИ
 */
export interface ChangeContractCreateResponse {
  /**
   * Идентификатор документа
   *
   * @format int64
   */
  id?: number;

  /**
   * Идентификатор клиента
   *
   * @format int64
   */
  dboClientId?: number;
}

/**
 * Получение детальной информации по документу ЗОВИ
 */
export interface ChangeDocumentContractInfoResponse {
  /**
   * Идентификатор документа СдПнУ
   * @format int64
   */
  id?: number;

  /**
   * Идентификатор Клиента в НДБО
   * @format int64
   */
  dboClientId?: number;

  /** Статус документа */
  state?: string;

  /** Причина отказа */
  bankInfoRejectReason?: string;

  /** Комментарий операциониста */
  bankInfoComment?: string;

  /** Номер документа */
  documentNumber?: string;

  /**
   * Дата создания документа
   * @format date
   */
  documentDate?: string;

  /**
   * Идентификатор БЕЗОТВЕСТВЕННОГО лица по сделке
   * @format int64
   */
  responsiblePersonId?: number;

  /** ФИО ответственного по сделке */
  responsiblePersonFIO?: string;

  /** телефон ответственного по сделке */
  responsiblePersonPhone?: string;

  /** Наименование резидента */
  clientName?: string;

  /** ИНН */
  clientInn?: string;

  /** КПП */
  clientKppWoRef?: string;

  /** Изменения в сведения о контракте (кредитном договоре) */
  contractLoanNumList?: ContractLoanNumRequest[];

  /** Документы, являющиеся основанием для внесения изменений */
  docReasonList?: DocReasonRequest[];

  /** Изменения в сведения о резиденте */
  changeResidentNumList?: ChangeResidentNumRequest[];

  /** Новое Наименование резидента */
  newClientName?: string;

  /** Адрес резидента */
  newAddress?: AddressRequest;

  /** ОГРН */
  newClientOgrn?: string;

  /**
   * Новая Дата внесения записи в государственный реестр
   * @format date
   */
  newClientRegisterDate?: string;

  /** Новый ИНН */
  newClientInn?: string;

  /** Новый КПП */
  newClientKpp?: string;

  /** Признак согласия с тарифами банка */
  agreementTariff?: boolean;

  /** Вложения к документу СдПнУ */
  attachments?: AttachmentsContractRegInfo[];

  /** Массив документов досыла к документу СдПнУ */
  addfilesending?: AddAttachmentsContractRegInfo[];
  permissions?: EntityPermission[];
}

/**
 * Юридический адрес
 */
export interface ClientAddressRequest {
  /** Юридический адрес */
  fullAddress?: string;
}

/**
 * Структура запроса на распознание счета
 */
export interface PaymentPhotoRequest {
  /** Возможное значение - PAYMENT_INVOICE_1C */
  docType?: string;

  /** Возможные значения - ANDROID, IOS */
  clientType: string;

  /** Фото счета в формате base64 */
  photo: string;

  /** Расширение файла */
  extension: string;
}

/**
 * Создание платежа по фотографии счета
 */
export interface PaymentByImageResponse {
  /** Номер платежа */
  number?: string;

  /**
   * Сумма операции
   * @format double
   */
  amount?: number;

  /** Буквенный ISO-код валюты */
  currency?: string;

  /** Данные о получателе */
  receiver?: PaymentMember;

  /** Назначение платежа */
  ground?: string;

  /** Ошибки распознавания */
  errors?: ValidationResponse;
}

/**
 * Информация о вложении
 */
export interface AttachmentInfoResponse {
  /** ID вложения */
  id?: string;

  /** Название файла */
  name?: string;

  /**
   * Размер файла в байтах
   * @format int64
   */
  size?: number;

  /** Позиция файла */
  position?: number;

  /** Формат вложения */
  format?: string;
}

/**
 * Запрос проверки лимитов для списка документов
 */
export interface DocumentsLimitsRequest {
  /**
   * Идентификатор Клиента
   *
   */
  clientId: string;

  /**
   * Идентификатор филиала Клиента
   *
   */
  filialId: string;

  /**
   * Идентификаторы документа
   *
   */
  documentId: string[];
}

/**
 * Ответ проверки лимитов для списка документов
 */
export interface DocumentsLimitsResponse {
  /**
   * Результат проверки (0 проверка пройдена успешно, 1 проверка не пройдена)
   *
   */
  result: string;

  /**
   * Описание результата проверки (Обязательно заполняется, если результат проверки 1)
   *
   */
  desc?: string;
}

import { HttpClient } from "../../client/monolith";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title РСХБ НДБО API
 * @version 2
 *
 * API для фронт приложения РСХБ для юридических лиц
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  login = {
    /**
 * @description Вход в приложение
 * 
 * @tags Auth
 * @name LoginCreate
 * @summary Авторизация

 * @request POST:/login
 */
    loginCreate: (body: LoginRequest, params: RequestParams = {}) =>
      this.request<LoginResponse, ErrorResponse>({
        path: `/login`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  pc53LoginStart = {
    /**
 * @description Начало процесса авторизации с помощью PayControl 5.3.
 * 
 * @tags Auth
 * @name Pc53LoginStartCreate
 * @summary Начало процесса авторизации с помощью PayControl 5.3.

 * @request POST:/pc53-login-start
 */
    pc53LoginStartCreate: (
      body: PC53LoginStartRequest,
      params: RequestParams = {}
    ) =>
      this.request<PC53LoginStartResponse, ErrorResponse>({
        path: `/pc53-login-start`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  pc53LoginFinish = {
    /**
 * @description Окончание процесса авторизации с помощью PayControl 5.3.
 * 
 * @tags Auth
 * @name Pc53LoginFinishCreate
 * @summary Окончание процесса авторизации с помощью PayControl 5.3.

 * @request POST:/pc53-login-finish
 */
    pc53LoginFinishCreate: (
      body: PC53LoginFinishRequest,
      params: RequestParams = {}
    ) =>
      this.request<PC53LoginFinishResponse, ErrorResponse>({
        path: `/pc53-login-finish`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  auth = {
    /**
 * @description Обновление Access токена
 * 
 * @tags Auth
 * @name RefreshTokenCreate
 * @summary Авторизация

 * @request POST:/auth/refresh-token
 */
    refreshTokenCreate: (
      body: RefreshTokenRequest,
      params: RequestParams = {}
    ) =>
      this.request<RefreshTokenResponse, ErrorResponse>({
        path: `/auth/refresh-token`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Выход из приложения
 * 
 * @tags Auth
 * @name JwtLogoutCreate
 * @summary Деинициализация сессии и очистка refresh токена

 * @request POST:/auth/jwt-logout
 */
    jwtLogoutCreate: (params: RequestParams = {}) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/auth/jwt-logout`,
        method: "POST",
        format: "json",
        ...params,
      }),
  };
  logout = {
    /**
 * @description Выход из приложения
 * 
 * @tags Auth
 * @name LogoutCreate
 * @summary Деинициализация сессии

 * @request POST:/logout
 */
    logoutCreate: (params: RequestParams = {}) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/logout`,
        method: "POST",
        format: "json",
        ...params,
      }),
  };
  registerMobileDevice = {
    /**
 * @description Регистрация мобильного устройства по отпечатку устройства PayControl
 * 
 * @tags PayControl
 * @name RegisterMobileDeviceCreate
 * @summary Регистрация мобильного устройства

 * @request POST:/register-mobile-device
 */
    registerMobileDeviceCreate: (
      body: RegisterMobileDeviceRequest,
      params: RequestParams = {}
    ) =>
      this.request<RegisterMobileDeviceResponse, ErrorResponse>({
        path: `/register-mobile-device`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  pc53RegisterMobileDevice = {
    /**
 * @description Регистрация мобильного устройства по отпечатку устройства PayControl 5.3
 * 
 * @tags PayControl
 * @name Pc53RegisterMobileDeviceCreate
 * @summary Регистрация мобильного устройства по отпечатку устройства PayControl 5.3

 * @request POST:/pc53-register-mobile-device
 */
    pc53RegisterMobileDeviceCreate: (
      body: PC53RegisterMobileDeviceRequest,
      params: RequestParams = {}
    ) =>
      this.request<PC53RegisterMobileDeviceResponse, ErrorResponse>({
        path: `/pc53-register-mobile-device`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  checkSmsConfirmUser = {
    /**
     * @description Проверка необходимости ввода sms подтверждения пользователю при авторизации
     *
     * @tags Auth
     * @name CheckSmsConfirmUserCreate
     * @summary Проверка необходимости ввода sms подтверждения пользователю при авторизации
     * @request POST:/check-sms-confirm-user
     */
    checkSmsConfirmUserCreate: (
      body: CheckSmsConfirmUserRequest,
      params: RequestParams = {}
    ) =>
      this.request<boolean, ErrorResponse>({
        path: `/check-sms-confirm-user`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  smsConfirmCode = {
    /**
     * @description Получение sms кода подтверждения авторизации
     *
     * @tags Auth
     * @name SmsConfirmCodeCreate
     * @summary Получение sms кода подтверждения авторизации
     * @request POST:/sms-confirm-code
     */
    smsConfirmCodeCreate: (
      body: SmsConfirmCodeRequest,
      params: RequestParams = {}
    ) =>
      this.request<SmsConfirmCodeResponse, ErrorResponse>({
        path: `/sms-confirm-code`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  payControlUserId = {
    /**
 * @description Получение идентификатора PayControl пользователя
 * 
 * @tags PayControl
 * @name PayControlUserIdList
 * @summary Получение идентификатора PayControl пользователя

 * @request GET:/pay-control-user-id
 */
    payControlUserIdList: (
      query: { fingerPrint: string },
      params: RequestParams = {}
    ) =>
      this.request<PayControlUserIdResponse, ErrorResponse>({
        path: `/pay-control-user-id`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  lockPayControlUser = {
    /**
 * @description Блокировка PayControl пользователя
 * 
 * @tags PayControl
 * @name LockPayControlUserCreate
 * @summary Блокировка PayControl пользователя

 * @request POST:/lock-pay-control-user
 */
    lockPayControlUserCreate: (
      body: LockPayControlUserRequest,
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorPayControl>({
        path: `/lock-pay-control-user`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  pc53LockPayControlUser = {
    /**
 * @description Блокировка пользователя в PayControl 5.3.
 * 
 * @tags PayControl
 * @name Pc53LockPayControlUserCreate
 * @summary Блокировка пользователя в PayControl 5.3.

 * @request POST:/pc53-lock-pay-control-user
 */
    pc53LockPayControlUserCreate: (
      body: PC53LockPayControlUserRequest,
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/pc53-lock-pay-control-user`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  activationCodeAttempts = {
    /**
 * @description Получение числа неуспешных попыток ввода кода активации до перенаправления пользователя на экран ввода логина и пароля
 * 
 * @tags Auth
 * @name ActivationCodeAttemptsList
 * @summary Получение числа неуспешных попыток ввода кода активации

 * @request GET:/activation-code-attempts
 */
    activationCodeAttemptsList: (params: RequestParams = {}) =>
      this.request<ActivationCodeAttemptsResponse, ErrorResponse>({
        path: `/activation-code-attempts`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  pinAttempts = {
    /**
 * @description Получение числа попыток ввода неправильного PIN-кода до временной и постоянной блокировки
 * 
 * @tags PayControl
 * @name PinAttemptsList
 * @summary Получение числа попыток ввода неправильного PIN-кода

 * @request GET:/pin-attempts
 */
    pinAttemptsList: (params: RequestParams = {}) =>
      this.request<PINAttemptsResponse, ErrorResponse>({
        path: `/pin-attempts`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  validatePasswords = {
    /**
 * @description Проверка паролей перед сменой временного на постоянный
 * 
 * @tags Auth
 * @name ValidatePasswordsCreate
 * @summary Проверить пароли

 * @request POST:/validate-passwords
 */
    validatePasswordsCreate: (
      body: ChangePasswordRequest,
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/validate-passwords`,
        method: "POST",
        body: body,
        format: "json",
        ...params,
      }),
  };
  changePassword = {
    /**
 * @description Смена временного пароля на постоянный
 * 
 * @tags Auth
 * @name ChangePasswordCreate
 * @summary Смена пароля

 * @request POST:/change-password
 */
    changePasswordCreate: (
      body: ChangePasswordRequest,
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/change-password`,
        method: "POST",
        body: body,
        format: "json",
        ...params,
      }),
  };
  validateAdditionalAuthenticators = {
    /**
 * @description Валидация дополнительных аутентификаторов (ИНН/КПП) при первом входе клиента в систему
 * 
 * @tags Auth
 * @name ValidateAdditionalAuthenticatorsCreate
 * @summary Валидация дополнительных аутентификаторов

 * @request POST:/validate-additional-authenticators
 */
    validateAdditionalAuthenticatorsCreate: (
      body: ValidationINNRequest,
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/validate-additional-authenticators`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  sendTempPassSms = {
    /**
 * @description Отправка временного пароля по СМС
 * 
 * @tags Auth
 * @name SendTempPassSmsCreate
 * @summary Отправка временного пароля по СМС

 * @request POST:/send-temp-pass-sms
 */
    sendTempPassSmsCreate: (
      body: SendTempPassSMSRequest,
      params: RequestParams = {}
    ) =>
      this.request<SendTempPassSMSResponse, ErrorResponse>({
        path: `/send-temp-pass-sms`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  resetPassSendSms = {
    /**
 * @description Востановление пароля по СМС (обновленный send-temp-pass-sms)
 * 
 * @tags Auth
 * @name ResetPassSendSmsCreate
 * @summary Востановление пароля по СМС (обновленный send-temp-pass-sms)

 * @request POST:/reset-pass-send-sms
 */
    resetPassSendSmsCreate: (
      body: ResetPassSendSMSRequest,
      params: RequestParams = {}
    ) =>
      this.request<ResetPassSendSMSResponse, ErrorResponse>({
        path: `/reset-pass-send-sms`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  existOtp = {
    /**
 * @description Проверка возможности подтверждения по одноразовому паролю
 * 
 * @tags OTP
 * @name ExistOtpList
 * @summary Проверка возможности подтверждения по одноразовому паролю

 * @request GET:/exist-otp
 */
    existOtpList: (params: RequestParams = {}) =>
      this.request<boolean, ErrorResponse>({
        path: `/exist-otp`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  sendOtpSms = {
    /**
 * @description Отправка одноразового пароля по СМС
 * 
 * @tags OTP
 * @name SendOtpSmsCreate
 * @summary Отправка одноразового пароля по СМС

 * @request POST:/send-otp-sms
 */
    sendOtpSmsCreate: (body: SendOTPSMSRequest, params: RequestParams = {}) =>
      this.request<SendOTPResponse, ErrorResponse>({
        path: `/send-otp-sms`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  otpSources = {
    /**
 * @description Получение источников одноразового пароля
 * 
 * @tags OTP
 * @name OtpSourcesCreate
 * @summary Получение источников одноразового пароля

 * @request POST:/otp-sources
 */
    otpSourcesCreate: (body: OTPSourceRequest, params: RequestParams = {}) =>
      this.request<OTPSource[], ErrorResponse>({
        path: `/otp-sources`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  otpCheck = {
    /**
 * @description Проверка одноразового пароля, выдача полноценного токена с рефреш-токеном
 * 
 * @tags OTP
 * @name OtpCheckCreate
 * @summary Проверка одноразового пароля, выдача полноценного токена с рефреш-токеном

 * @request POST:/otp-check
 */
    otpCheckCreate: (body: OTPCheckRequest, params: RequestParams = {}) =>
      this.request<LoginResponse, ErrorResponse>({
        path: `/otp-check`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  otpCheckSign = {
    /**
 * @description Проверка одноразового пароля при подписании
 * 
 * @tags OTP
 * @name OtpCheckSignCreate
 * @summary Проверка одноразового пароля при подписании

 * @request POST:/otp-check-sign
 */
    otpCheckSignCreate: (
      body: OTPCheckSignRequest,
      params: RequestParams = {}
    ) =>
      this.request<boolean, ErrorResponse>({
        path: `/otp-check-sign`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  availableAuthMethods = {
    /**
 * @description Получение доступных способов аутентификации
 * 
 * @tags Auth
 * @name AvailableAuthMethodsList
 * @summary Получение доступных способов аутентификации

 * @request GET:/available-auth-methods
 */
    availableAuthMethodsList: (params: RequestParams = {}) =>
      this.request<AuthenticationMethod[], ErrorResponse>({
        path: `/available-auth-methods`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  availableCertificates = {
    /**
 * @description Получение доступных для входа сертификатов
 * 
 * @tags Auth
 * @name AvailableCertificatesCreate
 * @summary Получение доступных для входа сертификатов

 * @request POST:/available-certificates
 */
    availableCertificatesCreate: (
      body: Certificate[],
      params: RequestParams = {}
    ) =>
      this.request<Certificate[], ErrorResponse>({
        path: `/available-certificates`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  certificates = {
    /**
 * @description Проверка наличия готовых к установке сертификатов
 * 
 * @tags Certificates
 * @name ExistReadyToInstallCertList
 * @summary Проверка наличия готовых к установке сертификатов

 * @request GET:/certificates/exist-ready-to-install-cert
 */
    existReadyToInstallCertList: (
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<boolean, ErrorResponse>({
        path: `/certificates/exist-ready-to-install-cert`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение виртуального сертификата для СМС-подписания
 * 
 * @tags Certificates
 * @name VirtualCertForSmsSignList
 * @summary Получение виртуального сертификата для СМС-подписания

 * @request GET:/certificates/virtual-cert-for-sms-sign
 */
    virtualCertForSmsSignList: (
      query: { documentId: number },
      params: RequestParams = {}
    ) =>
      this.request<VirtualCertResponse, ErrorResponse>({
        path: `/certificates/virtual-cert-for-sms-sign`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение списка сертификатов пользователя
 * 
 * @tags Certificates
 * @name AllUserCertsList
 * @summary Получение списка сертификатов пользователя

 * @request GET:/certificates/all-user-certs
 */
    allUserCertsList: (
      query?: { clientId?: number },
      params: RequestParams = {}
    ) =>
      this.request<Certificate[], ErrorResponse>({
        path: `/certificates/all-user-certs`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение списка сертификатов УЦ
 * 
 * @tags Certificates
 * @name CaCertsList
 * @summary Получение списка сертификатов УЦ

 * @request GET:/certificates/ca-certs
 */
    caCertsList: (params: RequestParams = {}) =>
      this.request<string[], ErrorResponse>({
        path: `/certificates/ca-certs`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Получение списка сертификатов всех УЛ клиента (только для УЛ с правом первой подписи)
 * 
 * @tags Certificates
 * @name UsersCertsForClientDetail
 * @summary Получение списка сертификатов всех УЛ клиента

 * @request GET:/certificates/users-certs-for-client/{id}
 */
    usersCertsForClientDetail: (id: number, params: RequestParams = {}) =>
      this.request<Certificate[], ErrorResponse>({
        path: `/certificates/users-certs-for-client/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  client = {
    /**
 * @description Получение настроек микросервиса для конкретного клиента
 * 
 * @tags Clients
 * @name SettingsDetail
 * @summary Получение настроек микросервиса для конкретного клиента

 * @request GET:/client/settings/{msStrId}
 */
    settingsDetail: (
      msStrId: string,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<MsSettingsResponse, ErrorResponse>({
        path: `/client/settings/${msStrId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  clients = {
    /**
 * @description Список клиентов (для текущего пользователя)
 * 
 * @tags Clients
 * @name ClientsList
 * @summary Список клиентов

 * @request GET:/clients
 */
    clientsList: (params: RequestParams = {}) =>
      this.request<ClientShort[], ErrorResponse>({
        path: `/clients`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Получить текущего клиента (для текущего пользователя)
 * 
 * @tags Clients
 * @name ActiveList
 * @summary Получить текущего клиента

 * @request GET:/clients/active
 */
    activeList: (params: RequestParams = {}) =>
      this.request<ClientShort, ErrorResponse>({
        path: `/clients/active`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Установить клиента активным
 * 
 * @tags Clients
 * @name ActiveUpdate
 * @summary Установить клиента активным

 * @request PUT:/clients/{clientId}/active
 */
    activeUpdate: (clientId: number, params: RequestParams = {}) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/clients/${clientId}/active`,
        method: "PUT",
        format: "json",
        ...params,
      }),

    /**
 * @description Детальная информация по клиенту
 * 
 * @tags Clients
 * @name ClientsDetail
 * @summary Детальная информация по клиенту

 * @request GET:/clients/{id}
 */
    clientsDetail: (id: number, params: RequestParams = {}) =>
      this.request<ClientInfoResponse, ErrorResponse>({
        path: `/clients/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Получение статуса услуги проверка контрагента
 * 
 * @tags Clients
 * @name CorrespondentCheckServiceStateDetail
 * @summary Статус услуги проверка контрагента

 * @request GET:/clients/{id}/correspondent-check-service-state
 */
    correspondentCheckServiceStateDetail: (
      id: number,
      params: RequestParams = {}
    ) =>
      this.request<CorrespondentCheckServiceStateResponse, ErrorResponse>({
        path: `/clients/${id}/correspondent-check-service-state`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Получение данных о наличии действующего ЕСД
 * 
 * @tags Clients
 * @name GetClients
 * @summary Данные о наличии действующего единого сервисного договора (ЕСД)

 * @request GET:/clients/{id}/esd
 */
    getClients: (id: number, params: RequestParams = {}) =>
      this.request<EsdResponse, ErrorResponse>({
        path: `/clients/${id}/esd`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Запрос информации о схеме подписания
 * 
 * @tags Clients
 * @name SignSchemDetail
 * @summary Запрос информации о схеме подписания

 * @request GET:/clients/{id}/sign-schem
 */
    signSchemDetail: (id: number, params: RequestParams = {}) =>
      this.request<SignSchem, ErrorResponse>({
        path: `/clients/${id}/sign-schem`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Получение списка сотрудников у активного клиента
 * 
 * @tags Users
 * @name ActiveUsersList
 * @summary Получение списка сотрудников у активного клиента

 * @request GET:/clients/active/users
 */
    activeUsersList: (params: RequestParams = {}) =>
      this.request<ClientsActiveUsersResponse[], ErrorResponse>({
        path: `/clients/active/users`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  responsiblePersons = {
    /**
 * @description Получение списка ответственных лиц при создании реестра на зачисление в рамках зарплатного проекта
 * 
 * @tags ResponsiblePersons
 * @name ResponsiblePersonsList
 * @summary Список ответственных лиц

 * @request GET:/responsible-persons
 */
    responsiblePersonsList: (
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<AgentListResponse, ErrorResponse>({
        path: `/responsible-persons`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  wageissuingcards = {
    /**
 * @description Получение списка распоряжений на выпуск карт в рамках зарплатного проекта
 * 
 * @tags WageIssuingCards
 * @name WageissuingcardsList
 * @summary Списко распоряжений на выпуск карт

 * @request GET:/wageissuingcards
 */
    wageissuingcardsList: (
      query: {
        clientId: number;
        absId?: string;
        stateList?: string[];
        position?: number;
        size?: number;
        beginDate?: string;
        endDate?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<WageIssuingCardsResponse, ErrorResponse>({
        path: `/wageissuingcards`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Создание распоряжение на выпуск карт в рамках зарплатного проекта
 * 
 * @tags WageIssuingCards
 * @name WageissuingcardsCreate
 * @summary Создание распоряжение на выпуск карт

 * @request POST:/wageissuingcards
 */
    wageissuingcardsCreate: (
      body: WageIssuingCardRequest,
      params: RequestParams = {}
    ) =>
      this.request<DocumentSaveResponse, ErrorResponse | ValidationResponse>({
        path: `/wageissuingcards`,
        method: "POST",
        body: body,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение подробной информации об распоряжении на выпуск карт
 * 
 * @tags WageIssuingCards
 * @name WageissuingcardsDetail
 * @summary Информация о распоряжении на выпуск карт

 * @request GET:/wageissuingcards/{id}
 */
    wageissuingcardsDetail: (
      id: string,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<WageIssuingCardInfoResponse, ErrorResponse>({
        path: `/wageissuingcards/${id}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Редактирование распоряжения на выпуск карт в рамках зарплатного проекта
 * 
 * @tags WageIssuingCards
 * @name WageissuingcardsUpdate
 * @summary Редактирование распоряжения на выпуск карт

 * @request PUT:/wageissuingcards/{id}
 */
    wageissuingcardsUpdate: (
      id: string,
      query: { clientId: number },
      body: WageIssuingCardRequest,
      params: RequestParams = {}
    ) =>
      this.request<DocumentSaveResponse, ErrorResponse | ValidationResponse>({
        path: `/wageissuingcards/${id}`,
        method: "PUT",
        query: query,
        body: body,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WageIssuingCards
     * @name WageissuingcardsDelete
     * @summary Удаление реестра на выпуск карт
     * @request DELETE:/wageissuingcards/{id}
     */
    wageissuingcardsDelete: (
      id: string,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/wageissuingcards/${id}`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение информации номера следующего реестра
 * 
 * @tags WageIssuingCards
 * @name NextregistrynumberList
 * @summary Информация о следующем номере реестра

 * @request GET:/wageissuingcards/nextregistrynumber
 */
    nextregistrynumberList: (
      query: { clientId: number; contractAbsId?: string },
      params: RequestParams = {}
    ) =>
      this.request<WageIssuingCardNextRegistryNumberResponse, ErrorResponse>({
        path: `/wageissuingcards/nextregistrynumber`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение количества Распоряжений на выпуск карт ожидающих подписания
 * 
 * @tags WageIssuingCards
 * @name NumberForSignStatusList
 * @summary Количество Распоряжений на выпуск карт ожидающих подписания

 * @request GET:/wageissuingcards/number/for-sign-status
 */
    numberForSignStatusList: (
      query: {
        clientId: number;
        contractAbsId?: string;
        beginDate?: string;
        endDate?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<number, ErrorResponse>({
        path: `/wageissuingcards/number/for-sign-status`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Экспорт реестра на выпуск карт в файл Excel
 * 
 * @tags WageIssuingCards
 * @name ExportList
 * @summary Экспорт реестра на выпуск карт в файл Excel

 * @request GET:/wageissuingcards/export
 */
    exportList: (
      query: { id: string; clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<File, ErrorResponse>({
        path: `/wageissuingcards/export`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Импорт распоряжения на выпуск карт сотрудникам из файла xls
     *
     * @tags WageIssuingCards
     * @name ImportCreate
     * @summary Импорт распоряжения на выпуск карт сотрудникам из файла xls
     * @request POST:/wageissuingcards/import
     */
    importCreate: (
      query: { clientId: number },
      data: { file: File },
      params: RequestParams = {}
    ) =>
      this.request<WageIssuingCardImportResponse, ErrorResponse>({
        path: `/wageissuingcards/import`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение подробной информации о сотруднике в распоряжении на выпуск карт
 * 
 * @tags WageIssuingCards
 * @name EmployeedetailinformationDetail
 * @summary Информация о сотруднике в распоряжении на выпуск карт

 * @request GET:/wageissuingcards/employeedetailinformation/{id}
 */
    employeedetailinformationDetail: (
      id: string,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<
        WageIssuingCardEmployeeDetailInformationResponse,
        ErrorResponse
      >({
        path: `/wageissuingcards/employeedetailinformation/${id}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Редактирование подробной информации о сотруднике в распоряжении на выпуск карт
 * 
 * @tags WageIssuingCards
 * @name EmployeedetailinformationCreate
 * @summary Информация о сотруднике в распоряжении на выпуск карт

 * @request POST:/wageissuingcards/employeedetailinformation/{id}
 */
    employeedetailinformationCreate: (
      id: string,
      query: { clientId: number; employeeId: number },
      body: WageIssuingCardEditRequest,
      params: RequestParams = {}
    ) =>
      this.request<DocumentSaveResponse, ErrorResponse>({
        path: `/wageissuingcards/employeedetailinformation/${id}`,
        method: "POST",
        query: query,
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Экспорт реестра на выпуск карт в файл PDF
 * 
 * @tags WageIssuingCards
 * @name PrintDetail
 * @summary Экспорт реестра на выпуск карт в файл PDF

 * @request GET:/wageissuingcards/{id}/print
 */
    printDetail: (
      id: string,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<File, ErrorResponse>({
        path: `/wageissuingcards/${id}/print`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  wagetransfers = {
    /**
 * @description Получение списка распоряжений на зачисление средств в рамках зарплатного проекта
 * 
 * @tags WageTransfers
 * @name WagetransfersList
 * @summary Список распоряжений на зачисление средств

 * @request GET:/wagetransfers
 */
    wagetransfersList: (
      query: {
        clientId: number;
        absId?: string;
        stateList?: string[];
        position?: number;
        size?: number;
        payerAccNumSearchText?: string;
        beginDate?: string;
        endDate?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<WageTransfersResponse, ErrorResponse>({
        path: `/wagetransfers`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Создание распоряжения на зачисление средств в рамках зарплатного проекта
 * 
 * @tags WageTransfers
 * @name WagetransfersCreate
 * @summary Создание распоряжения на зачисление средств

 * @request POST:/wagetransfers
 */
    wagetransfersCreate: (
      body: WageTransferRequest,
      params: RequestParams = {}
    ) =>
      this.request<DocumentSaveResponse, ErrorResponse | ValidationResponse>({
        path: `/wagetransfers`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение информации номере следующего реестра
 * 
 * @tags WageTransfers
 * @name NextregistrynumberList
 * @summary Информация о следующем номере реестра

 * @request GET:/wagetransfers/nextregistrynumber
 */
    nextregistrynumberList: (
      query: { clientId: number; contractAbsId?: string },
      params: RequestParams = {}
    ) =>
      this.request<WageTransfersNextRegistryNumberResponse, ErrorResponse>({
        path: `/wagetransfers/nextregistrynumber`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение подробной информации об распоряжении на зачисление средств
 * 
 * @tags WageTransfers
 * @name WagetransfersDetail
 * @summary Информация о распоряжении на зачисление средств

 * @request GET:/wagetransfers/{id}
 */
    wagetransfersDetail: (
      id: string,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<WageTransferInfoResponse, ErrorResponse>({
        path: `/wagetransfers/${id}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Редактирование распоряжения на зачисление средств
 * 
 * @tags WageTransfers
 * @name WagetransfersUpdate
 * @summary Редактирование распоряжения на зачисление средств

 * @request PUT:/wagetransfers/{id}
 */
    wagetransfersUpdate: (
      id: string,
      query: { clientId: number },
      wageTransfer: WageTransferRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        WageTransferInfoResponse,
        ErrorResponse | ValidationResponse
      >({
        path: `/wagetransfers/${id}`,
        method: "PUT",
        query: query,
        body: wageTransfer,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WageTransfers
     * @name WagetransfersDelete
     * @summary Удаление документа распоряжения на зачисление средств
     * @request DELETE:/wagetransfers/{id}
     */
    wagetransfersDelete: (
      id: string,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/wagetransfers/${id}`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение информации о сотрудниках распоряжения на зачисление средств
 * 
 * @tags WageTransfers
 * @name EmployeesDetail
 * @summary Информация о сотрудниках распоряжения на зачисление средств

 * @request GET:/wagetransfers/{id}/employees
 */
    employeesDetail: (
      id: string,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<WageTransferEmployeesResponse, ErrorResponse>({
        path: `/wagetransfers/${id}/employees`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение информации о статусе сотрудников распоряжения на зачисление средств
 * 
 * @tags WageTransfers
 * @name EmployeesStatusDetail
 * @summary Информация о статусе сотрудников распоряжения на зачисление средств

 * @request GET:/wagetransfers/{id}/employees/status
 */
    employeesStatusDetail: (
      id: string,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<WageTransferEmployeesStatusResponse, ErrorResponse>({
        path: `/wagetransfers/${id}/employees/status`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WageTransfers
     * @name CheckmakesignList
     * @summary Проверка права подписи реестра на зачисление
     * @request GET:/wagetransfers/checkmakesign
     */
    checkmakesignList: (
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<WageTransferCheckMakeSignResponse, ErrorResponse>({
        path: `/wagetransfers/checkmakesign`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WageTransfers
     * @name CopyList
     * @summary Копирование распоряжения на зачисление средств
     * @request GET:/wagetransfers/copy
     */
    copyList: (
      query: { id: string; clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<
        WageTransferInfoResponse,
        ErrorResponse | ValidationResponse
      >({
        path: `/wagetransfers/copy`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение ПФ Распоряжения на зачисление средств в формате PDF
 * 
 * @tags WageTransfers
 * @name PrintDetail
 * @summary Получение ПФ Распоряжения на зачисление средств в формате PDF

 * @request GET:/wagetransfers/{id}/print
 */
    printDetail: (
      id: string,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<File, ErrorResponse>({
        path: `/wagetransfers/${id}/print`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение количества Распоряжений на зачисление средств ожидающих подписания
 * 
 * @tags WageTransfers
 * @name NumberForSignStatusList
 * @summary Количество Распоряжений на зачисление средств ожидающих подписания

 * @request GET:/wagetransfers/number/for-sign-status
 */
    numberForSignStatusList: (
      query: {
        clientId: number;
        contractAbsId?: string;
        payerAccNumSearchText?: string;
        beginDate?: string;
        endDate?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<number, ErrorResponse>({
        path: `/wagetransfers/number/for-sign-status`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Импорт распоряжения на зачисление средств сотрудникам из файла xls
     *
     * @tags WageTransfers
     * @name ImportCreate
     * @summary Импорт распоряжения на зачисление средств сотрудникам из файла xls
     * @request POST:/wagetransfers/import
     */
    importCreate: (
      query: { clientId: number },
      data: { file: File },
      params: RequestParams = {}
    ) =>
      this.request<WageTransferImportResponse, ErrorResponse>({
        path: `/wagetransfers/import`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
 * @description Экспорт распоряжения на зачисление средств сотрудникам в файл xls
 * 
 * @tags WageTransfers
 * @name ExportList
 * @summary Экспорт распоряжения на зачисление средств сотрудникам в файл xls

 * @request GET:/wagetransfers/export
 */
    exportList: (
      query: { id: number; clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<File, ErrorResponse>({
        path: `/wagetransfers/export`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Запрос из ЦФТ статуса реестра на зачисление
 * 
 * @tags WageTransfers
 * @name RequestStatusList
 * @summary Запрос к сервису GetStatusPayrollReq

 * @request GET:/wagetransfers/requestStatus
 */
    requestStatusList: (
      query: {
        id: string;
        clientId: number;
        payrollDate?: string;
        contractId?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<GetStatusPayrollResponse, ErrorResponse>({
        path: `/wagetransfers/requestStatus`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Подписание документа Распоряжения на зачисление средств сотрудникам в рамках зарплатного проекта с помощью PayControl
     *
     * @tags WageTransfers
     * @name SignCreate
     * @summary Подписание документа Распоряжения на зачисление средств сотрудникам в рамках зарплатного проекта с помощью PayControl
     * @request POST:/wagetransfers/{id}/sign
     */
    signCreate: (
      id: string,
      body: WageTransferSignRequest,
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/wagetransfers/${id}/sign`,
        method: "POST",
        body: body,
        format: "json",
        ...params,
      }),

    /**
 * @description Снять подписи с реестра на зачисление ЗП
 * 
 * @tags WageTransfers
 * @name ResetSignUpdate
 * @summary Снять подписи с реестра на зачисление ЗП

 * @request PUT:/wagetransfers/{id}/resetSign
 */
    resetSignUpdate: (
      id: string,
      body: WageTransferSignRequest,
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/wagetransfers/${id}/resetSign`,
        method: "PUT",
        body: body,
        format: "json",
        ...params,
      }),

    /**
     * @description Подписание документа Распоряжения на зачисление средств сотрудникам в рамках зарплатного проекта с помощью PayControl 5.3
     *
     * @tags WageTransfers
     * @name Pc53SignCreate
     * @summary Подписание документа Распоряжения на зачисление средств сотрудникам в рамках зарплатного проекта с помощью PayControl 5.3
     * @request POST:/wagetransfers/{id}/pc53-sign
     */
    pc53SignCreate: (
      id: string,
      body: WageTransferPC53SignRequest,
      params: RequestParams = {}
    ) =>
      this.request<WageTransferPC53SignResponse, ErrorResponse>({
        path: `/wagetransfers/${id}/pc53-sign`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Создание шаблона Распоряжения на зачисление средств
 * 
 * @tags WageTransfers
 * @name TemplatesCreate
 * @summary Создание шаблона Распоряжения на зачисление средств

 * @request POST:/wagetransfers/templates
 */
    templatesCreate: (
      body: WageTransferTemplateRequest,
      params: RequestParams = {}
    ) =>
      this.request<TemplateResponse, ErrorResponse | ValidationResponse>({
        path: `/wagetransfers/templates`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Корректировка распоряжения на зачисление средств
 * 
 * @tags WageTransfers
 * @name CorrectUpdate
 * @summary Корректировка распоряжения на зачисление средств

 * @request PUT:/wagetransfers/{id}/correct
 */
    correctUpdate: (
      id: string,
      query: { clientId: number },
      wageTransfer: WageTransferRequest,
      params: RequestParams = {}
    ) =>
      this.request<DocumentSaveResponse, ErrorResponse | ValidationResponse>({
        path: `/wagetransfers/${id}/correct`,
        method: "PUT",
        query: query,
        body: wageTransfer,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  wagecontract = {
    /**
 * @description Получение информации по условиям обслуживания по договору зарплатного проекта
 * 
 * @tags WageContract
 * @name WagecontractList
 * @summary Условия обслуживания по договору ЗП

 * @request GET:/wagecontract
 */
    wagecontractList: (
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<WageContractInfoResponse, ErrorResponse>({
        path: `/wagecontract`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Получение списка доступных карточных продуктов по договору
     *
     * @tags WageContract
     * @name CardProductDetail
     * @summary Список доступных карточных продуктов по договору
     * @request GET:/wagecontract/{contractAbsId}/card-product
     */
    cardProductDetail: (
      contractAbsId: string,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<CardProductInfoResponse, ErrorResponse>({
        path: `/wagecontract/${contractAbsId}/card-product`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Изменение настроек договора
     *
     * @tags WageContract
     * @name SettingsCreate
     * @summary Изменение настроек договора
     * @request POST:/wagecontract/{id}/settings
     */
    settingsCreate: (
      id: number,
      query: { clientId: number },
      body: WageContractSettings,
      params: RequestParams = {}
    ) =>
      this.request<WageContractInfoResponse, ErrorResponse>({
        path: `/wagecontract/${id}/settings`,
        method: "POST",
        query: query,
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение печатной формы реквизитов для зачисления денежных средств на счета работников в формате PDF
 * 
 * @tags WageContract
 * @name TransfertoemployeePrintDetail
 * @summary Печать реквизитов для зачисления денежных средств на счета работников

 * @request GET:/wagecontract/{contractAbsId}/transfertoemployee/print
 */
    transfertoemployeePrintDetail: (
      contractAbsId: string,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<string, ErrorResponse>({
        path: `/wagecontract/${contractAbsId}/transfertoemployee/print`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение печатной формы реквизитов для перевода комиссии за зачисление денежных средств в формате PDF
 * 
 * @tags WageContract
 * @name TransfercommissionPrintDetail
 * @summary Печать реквизитов для перевода комиссии за зачисление денежных средств

 * @request GET:/wagecontract/{contractAbsId}/transfercommission/print
 */
    transfercommissionPrintDetail: (
      contractAbsId: string,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<string, ErrorResponse>({
        path: `/wagecontract/${contractAbsId}/transfercommission/print`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение печатной формы реквизитов для перевода комиссии за выпуск карт в формате PDF
 * 
 * @tags WageContract
 * @name CardissuingcommissionPrintDetail
 * @summary Печать реквизитов для перевода комиссии за выпуск карт

 * @request GET:/wagecontract/{contractAbsId}/cardissuingcommission/print
 */
    cardissuingcommissionPrintDetail: (
      contractAbsId: string,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<string, ErrorResponse>({
        path: `/wagecontract/${contractAbsId}/cardissuingcommission/print`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Отправка ПФ реквизитов для зачисления денежных средств на счета работников в формате PDF на E-mail
 * 
 * @tags WageContract
 * @name TransfertoemployeeSendDetail
 * @summary Отправка реквизитов для зачисления денежных средств на счета работников на E-mail

 * @request GET:/wagecontract/{contractAbsId}/transfertoemployee/send
 */
    transfertoemployeeSendDetail: (
      contractAbsId: string,
      query?: { clientId?: number; email?: string },
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/wagecontract/${contractAbsId}/transfertoemployee/send`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Отправка ПФ реквизитов для перевода комиссии за зачисление денежных средств в формате PDF на E-mail
 * 
 * @tags WageContract
 * @name TransfercommissionSendDetail
 * @summary Отправка реквизитов для перевода комиссии за зачисление денежных средств на E-mail

 * @request GET:/wagecontract/{contractAbsId}/transfercommission/send
 */
    transfercommissionSendDetail: (
      contractAbsId: string,
      query: { clientId: number; email: string },
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/wagecontract/${contractAbsId}/transfercommission/send`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Отправка ПФ реквизитов для перевода комиссии за выпуск карт в формате PDF на E-mail
 * 
 * @tags WageContract
 * @name CardissuingcommissionSendDetail
 * @summary Отправка реквизитов реквизитов для перевода комиссии за выпуск карт на E-mail

 * @request GET:/wagecontract/{contractAbsId}/cardissuingcommission/send
 */
    cardissuingcommissionSendDetail: (
      contractAbsId: string,
      query: { clientId: number; email: string },
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/wagecontract/${contractAbsId}/cardissuingcommission/send`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  accounts = {
    /**
 * @description Получение списка счетов
 * 
 * @tags Accounts
 * @name AccountsCreate
 * @summary Список счетов

 * @request POST:/accounts
 */
    accountsCreate: (
      query: { clientId: number },
      body: AccountsRequest,
      params: RequestParams = {}
    ) =>
      this.request<AccountsResponse, ErrorResponse>({
        path: `/accounts`,
        method: "POST",
        query: query,
        body: body,
        format: "json",
        ...params,
      }),

    /**
     * @description Получение базового списка открытых и закрытых счетов клиента по идентификатору клиента
     *
     * @tags Accounts
     * @name AccountsList
     * @summary Получение базового списка счетов
     * @request GET:/accounts
     */
    accountsList: (
      query: { clientId: number; isNationalCurrency?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<AccountItem[], ErrorResponse>({
        path: `/accounts`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение списка счетов
 * 
 * @tags Accounts
 * @name ClosedCreate
 * @summary Список счетов

 * @request POST:/accounts/closed
 */
    closedCreate: (
      query: { clientId: number },
      body: AccountsRequest,
      params: RequestParams = {}
    ) =>
      this.request<AccountsResponse, ErrorResponse>({
        path: `/accounts/closed`,
        method: "POST",
        query: query,
        body: body,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение подробной информации о счете
 * 
 * @tags Accounts
 * @name AccountsDetail
 * @summary Информация о счете

 * @request GET:/accounts/{id}
 */
    accountsDetail: (
      id: number,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<AccountDetail, ErrorResponse>({
        path: `/accounts/${id}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение информации по реквизитам счета
 * 
 * @tags Accounts
 * @name RequisitesDetail
 * @summary Реквизиты счета

 * @request GET:/accounts/{id}/requisites
 */
    requisitesDetail: (
      id: number,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<AccountRequisitesResponse, ErrorResponse>({
        path: `/accounts/${id}/requisites`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Отправка реквизитов по счету на E-mail
 * 
 * @tags Accounts
 * @name RequisitesSendDetail
 * @summary Отправка реквизитов по счету на E-mail

 * @request GET:/accounts/{id}/requisites/send
 */
    requisitesSendDetail: (
      id: number,
      query: { clientId: number; email: string },
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/accounts/${id}/requisites/send`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение файа реквизитов
 * 
 * @tags Accounts
 * @name RequisitesLoadDetail
 * @summary Получение файа реквизитов

 * @request GET:/accounts/{id}/requisites/load
 */
    requisitesLoadDetail: (
      id: number,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<string, ErrorResponse>({
        path: `/accounts/${id}/requisites/load`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Список блокировок по счету
 * 
 * @tags Accounts
 * @name BlockInfoDetail
 * @summary Блокировки по счету

 * @request GET:/accounts/{id}/block-info
 */
    blockInfoDetail: (
      id: number,
      query?: { online?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<AccountBlockInfo[], ErrorResponse>({
        path: `/accounts/${id}/block-info`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Выписка по Картотеке №2 по счету
 * 
 * @tags Accounts
 * @name StatementK2Detail
 * @summary Картотека №2 по счету

 * @request GET:/accounts/{id}/statement-k2
 */
    statementK2Detail: (
      id: number,
      query?: { online?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<AccountStatementK2[], ErrorResponse>({
        path: `/accounts/${id}/statement-k2`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Выписка по Картотеке №2 по счету
 * 
 * @tags Accounts
 * @name StatementK2List
 * @summary Картотека №2 по счету

 * @request GET:/accounts/statement-k2
 */
    statementK2List: (
      query: { number: string; online?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<AccountStatementK2[], ErrorResponse>({
        path: `/accounts/statement-k2`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Установить любимый счет
 * 
 * @tags Accounts
 * @name SetFavouriteAccountCreate
 * @summary Установить любимый счет

 * @request POST:/accounts/set-favourite-account
 */
    setFavouriteAccountCreate: (
      body: FavouriteAccountRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        FavouriteAccountResponse,
        ErrorResponse | FavouriteAccountErrorResponse
      >({
        path: `/accounts/set-favourite-account`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Получение тарифного плана счёта
     *
     * @tags Accounts
     * @name TariffPlanDetail
     * @summary Получение тарифного плана счёта
     * @request GET:/accounts/{id}/tariff-plan
     */
    tariffPlanDetail: (id: number, params: RequestParams = {}) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/accounts/${id}/tariff-plan`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  extract = {
    /**
     * @description Получение выписки по списку счетов
     *
     * @tags Extract
     * @name AccountsCreate
     * @summary Выписка по списку счетов
     * @request POST:/extract/accounts
     */
    accountsCreate: (
      body: ExtractAccountsRequest,
      params: RequestParams = {}
    ) =>
      this.request<ExtractResponse, ErrorResponse>({
        path: `/extract/accounts`,
        method: "POST",
        body: body,
        format: "json",
        ...params,
      }),

    /**
     * @description Экспорт выписки по списку счетов в файл
     *
     * @tags Extract
     * @name AccountsExportCreate
     * @summary Экспорт выписки в файл
     * @request POST:/extract/accounts/export
     */
    accountsExportCreate: (
      body: ExtractAccountsRequest,
      params: RequestParams = {}
    ) =>
      this.request<File, ErrorResponse>({
        path: `/extract/accounts/export`,
        method: "POST",
        body: body,
        format: "json",
        ...params,
      }),

    /**
     * @description Экспорт выписки по списку счетов в файл PDF
     *
     * @tags Extract
     * @name AccountsExportPdfCreate
     * @summary Экспорт выписки в файл PDF
     * @request POST:/extract/accounts/export/pdf
     */
    accountsExportPdfCreate: (
      body: ExtractAccountsRequest,
      params: RequestParams = {}
    ) =>
      this.request<File, ErrorResponse>({
        path: `/extract/accounts/export/pdf`,
        method: "POST",
        body: body,
        format: "json",
        ...params,
      }),

    /**
     * @description Отправка выписки по списку счетов на E-mail
     *
     * @tags Extract
     * @name AccountsEmailCreate
     * @summary Отправка выписки на E-mail
     * @request POST:/extract/accounts/email
     */
    accountsEmailCreate: (
      body: ExtractAccountsRequest,
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/extract/accounts/email`,
        method: "POST",
        body: body,
        format: "json",
        ...params,
      }),
  };
  users = {
    /**
 * @description Получение списка разрешений для вида объекта системы
 * 
 * @tags Users
 * @name PermissionsList
 * @summary Список разрешений

 * @request GET:/users/permissions
 */
    permissionsList: (
      query: { entityStrId: string },
      params: RequestParams = {}
    ) =>
      this.request<EntityPermissions, ErrorResponse>({
        path: `/users/permissions`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение списка разрешений для документа
 * 
 * @tags Users
 * @name PermissionsDetail
 * @summary Список разрешений

 * @request GET:/users/permissions/{id}
 */
    permissionsDetail: (id: number, params: RequestParams = {}) =>
      this.request<EntityPermissions, ErrorResponse>({
        path: `/users/permissions/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Получение списка уведомлений пользователя клиента
 * 
 * @tags Users
 * @name NotificationsList
 * @summary Список уведомлений

 * @request GET:/users/notifications
 */
    notificationsList: (
      query?: { type?: string },
      params: RequestParams = {}
    ) =>
      this.request<UserNotification[], ErrorResponse>({
        path: `/users/notifications`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Информация о текущем пользователе
 * 
 * @tags Users
 * @name UsersList
 * @summary Текущий пользователь

 * @request GET:/users
 */
    usersList: (query: { clientId: number }, params: RequestParams = {}) =>
      this.request<UsersResponse, ErrorResponse>({
        path: `/users`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  userRoles = {
    /**
 * @description Роли текущего пользователя у текущего клиента
 * 
 * @tags Users
 * @name UserRolesList
 * @summary Роли текущего пользователя у текущего клиента

 * @request GET:/user-roles
 */
    userRolesList: (params: RequestParams = {}) =>
      this.request<UserRole[], ErrorResponse>({
        path: `/user-roles`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  documents = {
    /**
 * @description Обновить пользователей по данным из ЦФТ
 * 
 * @tags Users, Documents
 * @name JoinIClientRetrieveAbsUsersCreate
 * @summary Обновить пользователей по данным из ЦФТ

 * @request POST:/documents/join-i-client/retrieve-abs-users
 */
    joinIClientRetrieveAbsUsersCreate: (params: RequestParams = {}) =>
      this.request<
        RetrieveAbsUsersResponse,
        ErrorResponse | ValidationResponse
      >({
        path: `/documents/join-i-client/retrieve-abs-users`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
 * @description Данные организации для заявки на подключение к ДБО, полученные из АБС с помощью сервисов GetCustomerDetailsLE_v2 и GetRequestConnectDBOLE
 * 
 * @tags Documents
 * @name JoinIClientInfoFromAbsList
 * @summary Данные организации для заявки на подключение к ДБО

 * @request GET:/documents/join-i-client/info-from-abs
 */
    joinIClientInfoFromAbsList: (params: RequestParams = {}) =>
      this.request<ClientInfoFromABS, ErrorResponse>({
        path: `/documents/join-i-client/info-from-abs`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Создание, сохранение и отправка заявки на подключение к ДБО
 * 
 * @tags Documents
 * @name JoinIClientSaveAndSendCreate
 * @summary Создание, сохранение и отправка заявки на подключение к ДБО

 * @request POST:/documents/join-i-client/save-and-send
 */
    joinIClientSaveAndSendCreate: (
      body: JoinIClientRequest,
      params: RequestParams = {}
    ) =>
      this.request<DocumentSaveResponse, ErrorResponse | ValidationResponse>({
        path: `/documents/join-i-client/save-and-send`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение статуса заявки на подключение к ДБО
 * 
 * @tags Documents
 * @name JoinIClientStateList
 * @summary Информация о заявке на подключение к ДБО

 * @request GET:/documents/join-i-client/state
 */
    joinIClientStateList: (params: RequestParams = {}) =>
      this.request<JoinIClientShortResponse, ErrorResponse>({
        path: `/documents/join-i-client/state`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Получение ПФ "Печать логинов"
 * 
 * @tags Documents
 * @name JoinIClientPrintList
 * @summary Получение ПФ "Печать логинов"

 * @request GET:/documents/join-i-client/print
 */
    joinIClientPrintList: (
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<PdfResponse, ErrorResponse>({
        path: `/documents/join-i-client/print`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Список заявок на регистрацию СИО в реестре УЦ
 * 
 * @tags Documents
 * @name JoinCaList
 * @summary Список заявок на регистрацию СИО в реестре УЦ

 * @request GET:/documents/join-ca
 */
    joinCaList: (
      query?: { position?: number; size?: number },
      params: RequestParams = {}
    ) =>
      this.request<JoinCAResponse, ErrorResponse>({
        path: `/documents/join-ca`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Заявка на регистрацию СИО в реестре УЦ
 * 
 * @tags Documents
 * @name JoinCaDetail
 * @summary Заявка на регистрацию СИО в реестре УЦ

 * @request GET:/documents/join-ca/{id}
 */
    joinCaDetail: (id: string, params: RequestParams = {}) =>
      this.request<JoinCA, ErrorResponse>({
        path: `/documents/join-ca/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Заявка на регистрацию СИО в реестре УЦ в формате PDF
 * 
 * @tags Documents
 * @name JoinCaPrintDetail
 * @summary Заявка на регистрацию СИО в реестре УЦ в формате PDF

 * @request GET:/documents/join-ca/{id}/print
 */
    joinCaPrintDetail: (id: string, params: RequestParams = {}) =>
      this.request<PdfResponse, ErrorResponse>({
        path: `/documents/join-ca/${id}/print`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Печать последней заявки указанного пользователя на регистрацию СИО в реестре УЦ в формате PDF
 * 
 * @tags Documents
 * @name UsersJoinCaPrintDetail
 * @summary Распечатать заявку на подключение (на регистрацию СИО в реестре УЦ в формате PDF)

 * @request GET:/documents/users/{id}/join-ca/print
 */
    usersJoinCaPrintDetail: (id: number, params: RequestParams = {}) =>
      this.request<PdfResponse, ErrorResponse>({
        path: `/documents/users/${id}/join-ca/print`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Заявки на регистрацию СИО в реестре УЦ в формате PDF
 * 
 * @tags Documents
 * @name JoinCaPrintAllList
 * @summary Заявки на регистрацию СИО в реестре УЦ в формате PDF

 * @request GET:/documents/join-ca/print-all
 */
    joinCaPrintAllList: (
      query?: { clientId?: number },
      params: RequestParams = {}
    ) =>
      this.request<PdfResponse, ErrorResponse>({
        path: `/documents/join-ca/print-all`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Печать логинов без привязки к заявкам на подключение к ДБО
 * 
 * @tags Documents
 * @name LoginPrintList
 * @summary Печать логинов без привязки к заявкам на подключение к ДБО

 * @request GET:/documents/login/print
 */
    loginPrintList: (query?: { userId?: number }, params: RequestParams = {}) =>
      this.request<PdfResponse, ErrorResponse>({
        path: `/documents/login/print`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Данные для заявки на выдачу сертификата
 * 
 * @tags Documents
 * @name CertReqCreateList
 * @summary Данные для заявки на выдачу сертификата

 * @request GET:/documents/cert-req-create
 */
    certReqCreateList: (params: RequestParams = {}) =>
      this.request<CertReqCreateData, ErrorResponse>({
        path: `/documents/cert-req-create`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Заявка на выдачу сертификата
 * 
 * @tags Documents
 * @name CertReqDetail
 * @summary Заявка на выдачу сертификата

 * @request GET:/documents/cert-req/{id}
 */
    certReqDetail: (id: string, params: RequestParams = {}) =>
      this.request<CertReq, ErrorResponse>({
        path: `/documents/cert-req/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Последняя заявка на выпуск сертификата для указанного пользователя и текущего клиента в состоянии "Обработка"
 * 
 * @tags Documents
 * @name UserCertReqDetail
 * @summary Последняя заявка на выпуск сертификата

 * @request GET:/documents/user/{id}/cert-req
 */
    userCertReqDetail: (id: number, params: RequestParams = {}) =>
      this.request<CertReqShort, ErrorResponse>({
        path: `/documents/user/${id}/cert-req`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Список заявок на выдачу сертификата
 * 
 * @tags Documents
 * @name CertReqList
 * @summary Список заявок на выдачу сертификата

 * @request GET:/documents/cert-req
 */
    certReqList: (
      query?: { position?: number; size?: number; clientId?: number },
      params: RequestParams = {}
    ) =>
      this.request<CertReqResponse, ErrorResponse>({
        path: `/documents/cert-req`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Создание, сохранение и отправка заявки на сертификат
 * 
 * @tags Documents
 * @name CertReqCreate
 * @summary Создание, сохранение и отправка заявки на сертификат

 * @request POST:/documents/cert-req
 */
    certReqCreate: (body: CertCreateReqRequest, params: RequestParams = {}) =>
      this.request<DocumentSaveResponse, ErrorResponse | ValidationResponse>({
        path: `/documents/cert-req`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Заявка на сертификат в формате PDF
 * 
 * @tags Documents
 * @name CertReqPrintDetail
 * @summary Заявка на сертификат в формате PDF

 * @request GET:/documents/cert-req/{id}/print
 */
    certReqPrintDetail: (id: string, params: RequestParams = {}) =>
      this.request<PdfResponse, ErrorResponse>({
        path: `/documents/cert-req/${id}/print`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Печать последней заявки на выпуск сертификата для указанного пользователя и текущего клиента в состоянии "Обработка" в формате PDF
 * 
 * @tags Documents
 * @name UserCertReqPrintDetail
 * @summary Печать последней заявки на выпуск сертификата в формате PDF

 * @request GET:/documents/user/{id}/cert-req/print
 */
    userCertReqPrintDetail: (id: number, params: RequestParams = {}) =>
      this.request<PdfResponse, ErrorResponse>({
        path: `/documents/user/${id}/cert-req/print`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Запрос на аннулирование сертификата в формате PDF
 * 
 * @tags Documents
 * @name CertCancellingPrintCreate
 * @summary Запрос на аннулирование сертификата в формате PDF

 * @request POST:/documents/cert-cancelling/{id}/print
 */
    certCancellingPrintCreate: (
      id: number,
      body: { cause: string },
      params: RequestParams = {}
    ) =>
      this.request<PdfResponse, ErrorResponse>({
        path: `/documents/cert-cancelling/${id}/print`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Печать сертификата
 * 
 * @tags Documents
 * @name CertPrintDetail
 * @summary Печать сертификата

 * @request GET:/documents/cert/{id}/print
 */
    certPrintDetail: (id: number, params: RequestParams = {}) =>
      this.request<PdfResponse, ErrorResponse>({
        path: `/documents/cert/${id}/print`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * No description
 * 
 * @tags Documents
 * @name LoadCertResultDetail
 * @summary Получить результаты ответа из УЦ

 * @request GET:/documents/load-cert-result/{id}
 */
    loadCertResultDetail: (id: string, params: RequestParams = {}) =>
      this.request<CertCreateResult, ErrorResponse>({
        path: `/documents/load-cert-result/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Завершение активации сертификата
 * 
 * @tags Documents
 * @name LoadCertResultUpdate
 * @summary Завершение активации сертификата

 * @request PUT:/documents/load-cert-result/{id}
 */
    loadCertResultUpdate: (
      id: string,
      body: CryptoAnswerRequest,
      params: RequestParams = {}
    ) =>
      this.request<DocumentSaveResponse, ErrorResponse | ValidationResponse>({
        path: `/documents/load-cert-result/${id}`,
        method: "PUT",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Запрос на вывод полей ККБ
 * 
 * @tags Documents
 * @name CryptoBlockInfoDetail
 * @summary Запрос на вывод полей ККБ

 * @request GET:/documents/crypto-block-info/{id}
 */
    cryptoBlockInfoDetail: (id: string, params: RequestParams = {}) =>
      this.request<CryptoBlockInfoResponse, ErrorResponse>({
        path: `/documents/crypto-block-info/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Запрос на вывод полей ККБ,  вторая версия эндпоинта, не требовательная к наличию активного сертификата пользователя
 * 
 * @tags Documents
 * @name CryptoBlockInfoV2Detail
 * @summary Запрос на вывод полей ККБ, вторая версия эндпоинта, не требовательная к наличию активного сертификата пользователя

 * @request GET:/documents/crypto-block-info/v2/{id}
 */
    cryptoBlockInfoV2Detail: (id: string, params: RequestParams = {}) =>
      this.request<CryptoBlockInfoResponse, ErrorResponse>({
        path: `/documents/crypto-block-info/v2/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Импорта документов из файла в формате 1С
     *
     * @tags Documents
     * @name Import1CCreate
     * @summary Импорта документов из 1С
     * @request POST:/documents/import1c
     */
    import1CCreate: (
      query: { clientId: number },
      data: { file: File },
      params: RequestParams = {}
    ) =>
      this.request<ImportResponse, ErrorResponse>({
        path: `/documents/import1c`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение подробной информации о типе подписи для документа а также о имеющихся подписях у документа
 * 
 * @tags Documents
 * @name CheckSignDetail
 * @summary Получение информации о типе и количестве подписей для документа

 * @request GET:/documents/{id}/checkSign
 */
    checkSignDetail: (
      id: number,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<DocumentCheckSignResponse, ErrorResponse>({
        path: `/documents/${id}/checkSign`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Проверка полномочий и доступных сертификатов для подписания документа
     *
     * @tags Documents
     * @name CheckCompetenceAndCertDetail
     * @summary Проверка полномочий и доступных сертификатов
     * @request GET:/documents/{id}/check-competence-and-cert
     */
    checkCompetenceAndCertDetail: (id: number, params: RequestParams = {}) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/documents/${id}/check-competence-and-cert`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Подписание документа с помощью ЭП
     *
     * @tags Documents
     * @name SignCreate
     * @summary Подписание документа
     * @request POST:/documents/sign
     */
    signCreate: (body: DocumentSigningRequest, params: RequestParams = {}) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/documents/sign`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Подписание документа через PayControl
     *
     * @tags Documents
     * @name SignPayControlCreate
     * @summary Подписание документа через PayControl
     * @request POST:/documents/sign/pay-control
     */
    signPayControlCreate: (
      body: PayControlDocumentSignRequest,
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/documents/sign/pay-control`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Подписание документа с помощью PayControl 5.3
     *
     * @tags Documents
     * @name Pc53SignCreate
     * @summary Подписание документа с помощью PayControl 5.3
     * @request POST:/documents/{id}/pc53-sign
     */
    pc53SignCreate: (
      id: string,
      body: DocumentPC53SignRequest,
      params: RequestParams = {}
    ) =>
      this.request<DocumentPC53SignResponse, ErrorResponse>({
        path: `/documents/${id}/pc53-sign`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Получить историю статусов документа
 * 
 * @tags Documents
 * @name HistoryDetail
 * @summary Получить историю статусов документа

 * @request GET:/documents/history/{id}
 */
    historyDetail: (id: number, params: RequestParams = {}) =>
      this.request<DocumentHistoryResponseList, ErrorResponse>({
        path: `/documents/history/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Проверка лимитов при массовом подписании
 * 
 * @tags Documents
 * @name LimitsCreate
 * @summary Проверка лимитов при массовом подписании

 * @request POST:/documents/limits
 */
    limitsCreate: (body: DocumentsLimitsRequest, params: RequestParams = {}) =>
      this.request<DocumentsLimitsResponse, ErrorResponse>({
        path: `/documents/limits`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  balance = {
    /**
 * @description Получение списка остатков счетов
 * 
 * @tags Accounts
 * @name BalanceList
 * @summary Список остатков счетов

 * @request GET:/balance
 */
    balanceList: (query: { clientId: number }, params: RequestParams = {}) =>
      this.request<BalanceResponse, ErrorResponse>({
        path: `/balance`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  payments = {
    /**
 * @description Список платежных документов
 * 
 * @tags Payments
 * @name PaymentsList
 * @summary Список платежных документов

 * @request GET:/payments
 */
    paymentsList: (
      query: {
        clientId: number;
        accountId?: number;
        position?: number;
        size?: number;
        searchText?: string;
        stateList?: string[];
        documentList?: string[];
        beginDate?: string;
        endDate?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<PaymentsResponse, ErrorResponse>({
        path: `/payments`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Создание платежа
 * 
 * @tags Payments
 * @name PaymentsCreate
 * @summary Создание платежа

 * @request POST:/payments
 */
    paymentsCreate: (body: PaymentRequest, params: RequestParams = {}) =>
      this.request<DocumentSaveResponse, ErrorResponse | ValidationResponse>({
        path: `/payments`,
        method: "POST",
        body: body,
        format: "json",
        ...params,
      }),

    /**
 * @description Список платежных документов
 * 
 * @tags Payments
 * @name WageissuingcardsList
 * @summary Список платежных документов

 * @request GET:/payments/wageissuingcards
 */
    wageissuingcardsList: (
      query: {
        clientId: number;
        accountId?: number;
        position?: number;
        size?: number;
        searchText?: string;
        stateList?: string[];
        documentList?: string[];
        beginDate?: string;
        endDate?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<PaymentsResponse, ErrorResponse>({
        path: `/payments/wageissuingcards`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Создание платежа
 * 
 * @tags Payments
 * @name WageissuingcardsCreate
 * @summary Создание платежа

 * @request POST:/payments/wageissuingcards
 */
    wageissuingcardsCreate: (
      body: PaymentRequest,
      params: RequestParams = {}
    ) =>
      this.request<DocumentSaveResponse, ErrorResponse | ValidationResponse>({
        path: `/payments/wageissuingcards`,
        method: "POST",
        body: body,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name PermissionsCreate
     * @summary Создание платежа и переход к оплате
     * @request POST:/payments/permissions
     */
    permissionsCreate: (
      query: { absId: string; branchId: string },
      body: DocumentsIdRequest,
      params: RequestParams = {}
    ) =>
      this.request<DocumentPermissionsShort, ErrorResponse>({
        path: `/payments/permissions`,
        method: "POST",
        query: query,
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name PostPayments
     * @summary Создание платежа и переход к оплате
     * @request POST:/payments/pay
     */
    postPayments: (
      body: PaymentRequest,
      query?: { id?: string },
      params: RequestParams = {}
    ) =>
      this.request<DocumentSaveResponse, ErrorResponse | ValidationResponse>({
        path: `/payments/pay`,
        method: "POST",
        query: query,
        body: body,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name SendCreate
     * @summary Отправка платёжного документа в банк
     * @request POST:/payments/send
     */
    sendCreate: (body: PaymentsSend, params: RequestParams = {}) =>
      this.request<DocumentSaveResponse, ErrorResponse>({
        path: `/payments/send`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name CopyList
     * @summary Копирование платежного документа
     * @request GET:/payments/copy
     */
    copyList: (
      query: { id: string; clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<PaymentInfoResponse, ErrorResponse | ValidationResponse>({
        path: `/payments/copy`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение подробной информации об исходящем платеже
 * 
 * @tags Payments
 * @name PaymentsDetail
 * @summary Информация о платеже

 * @request GET:/payments/{id}
 */
    paymentsDetail: (
      id: string,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<PaymentInfoResponse, ErrorResponse>({
        path: `/payments/${id}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name PaymentsUpdate
     * @summary Редактирование платежа
     * @request PUT:/payments/{id}
     */
    paymentsUpdate: (
      id: string,
      body: PaymentRequest,
      params: RequestParams = {}
    ) =>
      this.request<DocumentSaveResponse, ErrorResponse | ValidationResponse>({
        path: `/payments/${id}`,
        method: "PUT",
        body: body,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name PaymentsDelete
     * @summary Удаление платежа
     * @request DELETE:/payments/{id}
     */
    paymentsDelete: (
      id: string,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, PaymentFailedDeleteResponse | ErrorResponse>({
        path: `/payments/${id}`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Снять подписи с платежного документа
 * 
 * @tags Payments
 * @name ResetSignUpdate
 * @summary Снять подписи с платежного документа

 * @request PUT:/payments/{id}/resetSign
 */
    resetSignUpdate: (
      id: string,
      body: PaymentSignRequest,
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/payments/${id}/resetSign`,
        method: "PUT",
        body: body,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name PrintDetail
     * @summary Платежный документ в формате PDF
     * @request GET:/payments/{id}/print
     */
    printDetail: (
      id: string,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<File, ErrorResponse>({
        path: `/payments/${id}/print`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name RevokeDetail
     * @summary Документ отзыва для платежного документа
     * @request GET:/payments/{id}/revoke
     */
    revokeDetail: (
      id: string,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<Revoke, ErrorResponse>({
        path: `/payments/${id}/revoke`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение очередного актуального номера платежного документа
 * 
 * @tags Payments
 * @name NumberList
 * @summary Очередной номер платежного документа

 * @request GET:/payments/number
 */
    numberList: (
      query: { clientId: number; kind: string },
      params: RequestParams = {}
    ) =>
      this.request<PaymentNumberResponse, ErrorResponse>({
        path: `/payments/number`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение очередного актуального номера платежного документа
 * 
 * @tags Payments
 * @name WageissuingcardsNumberList
 * @summary Очередной номер платежного документа

 * @request GET:/payments/wageissuingcards/number
 */
    wageissuingcardsNumberList: (
      query: { clientId: number; kind: string },
      params: RequestParams = {}
    ) =>
      this.request<PaymentNumberResponse, ErrorResponse>({
        path: `/payments/wageissuingcards/number`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Поиск контрагентов клиента
 * 
 * @tags Payments
 * @name CorrespondentsList
 * @summary Список контрагентов

 * @request GET:/payments/correspondents
 */
    correspondentsList: (
      query: {
        clientId: number;
        search?: string;
        position?: number;
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<CorrespondentsResponse, ErrorResponse>({
        path: `/payments/correspondents`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name CorrespondentsCreate
     * @summary Сохранить нового клиентского контрагента
     * @request POST:/payments/correspondents
     */
    correspondentsCreate: (
      query: { clientId: number },
      body: CorrespondentRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        Correspondent,
        ErrorResponse | PaymentMember | ValidationResponse
      >({
        path: `/payments/correspondents`,
        method: "POST",
        query: query,
        body: body,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name CorrespondentsUpdate
     * @summary Обновить клиентского контрагента
     * @request PUT:/payments/correspondents/{id}
     */
    correspondentsUpdate: (
      id: string,
      query: { clientId: number },
      body: CorrespondentRequest,
      params: RequestParams = {}
    ) =>
      this.request<Correspondent, ErrorResponse | ValidationResponse>({
        path: `/payments/correspondents/${id}`,
        method: "PUT",
        query: query,
        body: body,
        format: "json",
        ...params,
      }),

    /**
 * @description Удаление контрагента клиента
 * 
 * @tags Payments
 * @name CorrespondentsDelete
 * @summary Удаление контрагента клиента

 * @request DELETE:/payments/correspondents/{id}
 */
    correspondentsDelete: (
      id: string,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/payments/correspondents/${id}`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение экспресс-отчета по контрагенту
 * 
 * @tags Payments
 * @name CorrespondentsBriefReportList
 * @summary Получение экспресс-отчета по контрагенту

 * @request GET:/payments/correspondents/brief-report
 */
    correspondentsBriefReportList: (
      query: {
        inn: string;
        mobileApp?: boolean;
        mobileOs?: string;
        requestFrom?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<CorrespondentBriefReportResponse, ErrorResponse>({
        path: `/payments/correspondents/brief-report`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name CorrespondentsBriefReportFileList
     * @summary Получение экспресс-отчета по контрагенту в файле
     * @request GET:/payments/correspondents/brief-report-file
     */
    correspondentsBriefReportFileList: (
      query: {
        inn: string;
        mobileApp?: boolean;
        mobileOs?: string;
        requestFrom?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<File, ErrorResponse>({
        path: `/payments/correspondents/brief-report-file`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение полного списка счетов списания/зачисления клиента
 * 
 * @tags Payments
 * @name AccountsList
 * @summary Список счетов списания/зачисления клиента

 * @request GET:/payments/accounts
 */
    accountsList: (
      query: { clientId: number; type?: string },
      params: RequestParams = {}
    ) =>
      this.request<AccountPayment[], ErrorResponse>({
        path: `/payments/accounts`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Признак отображения/скрытия поля "Код валютной операции"
 * 
 * @tags Payments
 * @name IsCurrencyPaymentList
 * @summary Признак отображения поля "Код валютной операции"

 * @request GET:/payments/is-currency-payment
 */
    isCurrencyPaymentList: (
      query: {
        payerAcc: string;
        receiverAcc: string;
        receiverCorAcc?: string;
        payerName?: string;
        ground?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<IsCurrencyPaymentResponse, ErrorResponse>({
        path: `/payments/is-currency-payment`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение количества документов ожидающих подписания
 * 
 * @tags Payments
 * @name NumberForSignStatusList
 * @summary Количество документов ожидающих подписания

 * @request GET:/payments/number/for-sign-status
 */
    numberForSignStatusList: (
      query: {
        clientId: number;
        accountId?: number;
        searchText?: string;
        documentList?: string[];
        beginDate?: string;
        endDate?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<number, ErrorResponse>({
        path: `/payments/number/for-sign-status`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Проверка даты создания платёжного документа
     *
     * @tags Payments
     * @name CheckDocumentDateDetail
     * @summary Проверка даты создания платёжного документа
     * @request GET:/payments/{id}/check/document-date
     */
    checkDocumentDateDetail: (id: number, params: RequestParams = {}) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/payments/${id}/check/document-date`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Подписание платежа с помощью PayControl
 * 
 * @tags Payments
 * @name SignCreate
 * @summary Подписание платежа с помощью PayControl

 * @request POST:/payments/{id}/sign
 */
    signCreate: (
      id: string,
      body: PaymentSignRequest,
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/payments/${id}/sign`,
        method: "POST",
        body: body,
        format: "json",
        ...params,
      }),

    /**
 * @description Подписание платежа с помощью PayControl 5.3
 * 
 * @tags Payments
 * @name Pc53SignCreate
 * @summary Подписание платежа с помощью PayControl 5.3

 * @request POST:/payments/{id}/pc53-sign
 */
    pc53SignCreate: (
      id: string,
      body: PaymentPC53SignRequest,
      params: RequestParams = {}
    ) =>
      this.request<PaymentPC53SignResponse, ErrorResponse>({
        path: `/payments/${id}/pc53-sign`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Поиск государственных начисления по УИН и получение предзаполненного документа
     *
     * @tags Payments
     * @name ChargeCreate
     * @summary Поиск государственных начисления по УИН и получение предзаполненного документа
     * @request POST:/payments/charge
     */
    chargeCreate: (body: PaymentChargingRequest, params: RequestParams = {}) =>
      this.request<PaymentChargingResponse, ErrorResponse>({
        path: `/payments/charge`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Создание платежа по фотографии счета
     *
     * @tags Payments
     * @name ByImageCreate
     * @summary Создание платежа по фотографии счета
     * @request POST:/payments/by-image
     */
    byImageCreate: (body: PaymentPhotoRequest, params: RequestParams = {}) =>
      this.request<PaymentByImageResponse, ErrorResponse>({
        path: `/payments/by-image`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  revokes = {
    /**
     * @description Создание заявления на отзыв документа и, если возможно, отправка в банк
     *
     * @tags Revokes
     * @name RevokesCreate
     * @summary Создание заявления на отзыв документа и, если возможно, отправка в банк
     * @request POST:/revokes
     */
    revokesCreate: (body: RevokeRequest, params: RequestParams = {}) =>
      this.request<DocumentSaveResponse, ErrorResponse | ValidationResponse>({
        path: `/revokes`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Подписание отзыва платежа с помощью PayControl
     *
     * @tags Revokes
     * @name SignCreate
     * @summary Подписание отзыва платежа с помощью PayControl
     * @request POST:/revokes/{id}/sign
     */
    signCreate: (
      id: string,
      body: RevokeSignRequest,
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/revokes/${id}/sign`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Подписание отзыва платежа с помощью PayControl 5.3
 * 
 * @tags Revokes
 * @name Pc53SignCreate
 * @summary Подписание отзыва платежа с помощью PayControl 5.3

 * @request POST:/revokes/{id}/pc53-sign
 */
    pc53SignCreate: (
      id: string,
      body: RevokePC53SignRequest,
      params: RequestParams = {}
    ) =>
      this.request<RevokePC53SignResponse, ErrorResponse>({
        path: `/revokes/${id}/pc53-sign`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Получение детальной информации отзыва
     *
     * @tags Revokes
     * @name RevokesDetail
     * @summary Получение детальной информации отзыва
     * @request GET:/revokes/{id}
     */
    revokesDetail: (id: number, params: RequestParams = {}) =>
      this.request<RevokeResponse, ErrorResponse>({
        path: `/revokes/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Получение детальной информации отзыва по отзываемому документу
     *
     * @tags Revokes
     * @name DocumentRefDetail
     * @summary Получение детальной информации отзыва по отзываемому документу
     * @request GET:/revokes/document-ref/{id}
     */
    documentRefDetail: (id: number, params: RequestParams = {}) =>
      this.request<RevokeResponse, ErrorResponse>({
        path: `/revokes/document-ref/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  templates = {
    /**
 * @description Получение списка шаблонов
 * 
 * @tags Templates
 * @name TemplatesList
 * @summary Список шаблонов

 * @request GET:/templates
 */
    templatesList: (
      query?: {
        position?: number;
        size?: number;
        searchText?: string;
        kind?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TemplatesResponse, ErrorResponse>({
        path: `/templates`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Создание шаблона
 * 
 * @tags Templates
 * @name TemplatesCreate
 * @summary Создание шаблона

 * @request POST:/templates
 */
    templatesCreate: (body: TemplateRequest, params: RequestParams = {}) =>
      this.request<TemplateResponse, ErrorResponse | ValidationResponse>({
        path: `/templates`,
        method: "POST",
        body: body,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение подробной информации о шаблоне
 * 
 * @tags Templates
 * @name TemplatesDetail
 * @summary Информация о шаблоне

 * @request GET:/templates/{id}
 */
    templatesDetail: (id: string, params: RequestParams = {}) =>
      this.request<TemplateInfoResponse, ErrorResponse>({
        path: `/templates/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Удаление шаблона
 * 
 * @tags Templates
 * @name TemplatesDelete
 * @summary Удаление шаблона

 * @request DELETE:/templates/{id}
 */
    templatesDelete: (id: string, params: RequestParams = {}) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/templates/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
 * @description Редактирование шаблона
 * 
 * @tags Templates
 * @name TemplatesUpdate
 * @summary Редактирование шаблона

 * @request PUT:/templates/{id}
 */
    templatesUpdate: (
      id: string,
      body: TemplateRequest,
      params: RequestParams = {}
    ) =>
      this.request<TemplateResponse, ErrorResponse | ValidationResponse>({
        path: `/templates/${id}`,
        method: "PUT",
        body: body,
        format: "json",
        ...params,
      }),
  };
  dict = {
    /**
 * @description Получение полного списка валют
 * 
 * @tags Dict
 * @name CurrencyList
 * @summary Список валют

 * @request GET:/dict/currency
 */
    currencyList: (params: RequestParams = {}) =>
      this.request<Currency[], ErrorResponse>({
        path: `/dict/currency`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Поиск банков по БИК / SWIFT при включеном параметре 'swift'
 * 
 * @tags Dict
 * @name BanksList
 * @summary Список банков

 * @request GET:/dict/banks
 */
    banksList: (
      query: {
        search: string;
        swift?: boolean;
        position?: number;
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<BanksResponse, ErrorResponse>({
        path: `/dict/banks`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение полного списка стран
 * 
 * @tags Dict
 * @name CountryList
 * @summary Список стран

 * @request GET:/dict/country
 */
    countryList: (params: RequestParams = {}) =>
      this.request<CountryResponse, ErrorResponse>({
        path: `/dict/country`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Получение списка адресов
 * 
 * @tags Dict
 * @name AddressList
 * @summary Список адресов

 * @request GET:/dict/address
 */
    addressList: (
      query?: { search?: string; position?: number; size?: number },
      params: RequestParams = {}
    ) =>
      this.request<AddressResponse, ErrorResponse>({
        path: `/dict/address`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение списка регионов и районов (level: region - область, край, area - Район)
 * 
 * @tags Dict
 * @name AddressRegionList
 * @summary Список регионов и районов

 * @request GET:/dict/address/region
 */
    addressRegionList: (
      query?: { search?: string; position?: number; size?: number },
      params: RequestParams = {}
    ) =>
      this.request<AddressResponse, ErrorResponse>({
        path: `/dict/address/region`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение списка адресов и населенных пунктов (level:  city - Город,  locality - Населенный пункт)
 * 
 * @tags Dict
 * @name AddressCityList
 * @summary Список адресов и населенных пунктов

 * @request GET:/dict/address/city
 */
    addressCityList: (
      query?: { search?: string; position?: number; size?: number },
      params: RequestParams = {}
    ) =>
      this.request<AddressResponse, ErrorResponse>({
        path: `/dict/address/city`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение списка улиц (level: street - Улица)
 * 
 * @tags Dict
 * @name AddressStreetList
 * @summary Список улиц

 * @request GET:/dict/address/street
 */
    addressStreetList: (
      query?: { search?: string; position?: number; size?: number },
      params: RequestParams = {}
    ) =>
      this.request<AddressResponse, ErrorResponse>({
        path: `/dict/address/street`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение списка домов
 * 
 * @tags Dict
 * @name AddressHouseDetail
 * @summary Список домов

 * @request GET:/dict/address/{uuid}/house
 */
    addressHouseDetail: (
      uuid: string,
      query?: { search?: string },
      params: RequestParams = {}
    ) =>
      this.request<HouseResponse, ErrorResponse>({
        path: `/dict/address/${uuid}/house`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение списка значений справочника
 * 
 * @tags Dict
 * @name DictDetail
 * @summary Список значений справочника

 * @request GET:/dict/{name}
 */
    dictDetail: (
      name: string,
      query?: {
        processCode?: string;
        search?: string;
        position?: number;
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<DictResponse, ErrorResponse>({
        path: `/dict/${name}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение глобальных настроек приложения
 * 
 * @tags Dict
 * @name GlobalSettingsList
 * @summary Получение глобальных настроек приложения

 * @request GET:/dict/global-settings
 */
    globalSettingsList: (params: RequestParams = {}) =>
      this.request<GlobalSettingsResponse, ErrorResponse>({
        path: `/dict/global-settings`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Получение настроек стойкости пароля
 * 
 * @tags Dict
 * @name PassStrengthSettingsList
 * @summary Получение настроек стойкости пароля

 * @request GET:/dict/pass-strength-settings
 */
    passStrengthSettingsList: (params: RequestParams = {}) =>
      this.request<StrengthSettingsResponse, ErrorResponse>({
        path: `/dict/pass-strength-settings`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Получение лицензии JCWebClient
 * 
 * @tags Dict
 * @name JcwebclientLicenseList
 * @summary Получение лицензии JCWebClient

 * @request GET:/dict/jcwebclient-license
 */
    jcwebclientLicenseList: (params: RequestParams = {}) =>
      this.request<JCWebClientResponse, ErrorResponse>({
        path: `/dict/jcwebclient-license`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Обязательность для пользователя установки компонента от компании Аладдин в новом UI
 * 
 * @tags Dict
 * @name AuthAladdinRequiredList
 * @summary Обязательность для пользователя установки компонента от компании Аладдин в новом UI

 * @request GET:/dict/auth-aladdin-required
 */
    authAladdinRequiredList: (params: RequestParams = {}) =>
      this.request<boolean, ErrorResponse>({
        path: `/dict/auth-aladdin-required`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Тарифные планы по счётам
     *
     * @tags Dict
     * @name TariffPlanAllList
     * @summary Тарифные планы по счётам
     * @request GET:/dict/tariff-plan/all
     */
    tariffPlanAllList: (
      query?: { imageType?: string },
      params: RequestParams = {}
    ) =>
      this.request<DictTariffPlanResponse[], ErrorResponse>({
        path: `/dict/tariff-plan/all`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Получить услуги тарифных планов
     *
     * @tags Dict
     * @name TariffPlanServicesList
     * @summary Услуги тарифных планов
     * @request GET:/dict/tariff-plan-services
     */
    tariffPlanServicesList: (
      query?: { imageType?: string },
      params: RequestParams = {}
    ) =>
      this.request<DictTariffPlanService[], ErrorResponse>({
        path: `/dict/tariff-plan-services`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Получить описания картинок для тарифных планов и услуг тарифных планов
     *
     * @tags Dict
     * @name TariffPlanImagesList
     * @summary Картинки для тарифных планов
     * @request GET:/dict/tariff-plan-images
     */
    tariffPlanImagesList: (
      query?: { imageType?: string; tariffKind?: string },
      params: RequestParams = {}
    ) =>
      this.request<DictTariffPlanImage[], ErrorResponse>({
        path: `/dict/tariff-plan-images`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Получить картинку для тарифного плана или услуги тарифного плана
     *
     * @tags Dict
     * @name TariffPlanImagesDetail
     * @summary Картинка для тарифного плана
     * @request GET:/dict/tariff-plan-images/{id}
     */
    tariffPlanImagesDetail: (
      id: string,
      query?: { preview?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<File, ErrorResponse>({
        path: `/dict/tariff-plan-images/${id}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Получение списка значений конкретного кодификатора
     *
     * @tags Dict
     * @name CodeKindsList
     * @summary Список значений кодификатора
     * @request GET:/dict/codeKinds
     */
    codeKindsList: (
      query: {
        name: string;
        searchText?: string;
        position?: number;
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<CodeKindsResponse, ErrorResponse>({
        path: `/dict/codeKinds`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Получить Виды справок
     *
     * @tags Dict
     * @name ReferencesList
     * @summary Виды справок
     * @request GET:/dict/references
     */
    referencesList: (params: RequestParams = {}) =>
      this.request<DictTypeReferences[], ErrorResponse>({
        path: `/dict/references`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Получение ссылок на api по версии и сборке приложения
 * 
 * @tags Dict
 * @name ApiSettingsList
 * @summary Получение ссылок на api по версии и сборке приложения

 * @request GET:/dict/api/settings
 */
    apiSettingsList: (
      query: { version: string; build: string; store: string },
      params: RequestParams = {}
    ) =>
      this.request<ApiSettingsResponse[], ErrorResponse>({
        path: `/dict/api/settings`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  banners = {
    /**
 * No description
 * 
 * @tags News
 * @name BannersList
 * @summary Получить список баннеров

 * @request GET:/banners
 */
    bannersList: (query: { clientId: number }, params: RequestParams = {}) =>
      this.request<BannersResponse, ErrorResponse>({
        path: `/banners`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * No description
 * 
 * @tags News
 * @name GetBanners
 * @summary Получить список баннеров для "Свой бизнес Mobile"

 * @request GET:/banners/mb
 */
    getBanners: (query: { clientId: number }, params: RequestParams = {}) =>
      this.request<BannersMobileResponse, ErrorResponse>({
        path: `/banners/mb`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Загрузить баннер с сервера
 * 
 * @tags Files
 * @name BannersDetail
 * @summary Загрузить баннер с сервера

 * @request GET:/banners/{id}
 */
    bannersDetail: (
      id: string,
      query?: { imageType?: string; bigBanner?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<File, ErrorResponse>({
        path: `/banners/${id}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * No description
 * 
 * @tags News
 * @name ReadCreate
 * @summary Установить признак, что баннер закрыт

 * @request POST:/banners/read
 */
    readCreate: (body: CloseRequest, params: RequestParams = {}) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/banners/read`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  files = {
    /**
 * @description Загрузить файл из вложения
 * 
 * @tags Files
 * @name FilesDetail
 * @summary Загрузить файл из вложения

 * @request GET:/files/{type}/{id}/{attachId}
 */
    filesDetail: (
      type: string,
      id: string,
      attachId: number,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<File, ErrorResponse>({
        path: `/files/${type}/${id}/${attachId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Удалить файл из вложения
 * 
 * @tags Files
 * @name FilesDelete
 * @summary Удалить файл из вложения

 * @request DELETE:/files/{type}/{id}/{attachId}
 */
    filesDelete: (
      type: string,
      id: string,
      attachId: number,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<AttachmentInfo, ErrorResponse>({
        path: `/files/${type}/${id}/${attachId}`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Загрузить файл на сервера в конкретное письмо
 * 
 * @tags Files
 * @name FilesCreate
 * @summary Загрузить файл на сервер в конкретное письмо

 * @request POST:/files/{type}/{id}
 */
    filesCreate: (
      type: string,
      id: string,
      query: { clientId: number },
      data: { file: File },
      params: RequestParams = {}
    ) =>
      this.request<AttachmentInfo, ErrorResponse>({
        path: `/files/${type}/${id}`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
 * @description Редактирование прикрепленного файла.
 * 
 * @tags Files
 * @name FilesUpdate
 * @summary Редактирование прикрепленного файла.

 * @request PUT:/files/{type}/{id}
 */
    filesUpdate: (
      type: string,
      id: string,
      query: { clientId: number },
      editFileRequest: EditFilesRequest,
      params: RequestParams = {}
    ) =>
      this.request<AttachmentInfo[], ErrorResponse>({
        path: `/files/${type}/${id}`,
        method: "PUT",
        query: query,
        body: editFileRequest,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  letters = {
    /**
     * @description Получение списка писем
     *
     * @tags Letters
     * @name LettersList
     * @summary Список входящих писем
     * @request GET:/letters
     */
    lettersList: (
      query: { clientId: number; position?: number; size?: number },
      params: RequestParams = {}
    ) =>
      this.request<LettersResponse, ErrorResponse>({
        path: `/letters`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Создание письма
     *
     * @tags Letters
     * @name LettersCreate
     * @summary Создание письма
     * @request POST:/letters
     */
    lettersCreate: (
      query: { clientId: number; parentId?: number },
      body: LetterRequest,
      params: RequestParams = {}
    ) =>
      this.request<LetterInfo, ErrorResponse | ValidationResponse>({
        path: `/letters`,
        method: "POST",
        query: query,
        body: body,
        format: "json",
        ...params,
      }),

    /**
     * @description Получение списка вложений письма
     *
     * @tags Letters
     * @name AttachmentsList
     * @summary Список вложений письма
     * @request GET:/letters/attachments
     */
    attachmentsList: (
      query: { clientId: number; id?: number },
      params: RequestParams = {}
    ) =>
      this.request<AttachmentsResponse, ErrorResponse>({
        path: `/letters/attachments`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Список прав доступа пользователя
     *
     * @tags Letters
     * @name PermissionsList
     * @summary Список прав доступа пользователя
     * @request GET:/letters/permissions
     */
    permissionsList: (
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<LettersPermissions, ErrorResponse>({
        path: `/letters/permissions`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Отправка письма
     *
     * @tags Letters
     * @name SendCreate
     * @summary Отправка письма
     * @request POST:/letters/send
     */
    sendCreate: (
      query: { clientId: number; id?: string; parentId?: number },
      body: LetterRequest,
      params: RequestParams = {}
    ) =>
      this.request<LetterSendResponse, ErrorResponse>({
        path: `/letters/send`,
        method: "POST",
        query: query,
        body: body,
        format: "json",
        ...params,
      }),

    /**
     * @description Поиск писем
     *
     * @tags Letters
     * @name SearchList
     * @summary Поиск писем
     * @request GET:/letters/search
     */
    searchList: (
      query: {
        clientId: number;
        text?: string;
        type?: string;
        beginDate?: string;
        endDate?: string;
        position?: number;
        size?: number;
        mailBoxId?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<LettersSearchResponse, ErrorResponse>({
        path: `/letters/search`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Получение списка писем черновика
     *
     * @tags Letters
     * @name DraftList
     * @summary Список писем черновика
     * @request GET:/letters/draft
     */
    draftList: (
      query: { clientId: number; position?: number; size?: number },
      params: RequestParams = {}
    ) =>
      this.request<LettersResponse, ErrorResponse>({
        path: `/letters/draft`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Получение количества входящих писем
     *
     * @tags Letters
     * @name CountList
     * @summary Количество входящих писем
     * @request GET:/letters/count
     */
    countList: (
      query: { clientId: number; senderId: string },
      params: RequestParams = {}
    ) =>
      this.request<LetterCountResponse, ErrorResponse>({
        path: `/letters/count`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Letters
     * @name LettersDetail
     * @summary Получаем конкретное письмо
     * @request GET:/letters/{id}
     */
    lettersDetail: (
      id: string,
      query: { clientId: string },
      params: RequestParams = {}
    ) =>
      this.request<LetterInfo, ErrorResponse>({
        path: `/letters/${id}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Редактирование письма
     *
     * @tags Letters
     * @name LettersUpdate
     * @summary Редактирование письма
     * @request PUT:/letters/{id}
     */
    lettersUpdate: (
      id: string,
      query: { clientId: number },
      body: LetterRequest,
      params: RequestParams = {}
    ) =>
      this.request<LetterInfo, ErrorResponse>({
        path: `/letters/${id}`,
        method: "PUT",
        query: query,
        body: body,
        format: "json",
        ...params,
      }),

    /**
     * @description Удаление письма
     *
     * @tags Letters
     * @name LettersDelete
     * @summary Удаление письма
     * @request DELETE:/letters/{id}
     */
    lettersDelete: (
      id: string,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/letters/${id}`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Letters
     * @name ReadCreate
     * @summary Установить признак, что письмо прочитано
     * @request POST:/letters/{id}/read
     */
    readCreate: (
      id: string,
      query: { clientId: number; isRead?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, any>({
        path: `/letters/${id}/read`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Получение количества непрочитанных писем
     *
     * @tags Letters
     * @name UnreadList
     * @summary Количество непрочитанных писем
     * @request GET:/letters/unread
     */
    unreadList: (query: { clientId: number }, params: RequestParams = {}) =>
      this.request<LetterCountResponse, ErrorResponse>({
        path: `/letters/unread`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Получение списка отправленных писем
     *
     * @tags Letters
     * @name OutboxList
     * @summary Список отправленных писем
     * @request GET:/letters/outbox
     */
    outboxList: (
      query: { clientId: number; position?: number; size?: number },
      params: RequestParams = {}
    ) =>
      this.request<LettersResponse, ErrorResponse>({
        path: `/letters/outbox`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Получение списка возможных адресатов в новом письме
     *
     * @tags Letters
     * @name SendtoList
     * @summary Список возможных адресатов в новом письме
     * @request GET:/letters/sendto
     */
    sendtoList: (query: { clientId: number }, params: RequestParams = {}) =>
      this.request<SendToResponse, ErrorResponse>({
        path: `/letters/sendto`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Letters
     * @name PrintDetail
     * @summary Письмо в формате PDF
     * @request GET:/letters/{id}/print
     */
    printDetail: (
      id: string,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<File, ErrorResponse>({
        path: `/letters/${id}/print`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Получение списка возможных адресатов в новом письме
     *
     * @tags Letters
     * @name IncomingList
     * @summary Список писем по получателю
     * @request GET:/letters/incoming
     */
    incomingList: (
      query: {
        clientId: number;
        senderId: string;
        position?: number;
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<LettersResponse, ErrorResponse>({
        path: `/letters/incoming`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  menuInfo = {
    /**
     * No description
     *
     * @tags News
     * @name ReadCreate
     * @summary Установить признак, что пользователь посетил раздел меню
     * @request POST:/menuInfo/read
     */
    readCreate: (body: MenuInfoRequest, params: RequestParams = {}) =>
      this.request<EmptyResponse, any>({
        path: `/menuInfo/read`,
        method: "POST",
        body: body,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags News
     * @name UnreadCreate
     * @summary Снять признак, что пользователь посетил раздел меню
     * @request POST:/menuInfo/unread
     */
    unreadCreate: (body: MenuInfoRequest, params: RequestParams = {}) =>
      this.request<EmptyResponse, any>({
        path: `/menuInfo/unread`,
        method: "POST",
        body: body,
        format: "json",
        ...params,
      }),
  };
  invoices = {
    /**
 * @description Список выставленных счетов
 * 
 * @tags Invoices
 * @name InvoicesList
 * @summary Список выставленных счетов

 * @request GET:/invoices
 */
    invoicesList: (
      query: {
        clientId: number;
        position?: number;
        size?: number;
        searchText?: string;
        stateList?: string[];
        direction?: string;
        beginDate?: string;
        endDate?: string;
        hasNewNotification?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<InvoicesInfoResponse, ErrorResponse>({
        path: `/invoices`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoices
     * @name InvoicesCreate
     * @summary Сохранить счет-фактуру, для выставления счёта
     * @request POST:/invoices
     */
    invoicesCreate: (body: InvoiceRequest, params: RequestParams = {}) =>
      this.request<InvoiceResponse, ErrorResponse | ValidationResponse>({
        path: `/invoices`,
        method: "POST",
        body: body,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение подробной информации о выставленном счете
 * 
 * @tags Invoices
 * @name InvoicesDetail
 * @summary Информация о выставленном счете

 * @request GET:/invoices/{id}
 */
    invoicesDetail: (
      id: string,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<InvoiceInfoResponse, ErrorResponse>({
        path: `/invoices/${id}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoices
     * @name InvoicesUpdate
     * @summary Обновление выставленного счёта
     * @request PUT:/invoices/{id}
     */
    invoicesUpdate: (
      id: string,
      body: InvoiceRequest,
      params: RequestParams = {}
    ) =>
      this.request<InvoiceResponse, ErrorResponse | ValidationResponse>({
        path: `/invoices/${id}`,
        method: "PUT",
        body: body,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoices
     * @name InvoicesDelete
     * @summary Удаление выставленного счёта
     * @request DELETE:/invoices/{id}
     */
    invoicesDelete: (
      id: string,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/invoices/${id}`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Получить колличество входящих счетов c активными уведомлениями
     *
     * @tags Invoices
     * @name NotificationCountList
     * @summary Получить колличество входящих счетов c активными уведомлениями
     * @request GET:/invoices/notification/count
     */
    notificationCountList: (
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<InvoicesIncomingDocumentWithNotification, ErrorResponse>({
        path: `/invoices/notification/count`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Отправить выставляемый счёт плательщику через ДБО
     *
     * @tags Invoices
     * @name SendCreate
     * @summary Отправить выставляемый счёт плательщику через ДБО
     * @request POST:/invoices/{id}/send
     */
    sendCreate: (
      id: string,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/invoices/${id}/send`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Отметить выставленный счёт как оплаченный
     *
     * @tags Invoices
     * @name PutInvoices
     * @summary Отметить выставленный счёт как оплаченный
     * @request PUT:/invoices/{id}/pay
     */
    putInvoices: (
      id: string,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/invoices/${id}/pay`,
        method: "PUT",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Удалить выставленный счёт из списка входящих
     *
     * @tags Invoices
     * @name HideUpdate
     * @summary Удалить выставленный счёт из списка входящих
     * @request PUT:/invoices/{id}/hide
     */
    hideUpdate: (
      id: string,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/invoices/${id}/hide`,
        method: "PUT",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Сформировать печатную форму документа по выставленному счёту
     *
     * @tags Invoices
     * @name PrintCreate
     * @summary Печатная форма документа по выставленному счёту
     * @request POST:/invoices/{id}/print
     */
    printCreate: (
      id: string,
      query: { clientId: number; withoutDocuments?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<File, ErrorResponse>({
        path: `/invoices/${id}/print`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Отправление сформированного документа выставленный счёт на email
     *
     * @tags Invoices
     * @name EmailCreate
     * @summary Отправить выставленный счёт на email
     * @request POST:/invoices/{id}/email
     */
    emailCreate: (
      id: string,
      query: { clientId: number; email: string; withDocuments?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/invoices/${id}/email`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Список отчетных документов по счету
 * 
 * @tags Invoices
 * @name DocumentsDetail
 * @summary Список документов по счету

 * @request GET:/invoices/{id}/documents
 */
    documentsDetail: (
      id: string,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<InvoiceDocuments, ErrorResponse>({
        path: `/invoices/${id}/documents`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Сохранить печатные формы отчетных документов по выставленному счёту
     *
     * @tags Invoices
     * @name DocumentsCreate
     * @summary Сохранить печатные формы отчетных документов по выставленному счёту
     * @request POST:/invoices/{id}/documents
     */
    documentsCreate: (
      id: string,
      query: { clientId: number },
      body: InvoiceDocumentsPrintRequest,
      params: RequestParams = {}
    ) =>
      this.request<InvoiceDocuments, ErrorResponse>({
        path: `/invoices/${id}/documents`,
        method: "POST",
        query: query,
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoices
     * @name DocumentsDelete
     * @summary Удаление документа по выставленному счёту
     * @request DELETE:/invoices/{id}/documents/{documentId}
     */
    documentsDelete: (
      id: string,
      documentId: string,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/invoices/${id}/documents/${documentId}`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение печатной формы отчетного документа по выставленному счету
 * 
 * @tags Invoices
 * @name DocumentsPrintDetail
 * @summary Печатная форма документа по выставленному счету

 * @request GET:/invoices/{id}/documents/{documentId}/print
 */
    documentsPrintDetail: (
      id: string,
      documentId: string,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<File, ErrorResponse>({
        path: `/invoices/${id}/documents/${documentId}/print`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Отправить печатную форму документа по выставленному счету на email
     *
     * @tags Invoices
     * @name DocumentsEmailCreate
     * @summary Отправить печатную форму документа по выставленному счету на email
     * @request POST:/invoices/{id}/documents/{documentId}/email
     */
    documentsEmailCreate: (
      id: string,
      documentId: string,
      query: { clientId: number; email: string },
      params: RequestParams = {}
    ) =>
      this.request<File, ErrorResponse>({
        path: `/invoices/${id}/documents/${documentId}/email`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Получение справочника плательщиков счета-фактуры
     *
     * @tags Invoices
     * @name PayersList
     * @summary Справочник плательщиков счета-фактуры
     * @request GET:/invoices/payers
     */
    payersList: (
      query: {
        clientId: number;
        position?: number;
        size?: number;
        searchText?: string;
        inn?: string;
        kpp?: string;
        agreementNumber?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<InvoicePayersResponse, ErrorResponse>({
        path: `/invoices/payers`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Список товаров/услуг счета
 * 
 * @tags Invoices
 * @name GoodsList
 * @summary Список товаров/услуг счета

 * @request GET:/invoices/goods
 */
    goodsList: (
      query: {
        clientId: number;
        position?: number;
        size?: number;
        searchText?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<InvoiceGoodsShort, ErrorResponse>({
        path: `/invoices/goods`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Список единиц измерения товаров/услуг счета
 * 
 * @tags Invoices
 * @name UnitsList
 * @summary Список единиц измерения товаров/услуг счета

 * @request GET:/invoices/units
 */
    unitsList: (
      query: { clientId: number; searchText?: string },
      params: RequestParams = {}
    ) =>
      this.request<InvoiceUnits, ErrorResponse>({
        path: `/invoices/units`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Получение очередного актуального номера для счета-фактуры
     *
     * @tags Invoices
     * @name NumberList
     * @summary Очередной номер для счета-фактуры
     * @request GET:/invoices/number
     */
    numberList: (query: { clientId: number }, params: RequestParams = {}) =>
      this.request<DocumentNumberResponse, ErrorResponse>({
        path: `/invoices/number`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  orders = {
    /**
 * @description Запросить из АБС дату начала действия нового тарифного плана
 * 
 * @tags Orders
 * @name TariffOrderChangeDateList
 * @summary Запросить из АБС дату начала действия нового тарифного плана

 * @request GET:/orders/tariff-order/change-date
 */
    tariffOrderChangeDateList: (
      query?: { changeDate?: string },
      params: RequestParams = {}
    ) =>
      this.request<string, ErrorResponse>({
        path: `/orders/tariff-order/change-date`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение списка заявок на подключение услуги «Проверка контрагентов»
 * 
 * @tags Orders
 * @name CorrespondentCheckOrderList
 * @summary Получение списка заявок на подключение услуги «Проверка контрагентов»

 * @request GET:/orders/correspondent-check-order
 */
    correspondentCheckOrderList: (
      query: { state: string; position?: number; size?: number },
      params: RequestParams = {}
    ) =>
      this.request<CorrespondentCheckOrders, ErrorResponse>({
        path: `/orders/correspondent-check-order`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Создание заявки на подключение/отключение услуги Проверка контрагентов
 * 
 * @tags Orders
 * @name CorrespondentCheckOrderCreate
 * @summary Создание заявки на подключение/отключение услуги Проверка контрагентов

 * @request POST:/orders/correspondent-check-order
 */
    correspondentCheckOrderCreate: (
      body: CorrespondentCheckOrderRequest,
      params: RequestParams = {}
    ) =>
      this.request<CorrespondentCheckOrder, ErrorResponse | ValidationResponse>(
        {
          path: `/orders/correspondent-check-order`,
          method: "POST",
          body: body,
          type: ContentType.Json,
          format: "json",
          ...params,
        }
      ),

    /**
 * @description Редактирование заявки на подключение/отключение услуги Проверка контрагентов
 * 
 * @tags Orders
 * @name CorrespondentCheckOrderUpdate
 * @summary Редактирование заявки на подключение/отключение услуги Проверка контрагентов

 * @request PUT:/orders/correspondent-check-order/{id}
 */
    correspondentCheckOrderUpdate: (
      id: string,
      body: CorrespondentCheckOrderUpdateRequest,
      params: RequestParams = {}
    ) =>
      this.request<CorrespondentCheckOrder, ErrorResponse | ValidationResponse>(
        {
          path: `/orders/correspondent-check-order/${id}`,
          method: "PUT",
          body: body,
          type: ContentType.Json,
          format: "json",
          ...params,
        }
      ),

    /**
 * @description Получение pdf-файла с примером отчета о проверке контрагента
 * 
 * @tags Orders
 * @name CorrespondentCheckOrderExampleList
 * @summary Получение pdf-файла с примером отчета о проверке контрагента

 * @request GET:/orders/correspondent-check-order/example
 */
    correspondentCheckOrderExampleList: (params: RequestParams = {}) =>
      this.request<File, ErrorResponse>({
        path: `/orders/correspondent-check-order/example`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Получение списка заявок на смену тарифного плана
 * 
 * @tags Orders
 * @name TariffOrderList
 * @summary Получение списка заявок на смену тарифного плана

 * @request GET:/orders/tariff-order
 */
    tariffOrderList: (
      query: {
        accountNumber?: string;
        state: string;
        position?: number;
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<TariffOrders, ErrorResponse>({
        path: `/orders/tariff-order`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Создание заявки на смену тарифного плана
 * 
 * @tags Orders
 * @name TariffOrderCreate
 * @summary Создание заявки на смену тарифного плана

 * @request POST:/orders/tariff-order
 */
    tariffOrderCreate: (body: TariffOrderRequest, params: RequestParams = {}) =>
      this.request<TariffOrder, ErrorResponse | ValidationResponse>({
        path: `/orders/tariff-order`,
        method: "POST",
        body: body,
        format: "json",
        ...params,
      }),

    /**
     * @description Создание и попытка отправки заявки на смену тарифного плана
     *
     * @tags Orders
     * @name TariffOrderPayCreate
     * @summary Создание и попытка отправки заявки на смену тарифного плана
     * @request POST:/orders/tariff-order/pay
     */
    tariffOrderPayCreate: (
      body: TariffOrderRequest,
      query?: { id?: string },
      params: RequestParams = {}
    ) =>
      this.request<TariffOrder, ErrorResponse | ValidationResponse>({
        path: `/orders/tariff-order/pay`,
        method: "POST",
        query: query,
        body: body,
        format: "json",
        ...params,
      }),

    /**
 * @description Редактирование заявки на смену тарифного плана
 * 
 * @tags Orders
 * @name TariffOrderUpdate
 * @summary Редактирование заявки на смену тарифного плана

 * @request PUT:/orders/tariff-order/{id}
 */
    tariffOrderUpdate: (
      id: string,
      body: TariffOrderRequest,
      params: RequestParams = {}
    ) =>
      this.request<TariffOrder, ErrorResponse | ValidationResponse>({
        path: `/orders/tariff-order/${id}`,
        method: "PUT",
        body: body,
        format: "json",
        ...params,
      }),

    /**
 * @description Удаление заявки на смену тарифного плана
 * 
 * @tags Orders
 * @name TariffOrderDelete
 * @summary Удаление заявки на смену тарифного плана

 * @request DELETE:/orders/tariff-order/{id}
 */
    tariffOrderDelete: (
      id: string,
      query?: { resetSign?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/orders/tariff-order/${id}`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение списка заявок на запрос справок
 * 
 * @tags Orders
 * @name ReferenceList
 * @summary Получение списка заявок на запрос справок

 * @request GET:/orders/reference
 */
    referenceList: (
      query: { state: string; position?: number; size?: number },
      params: RequestParams = {}
    ) =>
      this.request<BankStatementOrders, ErrorResponse>({
        path: `/orders/reference`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Создание заявки на запрос справки
     *
     * @tags Orders
     * @name ReferenceCreate
     * @summary Создание заявки на запрос справки
     * @request POST:/orders/reference
     */
    referenceCreate: (
      body: ReferenceOrderRequest,
      params: RequestParams = {}
    ) =>
      this.request<DocumentSaveResponse, ErrorResponse | ValidationResponse>({
        path: `/orders/reference`,
        method: "POST",
        body: body,
        format: "json",
        ...params,
      }),

    /**
     * @description Редактирование заявки на запрос справки
     *
     * @tags Orders
     * @name ReferenceUpdate
     * @summary Редактирование заявки на запрос справки
     * @request PUT:/orders/reference/{id}
     */
    referenceUpdate: (
      id: string,
      body: ReferenceOrderRequest,
      params: RequestParams = {}
    ) =>
      this.request<DocumentSaveResponse, ErrorResponse | ValidationResponse>({
        path: `/orders/reference/${id}`,
        method: "PUT",
        body: body,
        format: "json",
        ...params,
      }),

    /**
     * @description Удаление документа заявки на запрос справки
     *
     * @tags Orders
     * @name ReferenceDelete
     * @summary Удаление документа заявки на запрос справки
     * @request DELETE:/orders/reference/{id}
     */
    referenceDelete: (id: string, params: RequestParams = {}) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/orders/reference/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * @description Получение заявки на запрос справки по идентификатору
     *
     * @tags Orders
     * @name ReferenceDetail
     * @summary Получение заявки на запрос справки по идентификатору
     * @request GET:/orders/reference/{id}
     */
    referenceDetail: (id: string, params: RequestParams = {}) =>
      this.request<BankStatementOrder, ErrorResponse>({
        path: `/orders/reference/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Создание заявки на запрос справки заявки на запрос справки
     *
     * @tags Orders
     * @name ReferencePayCreate
     * @summary Создание заявки на запрос справки и сразу попытаться её отправить
     * @request POST:/orders/reference/pay
     */
    referencePayCreate: (
      body: ReferenceOrderRequest,
      query?: { id?: string },
      params: RequestParams = {}
    ) =>
      this.request<DocumentSaveResponse, ErrorResponse | ValidationResponse>({
        path: `/orders/reference/pay`,
        method: "POST",
        query: query,
        body: body,
        format: "json",
        ...params,
      }),

    /**
     * @description Подписание заявки с помощью PayControl
     *
     * @tags Orders
     * @name SignCreate
     * @summary Подписание заявки с помощью PayControl
     * @request POST:/orders/sign
     */
    signCreate: (
      query: { id: string },
      body: OrderSignRequest,
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/orders/sign`,
        method: "POST",
        query: query,
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Подписание заявки с помощью PayControl 5.3
 * 
 * @tags Orders
 * @name Pc53SignCreate
 * @summary Подписание заявки с помощью PayControl 5.3

 * @request POST:/orders/{id}/pc53-sign
 */
    pc53SignCreate: (
      id: string,
      body: OrderPC53SignRequest,
      params: RequestParams = {}
    ) =>
      this.request<OrderPC53SignResponse, ErrorResponse>({
        path: `/orders/${id}/pc53-sign`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Получение списка доп. офисов филиала клиента
     *
     * @tags Orders
     * @name BranchesList
     * @summary Список доп. офисов филиала клиента
     * @request GET:/orders/branches
     */
    branchesList: (params: RequestParams = {}) =>
      this.request<BranchesResponse, ErrorResponse>({
        path: `/orders/branches`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  currencyExchange = {
    /**
 * @description Получение полного списка счетов клиента для оформления заявок
 * 
 * @tags Orders
 * @name AccountsList
 * @summary Список счетов клиента для оформления заявок

 * @request GET:/currency-exchange/accounts
 */
    accountsList: (query: { clientId: number }, params: RequestParams = {}) =>
      this.request<AccountExchange[], ErrorResponse>({
        path: `/currency-exchange/accounts`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Создание заявки на покупку/продажу/конверсию валюты
 * 
 * @tags Orders
 * @name CurrencyOrderCreate
 * @summary Создание заявки на покупку/продажу/конверсию валюты

 * @request POST:/currency-exchange/currency-order
 */
    currencyOrderCreate: (
      body: CurrencyOrderRequest,
      params: RequestParams = {}
    ) =>
      this.request<DocumentSaveResponse, ErrorResponse | ValidationResponse>({
        path: `/currency-exchange/currency-order`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение PDF на валюту
 * 
 * @tags Orders
 * @name CurrencyPdfList
 * @summary PDF на действия с валютой

 * @request GET:/currency-exchange/currency-pdf
 */
    currencyPdfList: (
      query: { id: number; clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<string, ErrorResponse>({
        path: `/currency-exchange/currency-pdf`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение детальной информации по обмену валюты
 * 
 * @tags Orders
 * @name DetailsList
 * @summary Детальная информация

 * @request GET:/currency-exchange/details
 */
    detailsList: (
      query: { id: number; clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<OrderDetails, ErrorResponse>({
        path: `/currency-exchange/details`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение списка курсов валют
 * 
 * @tags Orders
 * @name ExchangeRatesMainPageList
 * @summary Список курсов валют

 * @request GET:/currency-exchange/exchange-rates-main-page
 */
    exchangeRatesMainPageList: (params: RequestParams = {}) =>
      this.request<CurrencyRateResponse, ErrorResponse>({
        path: `/currency-exchange/exchange-rates-main-page`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Получение списка курсов валют
 * 
 * @tags Orders
 * @name ExchangeRatesExchangePageList
 * @summary Список курсов валют

 * @request GET:/currency-exchange/exchange-rates-exchange-page
 */
    exchangeRatesExchangePageList: (
      query: { creditCurrencyId: string; debitCurrencyId: string },
      params: RequestParams = {}
    ) =>
      this.request<ExchangeRatesResponse, ErrorResponse>({
        path: `/currency-exchange/exchange-rates-exchange-page`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение списка курсов валют
 * 
 * @tags Orders
 * @name IndividualExchangeRateCreate
 * @summary Список курсов валют

 * @request POST:/currency-exchange/individual-exchange-rate
 */
    individualExchangeRateCreate: (
      body: CurrencyOrderRateRequest,
      params: RequestParams = {}
    ) =>
      this.request<CurrencyOrderRateResponse, ErrorResponse>({
        path: `/currency-exchange/individual-exchange-rate`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Подписание заявки на обмен валюты
 * 
 * @tags Orders
 * @name SendCreate
 * @summary Подписание заявки на обмен валюты

 * @request POST:/currency-exchange/send
 */
    sendCreate: (
      query: { id: string },
      body: CurrencyOrderRequest,
      params: RequestParams = {}
    ) =>
      this.request<DocumentSaveResponse, ErrorResponse | ValidationResponse>({
        path: `/currency-exchange/send`,
        method: "POST",
        query: query,
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Отправка в банк заявки на обмен валюты
 * 
 * @tags Orders
 * @name SendToBankCreate
 * @summary Отправка в банк заявки на обмен валюты

 * @request POST:/currency-exchange/send-to-bank/{id}
 */
    sendToBankCreate: (id: number, params: RequestParams = {}) =>
      this.request<EmptyResponse, ErrorResponse | ValidationResponse>({
        path: `/currency-exchange/send-to-bank/${id}`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
 * @description Получения заявок по обмену валюты
 * 
 * @tags Orders
 * @name CurrencyExchangeList
 * @summary Получения заявок по обмену валюты

 * @request GET:/currency-exchange
 */
    currencyExchangeList: (
      query?: {
        position?: number;
        size?: number;
        beginDate?: string;
        endDate?: string;
        statusList?: string[];
        type?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<DocumentListResponse, ErrorResponse>({
        path: `/currency-exchange`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  ved = {
    /**
     * No description
     *
     * @tags Ved
     * @name PaymentsCreate
     * @summary Сохранение данных валютного платежа
     * @request POST:/ved/payments
     */
    paymentsCreate: (
      body: VedPaymentRequest,
      query?: { draft?: boolean; ignoreWarnings?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<VedDocumentSaveResponse, ErrorResponse | ValidationResponse>(
        {
          path: `/ved/payments`,
          method: "POST",
          query: query,
          body: body,
          format: "json",
          ...params,
        }
      ),

    /**
     * No description
     *
     * @tags Ved
     * @name PaymentsList
     * @summary Получение данных валютного платежа
     * @request GET:/ved/payments
     */
    paymentsList: (
      query: { clientId: number; position?: number; size?: number },
      params: RequestParams = {}
    ) =>
      this.request<VedPaymentResponse, ErrorResponse>({
        path: `/ved/payments`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Удаление валютного платежа
 * 
 * @tags Ved
 * @name PaymentsDelete
 * @summary Удаление валютного платежа

 * @request DELETE:/ved/payments
 */
    paymentsDelete: (
      query: { extId: number; clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/ved/payments`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение подробной информации о валютном платеже
 * 
 * @tags Ved
 * @name PaymentsDetail
 * @summary Информация о валютном платеже

 * @request GET:/ved/payments/{id}
 */
    paymentsDetail: (id: number, params: RequestParams = {}) =>
      this.request<VedPaymentInfoResponse, ErrorResponse>({
        path: `/ved/payments/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Изменение данных о валютном платеже
 * 
 * @tags Ved
 * @name PaymentsUpdate
 * @summary Изменение данных о валютном платеже

 * @request PUT:/ved/payments/{id}
 */
    paymentsUpdate: (
      id: number,
      body: VedPaymentRequest,
      query?: { draft?: boolean; ignoreWarnings?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<VedDocumentSaveResponse, ErrorResponse>({
        path: `/ved/payments/${id}`,
        method: "PUT",
        query: query,
        body: body,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение печатной формы валютного платежа
 * 
 * @tags Ved
 * @name PaymentsPrintDetail
 * @summary Получение печатной формы валютного платежа

 * @request GET:/ved/payments/{id}/print
 */
    paymentsPrintDetail: (id: number, params: RequestParams = {}) =>
      this.request<File, ErrorResponse>({
        path: `/ved/payments/${id}/print`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Получение списка стран
     *
     * @tags Ved
     * @name CountriesList
     * @summary Список стран
     * @request GET:/ved/countries
     */
    countriesList: (
      query?: { searchText?: string },
      params: RequestParams = {}
    ) =>
      this.request<VedCountriesResponse, ErrorResponse>({
        path: `/ved/countries`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Список зачислений.
 * 
 * @tags Ved
 * @name EnrollmentList
 * @summary Список зачислений.

 * @request GET:/ved/enrollment
 */
    enrollmentList: (
      query: {
        clientId: number;
        rubles?: boolean;
        trAcc?: string;
        sum?: number;
        curCode?: string;
        documentDateFrom?: string;
        documentDateTo?: string;
        state?: string;
        position: number;
        size: number;
        sort: string;
        searchText?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<VedEnrollmentResponse, ErrorResponse>({
        path: `/ved/enrollment`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Досыл, сохранение.
 * 
 * @tags VedAddFiles
 * @name AddFilesCreate
 * @summary Досыл, сохранение.

 * @request POST:/ved/addFiles
 */
    addFilesCreate: (
      query: { comment?: string; documentRef: number },
      attachments: AttachmentRequest[],
      params: RequestParams = {}
    ) =>
      this.request<number, ErrorResponse | ValidationResponse>({
        path: `/ved/addFiles`,
        method: "POST",
        query: query,
        body: attachments,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Досыл, получение.
 * 
 * @tags VedAddFiles
 * @name AddFilesList
 * @summary Досыл, получение.

 * @request GET:/ved/addFiles
 */
    addFilesList: (
      query?: { clientId?: number; documentRef?: number },
      params: RequestParams = {}
    ) =>
      this.request<AddFileSendingResponse[], ErrorResponse>({
        path: `/ved/addFiles`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Досыл, удаление.
 * 
 * @tags VedAddFiles
 * @name AddFilesDelete
 * @summary Досыл, удаление.

 * @request DELETE:/ved/addFiles
 */
    addFilesDelete: (query?: { id?: number }, params: RequestParams = {}) =>
      this.request<EmptyResponse[], ErrorResponse>({
        path: `/ved/addFiles`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Бенефициар. Выбор из списка.
 * 
 * @tags Ved
 * @name BeneficiariesList
 * @summary Бенефициар. Выбор из списка.

 * @request GET:/ved/beneficiaries
 */
    beneficiariesList: (
      query: {
        clientId: number;
        searchText?: string;
        position?: number;
        size?: number;
        sortByDateCreate?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<VedBeneficiaryResponse, ErrorResponse>({
        path: `/ved/beneficiaries`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Бенефициар. Сохранение.
 * 
 * @tags Ved
 * @name BeneficiariesCreate
 * @summary Бенефициар. Сохранение.

 * @request POST:/ved/beneficiaries
 */
    beneficiariesCreate: (
      body: BeneficiarySaveRequest,
      params: RequestParams = {}
    ) =>
      this.request<BeneficiarySaveResponse, ErrorResponse>({
        path: `/ved/beneficiaries`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Информация о бенефициаре.
 * 
 * @tags Ved
 * @name BeneficiariesDetail
 * @summary Информация о бенефициаре.

 * @request GET:/ved/beneficiaries/{id}
 */
    beneficiariesDetail: (id: number, params: RequestParams = {}) =>
      this.request<VedBeneficiaryResponseFull, ErrorResponse>({
        path: `/ved/beneficiaries/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Удаление
 * 
 * @tags Ved
 * @name BeneficiariesDelete
 * @summary Удаление бенефициара

 * @request DELETE:/ved/beneficiaries/{id}
 */
    beneficiariesDelete: (id: number, params: RequestParams = {}) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/ved/beneficiaries/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
 * @description Информация от транзитном счете
 * 
 * @tags Ved
 * @name TransitAccountList
 * @summary Информация от транзитном счете

 * @request GET:/ved/transitAccount
 */
    transitAccountList: (
      query: { clientId: number; position?: number; size?: number },
      params: RequestParams = {}
    ) =>
      this.request<TransitAccountResponse, ErrorResponse>({
        path: `/ved/transitAccount`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Активные валютные операции
 * 
 * @tags Ved
 * @name OperCodesList
 * @summary Активные валютные операции

 * @request GET:/ved/oper-codes
 */
    operCodesList: (
      query?: { searchText?: string },
      params: RequestParams = {}
    ) =>
      this.request<VedOperCodesResponse[], ErrorResponse>({
        path: `/ved/oper-codes`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ved
     * @name EnrolmentPrintDetail
     * @summary Уведомления о зачислении на транзитный валютный счет в формате PDF
     * @request GET:/ved/enrolment/{id}/print
     */
    enrolmentPrintDetail: (id: number, params: RequestParams = {}) =>
      this.request<File, ErrorResponse>({
        path: `/ved/enrolment/${id}/print`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Получение списка валют без 810 RUR
 * 
 * @tags Ved
 * @name CurrencyList
 * @summary Список валют из справочника

 * @request GET:/ved/currency
 */
    currencyList: (params: RequestParams = {}) =>
      this.request<Currency[], ErrorResponse>({
        path: `/ved/currency`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  docObSale = {
    /**
 * @description Сохранение распоряжения по транзитному счету
 * 
 * @tags DocObSale
 * @name DocObSaleCreate
 * @summary Сохранение распоряжения по транзитному счету

 * @request POST:/doc-ob-sale
 */
    docObSaleCreate: (
      query: { isDraft: boolean; ignoreWarnings?: boolean; clientId: number },
      body: DocObSaleCurrReq,
      params: RequestParams = {}
    ) =>
      this.request<DocObSaleCurrResponse, ErrorResponse>({
        path: `/doc-ob-sale`,
        method: "POST",
        query: query,
        body: body,
        format: "json",
        ...params,
      }),

    /**
 * @description Редактирование распоряжения по транзитному счету
 * 
 * @tags DocObSale
 * @name DocObSaleUpdate
 * @summary Редактирование распоряжения по транзитному счету

 * @request PUT:/doc-ob-sale
 */
    docObSaleUpdate: (
      query: {
        isDraft: boolean;
        ignoreWarnings?: boolean;
        clientId: number;
        documentId: number;
      },
      body: DocObSaleCurrReq,
      params: RequestParams = {}
    ) =>
      this.request<DocObSaleCurrResponse, ErrorResponse>({
        path: `/doc-ob-sale`,
        method: "PUT",
        query: query,
        body: body,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение распоряжения по транзитному счету
 * 
 * @tags DocObSale
 * @name DocObSaleList
 * @summary Получение распоряжения по транзитному счету

 * @request GET:/doc-ob-sale
 */
    docObSaleList: (
      query: { documentId: number },
      params: RequestParams = {}
    ) =>
      this.request<DocObSaleCurrResponse, ErrorResponse>({
        path: `/doc-ob-sale`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Удаление распоряжения по транзитному счету
 * 
 * @tags DocObSale
 * @name DocObSaleDelete
 * @summary Удаление распоряжения по транзитному счету

 * @request DELETE:/doc-ob-sale
 */
    docObSaleDelete: (
      query: { documentId: number },
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/doc-ob-sale`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DocObSale
     * @name PrintList
     * @summary РПТС в формате PDF
     * @request GET:/doc-ob-sale/print
     */
    printList: (query: { documentId: number }, params: RequestParams = {}) =>
      this.request<File, ErrorResponse>({
        path: `/doc-ob-sale/print`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  dealing = {
    /**
 * @description Получение ссылки для перехода в Дилинг 2.0
 * 
 * @tags Dealing
 * @name LinkList
 * @summary Получение ссылки для перехода в Дилинг 2.0

 * @request GET:/dealing/link
 */
    linkList: (params: RequestParams = {}) =>
      this.request<DealingUrlResponse, ErrorResponse>({
        path: `/dealing/link`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  journalize = {
    /**
 * @description Журнализация клиентских сообщений
 * 
 * @tags Journalize
 * @name MessageCreate
 * @summary Журнализация клиентских сообщений

 * @request POST:/journalize/message
 */
    messageCreate: (
      body: JournalizeMessageRequest,
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/journalize/message`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  ivo = {
    /**
 * @description Получение списка ИВО клиента
 * 
 * @tags IVO
 * @name GetIvo
 * @summary Получение списка ИВО клиента

 * @request GET:/ivo
 */
    getIvo: (
      query: {
        clientId: number;
        position?: number;
        size?: number;
        beginDate?: string;
        endDate?: string;
        statusList?: string[];
        codeOperationList?: string[];
        dealNumberList?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<IvoDocumentResponse, ErrorResponse>({
        path: `/ivo`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags IVO
     * @name PostIvo
     * @summary Сохранение ИВО клиента
     * @request POST:/ivo
     */
    postIvo: (
      query: { isDraft: boolean; ignoreWarning: boolean },
      body: IvoDocumentSaveRequest,
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse | ValidationResponse>({
        path: `/ivo`,
        method: "POST",
        query: query,
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение детальной информации по одной ИВО клиента
 * 
 * @tags IVO
 * @name GetIvo2
 * @summary Получение детальной информации по одной ИВО клиента

 * @request GET:/ivo/{id}
 * @originalName getIvo
 * @duplicate
 */
    getIvo2: (id: string, params: RequestParams = {}) =>
      this.request<IvoDocumentResponse, ErrorResponse>({
        path: `/ivo/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Рест для редактирования документа ИВО
 * 
 * @tags IVO
 * @name PutIvo
 * @summary Редактирование ИВО

 * @request PUT:/ivo/{id}
 */
    putIvo: (
      id: string,
      query: { isDraft: boolean; ignoreWarning: boolean },
      body: IvoDocumentUpdateRequest,
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse | ValidationResponse>({
        path: `/ivo/${id}`,
        method: "PUT",
        query: query,
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение первичных данных для создания ИВО
 * 
 * @tags IVO
 * @name PrimaryDataList
 * @summary Получение первичных данных для создания ИВО

 * @request GET:/ivo/primary-data
 */
    primaryDataList: (params: RequestParams = {}) =>
      this.request<IvoPrimaryDataResponse, ErrorResponse>({
        path: `/ivo/primary-data`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Получение операций по счету клиента
 * 
 * @tags IVO
 * @name OperationsList
 * @summary Получение операций по счету клиента

 * @request GET:/ivo/operations
 */
    operationsList: (
      query: { numberAccount: string },
      params: RequestParams = {}
    ) =>
      this.request<IvoOperationInfoResponse[], ErrorResponse>({
        path: `/ivo/operations`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение файлов вложений прикрепленных к ИВО
 * 
 * @tags IVO
 * @name AttachmentDetail
 * @summary Рест получения вложений

 * @request GET:/ivo/{operationId}/attachment/{id}
 */
    attachmentDetail: (
      operationId: string,
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<AttachmentResponse, ErrorResponse>({
        path: `/ivo/${operationId}/attachment/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Получение информации по операции для ИВО
 * 
 * @tags IVO
 * @name OperationDetail
 * @summary Операция для ИВО

 * @request GET:/ivo/operation/{id}/{type}
 */
    operationDetail: (id: string, type: string, params: RequestParams = {}) =>
      this.request<IvoOperationInfoResponse, ErrorResponse>({
        path: `/ivo/operation/${id}/${type}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Получение печатной формы иво в формате PDF
 * 
 * @tags IVO
 * @name PrintformDetail
 * @summary Печать иво

 * @request GET:/ivo/{id}/printform
 */
    printformDetail: (
      id: number,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<string, ErrorResponse>({
        path: `/ivo/${id}/printform`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение списка счетов клиента
 * 
 * @tags IVO
 * @name AccountsList
 * @summary Список счетов клиента

 * @request GET:/ivo/accounts
 */
    accountsList: (query: { clientId: number }, params: RequestParams = {}) =>
      this.request<AccountInfo[], ErrorResponse>({
        path: `/ivo/accounts`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение списка стран кроме 643-РФ
 * 
 * @tags IVO
 * @name CountryList
 * @summary Список стран

 * @request GET:/ivo/country
 */
    countryList: (params: RequestParams = {}) =>
      this.request<CountryResponse, ErrorResponse>({
        path: `/ivo/country`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  spd = {
    /**
 * @description Получение первоначальных данных для СПД
 * 
 * @tags SPD
 * @name PrimaryDataList
 * @summary Получение первоначальных данных для СПД

 * @request GET:/spd/primary-data
 */
    primaryDataList: (params: RequestParams = {}) =>
      this.request<SpdPrimaryDataResponse, ErrorResponse>({
        path: `/spd/primary-data`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Рест для получения СПД
 * 
 * @tags SPD
 * @name GetSpd
 * @summary Получение СПД

 * @request GET:/spd
 */
    getSpd: (
      query: {
        clientId: number;
        position?: number;
        size?: number;
        beginDate?: string;
        endDate?: string;
        statusList?: string[];
        contractList?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<SpdDocumentResponse, ErrorResponse>({
        path: `/spd`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Сохранение СПД
 * 
 * @tags SPD
 * @name PostSpd
 * @summary Сохранение СПД

 * @request POST:/spd
 */
    postSpd: (
      query: { isDraft: boolean; ignoreWarning: boolean },
      body: SpdDocumentSaveRequest,
      params: RequestParams = {}
    ) =>
      this.request<SpdIdResponse, ErrorResponse | ValidationResponse>({
        path: `/spd`,
        method: "POST",
        query: query,
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Редактирование СПД
 * 
 * @tags SPD
 * @name PutSpd
 * @summary Редактирование СПД

 * @request PUT:/spd/{id}
 */
    putSpd: (
      id: number,
      query: { isDraft: boolean; ignoreWarning: boolean },
      body: SpdDocumentUpdateRequest,
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse | ValidationResponse>({
        path: `/spd/${id}`,
        method: "PUT",
        query: query,
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение детальной информации СПД
 * 
 * @tags SPD
 * @name GetSpd2
 * @summary Получение детальной информации СПД

 * @request GET:/spd/{id}
 * @originalName getSpd
 * @duplicate
 */
    getSpd2: (id: string, params: RequestParams = {}) =>
      this.request<SpdDocumentResponse, ErrorResponse>({
        path: `/spd/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Получение файлов вложений прикрепленных к СПД
 * 
 * @tags SPD
 * @name AttachmentDetail
 * @summary Рест для скачивания вложений

 * @request GET:/spd/{documentId}/attachment/{id}
 */
    attachmentDetail: (
      documentId: string,
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<AttachmentResponse, ErrorResponse>({
        path: `/spd/${documentId}/attachment/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Получение печатной формы СПД в формате PDF
 * 
 * @tags SPD
 * @name PrintformDetail
 * @summary Печатная форма СПД

 * @request GET:/spd/{id}/printform
 */
    printformDetail: (id: number, params: RequestParams = {}) =>
      this.request<string, ErrorResponse>({
        path: `/spd/${id}/printform`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  currency = {
    /**
 * @description Получение Сведений о постановке контракта на учет
 * 
 * @tags Contract-reg
 * @name ContractRegList
 * @summary Получение Сведений о постановке контракта на учет

 * @request GET:/currency/contract-reg
 */
    contractRegList: (
      query: {
        dboClientId: number;
        position?: number;
        count?: number;
        beginDate?: string;
        endDate?: string;
        state?: string[];
        nonresName?: string;
        contractNumber?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ContractRegResponse, ErrorResponse>({
        path: `/currency/contract-reg`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Создание сведений о постановке контракта на учет
 * 
 * @tags Contract-reg
 * @name ContractRegCreate
 * @summary Создание сведений о постановке контракта на учет

 * @request POST:/currency/contract-reg
 */
    contractRegCreate: (
      body: ContractRegCreateRequest,
      query?: { isDraft?: boolean; skipWarnings?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<
        ContractRegSuccessResponse,
        ErrorResponse | ValidationResponse
      >({
        path: `/currency/contract-reg`,
        method: "POST",
        query: query,
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Получение детальной информации по документу Сведения о постановке на учет
 * 
 * @tags Contract-reg
 * @name ContractRegDetail
 * @summary Детальная информация

 * @request GET:/currency/contract-reg/{documentId}
 */
    contractRegDetail: (
      documentId: number,
      query: { dboClientId: number },
      params: RequestParams = {}
    ) =>
      this.request<ContractRegInfoResponse, ErrorResponse>({
        path: `/currency/contract-reg/${documentId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Редактирование сведений о постановке контракта на учет
 * 
 * @tags Contract_reg
 * @name ContractRegUpdate
 * @summary Редактирование сведений о постановке контракта на учет

 * @request PUT:/currency/contract-reg/{documentId}
 */
    contractRegUpdate: (
      documentId: number,
      body: ContractRegUpdateRequest,
      query?: { isDraft?: boolean; skipWarnings?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<
        ContractRegSuccessResponse,
        ErrorResponse | ValidationResponse
      >({
        path: `/currency/contract-reg/${documentId}`,
        method: "PUT",
        query: query,
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Удаление сведений о постановке контракта на учет
 * 
 * @tags Contract-reg
 * @name ContractRegDelete
 * @summary Удаление сведений о постановке контракта на учет

 * @request DELETE:/currency/contract-reg/{documentId}
 */
    contractRegDelete: (
      documentId: number,
      query: { dboClientId: number },
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/currency/contract-reg/${documentId}`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Печать сведений о постановке контракта на учет
 * 
 * @tags Contract-reg
 * @name ContractRegPrintDetail
 * @summary Печать сведений о постановке контракта на учет

 * @request GET:/currency/contract-reg/{documentId}/print
 */
    contractRegPrintDetail: (
      documentId: number,
      query: { dboClientId: number },
      params: RequestParams = {}
    ) =>
      this.request<File, ErrorResponse>({
        path: `/currency/contract-reg/${documentId}/print`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Рест получения списка документов ЗоВИ
 * 
 * @tags ChangeContract
 * @name ContractChangeList
 * @summary Рест получения списка документов ЗоВИ

 * @request GET:/currency/contract-change
 */
    contractChangeList: (
      query: {
        dboClientId: number;
        position?: number;
        count?: number;
        beginDate?: string;
        endDate?: string;
        state?: string[];
        fromContract?: string;
        fromReason?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ChangeContractResponse, ErrorResponse>({
        path: `/currency/contract-change`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Создание ЗоВИ
 * 
 * @tags ChangeContract
 * @name ContractChangeCreate
 * @summary Создание ЗоВИ

 * @request POST:/currency/contract-change
 */
    contractChangeCreate: (
      body: ChangeContractRequest,
      query?: { isDraft?: boolean; skipWarnings?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<
        ChangeContractCreateResponse,
        ErrorResponse | ValidationResponse
      >({
        path: `/currency/contract-change`,
        method: "POST",
        query: query,
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Редактирование ЗоВИ
 * 
 * @tags ChangeContract
 * @name ContractChangeUpdate
 * @summary Редактирование ЗоВИ

 * @request PUT:/currency/contract-change/{documentId}
 */
    contractChangeUpdate: (
      documentId: number,
      body: ChangeContractUpdateRequest,
      query?: { isDraft?: boolean; skipWarnings?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse | ValidationResponse>({
        path: `/currency/contract-change/${documentId}`,
        method: "PUT",
        query: query,
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Рест удаления ЗоВИ
 * 
 * @tags ChangeContract
 * @name ContractChangeDelete
 * @summary Рест удаления ЗоВИ

 * @request DELETE:/currency/contract-change/{documentId}
 */
    contractChangeDelete: (
      documentId: number,
      query: { dboClientId: number },
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorResponse>({
        path: `/currency/contract-change/${documentId}`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description Получает из НДБО детальную информацию по документу Заявление о внесении изменений в раздел I ведомости банковского контроля по договору/кредитному договору
 * 
 * @tags ChangeContract
 * @name ContractChangeDetail
 * @summary Детальная информация ЗОВИ

 * @request GET:/currency/contract-change/{documentId}
 */
    contractChangeDetail: (
      documentId: number,
      query: { dboClientId: number },
      params: RequestParams = {}
    ) =>
      this.request<ChangeDocumentContractInfoResponse, ErrorResponse>({
        path: `/currency/contract-change/${documentId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * No description
 * 
 * @tags ChangeContract
 * @name ContractChangePrintDetail
 * @summary Рест получения печатной формы ЗоВИ.

 * @request GET:/currency/contract-change/{documentId}/print
 */
    contractChangePrintDetail: (
      documentId: number,
      query?: { dboClientId?: number },
      params: RequestParams = {}
    ) =>
      this.request<File, ErrorResponse>({
        path: `/currency/contract-change/${documentId}/print`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  certificate = {
    /**
 * @description Добавление сертификата УКЭП
 * 
 * @tags Certificates
 * @name CertificateCreate
 * @summary Добавление сертификата УКЭП

 * @request POST:/certificate
 */
    certificateCreate: (
      body: CertQualifiedRequest,
      params: RequestParams = {}
    ) =>
      this.request<CertQualifiedResponse, ErrorResponse>({
        path: `/certificate`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Проверка на наличие у пользователя клиента сертификата УКЭП
 * 
 * @tags Certificates
 * @name CheckActiveQualifiedExistDetail
 * @summary Проверка на наличие у пользователя клиента сертификата УКЭП

 * @request GET:/certificate/{clientId}/check-active-qualified-exist
 */
    checkActiveQualifiedExistDetail: (
      clientId: number,
      params: RequestParams = {}
    ) =>
      this.request<boolean, ErrorResponse>({
        path: `/certificate/${clientId}/check-active-qualified-exist`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
